
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * CORE APPLICATION CONTROLLER (LOCAL PWA)
 * ============================================================================
 * Adapted for IndexedDB Local Storage usage.
 */ // auth.js
/**
 * @fileoverview Authentication Layer (Local PWA Version)
 * ------------------------------------------------------------------
 * This replaces the Supabase Auth client.
 * It uses sessionStorage to simulate a "logged in" state during the
 * browser session, without sending credentials to any server.
 */ // Mock Supabase client object
// This ensures that if any legacy code tries to import 'sb', it won't crash.
const $e7ff1b009dd6583c$export$f92973b23adda3f5 = {
    auth: {
        onAuthStateChange: ()=>({
                data: {
                    subscription: {
                        unsubscribe: ()=>{}
                    }
                }
            }),
        getSession: async ()=>({
                data: {
                    session: {
                        user: {
                            id: 'local-owner'
                        }
                    }
                }
            }),
        signOut: async ()=>({
                error: null
            })
    }
};
function $e7ff1b009dd6583c$export$6d3c879d7a79980d(onLogin, onLogout) {
    const loginBtn = document.getElementById('login-btn');
    // 1. Auto-Login Check
    // If the user has previously "logged in" this session, or if we want 
    // to default to logged-in for the PWA (since it's a personal device app).
    if (sessionStorage.getItem('inaiya_session')) {
        onLogin({
            user: {
                id: 'local-owner'
            }
        });
        return;
    }
    // 2. Handle Login Button Click
    if (loginBtn) loginBtn.onclick = ()=>{
        // Add a fake loading delay for better UX
        loginBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Opening...';
        loginBtn.disabled = true;
        setTimeout(()=>{
            sessionStorage.setItem('inaiya_session', 'true');
            onLogin({
                user: {
                    id: 'local-owner'
                }
            });
        }, 800);
    };
}
async function $e7ff1b009dd6583c$export$a0973bcfe11b05c9() {
    sessionStorage.removeItem('inaiya_session');
    sessionStorage.removeItem('isAppAuthenticated'); // Clear PIN state if used
    window.location.reload();
}
async function $e7ff1b009dd6583c$export$19ff617ede568ce2(email) {
    console.warn("Magic Link is not available in Local Mode.");
    return {
        error: null
    };
}


// data.js
/**
 * DATA LAYER (INDEXEDDB VERSION - PRODUCTION READY)
 * ------------------------------------------------------------------
 * Handles state management, data persistence, and memory cleanup.
 */ // Placeholder Asset imports
// utils.js
/**
 * @fileoverview Utilities & Helpers
 * Pure functions for data manipulation, security, and validation.
 * Contains no side effects or application state.
 */ var $d349326c2b62c55f$exports = {};
/*! @license DOMPurify 3.3.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.0/LICENSE */ (function(global, factory) {
    $d349326c2b62c55f$exports = factory();
})($d349326c2b62c55f$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.3.0';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (cfg.ADD_ATTR) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title|textarea)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


function $9423fef94170f602$export$6969335ea1e4e77c(target, source) {
    if (!source) return target;
    const isObject = (item)=>item && typeof item === 'object' && !Array.isArray(item);
    if (isObject(target) && isObject(source)) {
        for(const key in source)if (isObject(source[key])) {
            if (!target[key]) Object.assign(target, {
                [key]: {}
            });
            $9423fef94170f602$export$6969335ea1e4e77c(target[key], source[key]);
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    return target;
}
function $9423fef94170f602$export$83d2e9e3e4ee39ed(str) {
    if (!str) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(str, {
        ALLOWED_TAGS: [
            'b',
            'i',
            'em',
            'strong',
            'a',
            'br',
            'p',
            'span',
            'u'
        ],
        ALLOWED_ATTR: [
            'href',
            'target',
            'class',
            'aria-label'
        ]
    });
}
function $9423fef94170f602$export$4d09d4ac8ba225dd(value, type, label) {
    if (type === 'required' && (!value || value.trim() === '')) return `${label} is required.`;
    if (type === 'url' && value) {
        // Regex checks for http:// or https:// protocol
        if (!value.match(/^(http|https):\/\/[^ "]+$/)) return `${label} must be a valid URL.`;
    }
    if (type === 'date' && value) {
        if (isNaN(new Date(value).getTime())) return `${label} is not a valid date.`;
    }
    return null;
}
function $9423fef94170f602$export$44cee01bde6a1304(input) {
    if (!input) return null;
    try {
        const url = new URL(input);
        if (url.hostname.includes('youtube.com') || url.hostname.includes('youtu.be')) {
            if (url.searchParams.get('v')) return url.searchParams.get('v');
            if (url.pathname.slice(1)) return url.pathname.slice(1);
        }
    } catch (e) {
        // Fallback: if the user pasted just the ID
        if (input.length === 11) return input;
    }
    return null;
}
function $9423fef94170f602$export$719951a5f84653c6(input) {
    const id = $9423fef94170f602$export$44cee01bde6a1304(input);
    return id ? `https://www.youtube.com/embed/${id}` : input;
}
async function $9423fef94170f602$export$8c91308a4df762e1(message) {
    if (!window.crypto || !window.crypto.subtle) {
        if (window.location.hostname !== 'localhost' && window.location.protocol !== 'https:') console.warn("Security Warning: This site should be run on HTTPS.");
    }
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    // Convert buffer to hex string
    return Array.from(new Uint8Array(hashBuffer)).map((b)=>b.toString(16).padStart(2, '0')).join('');
}


/**
 * Browser Image Compression
 * v2.0.2
 * by Donald <donaldcwl@gmail.com>
 * https://github.com/Donaldcwl/browser-image-compression
 */ function $8225ba78123222c8$var$_mergeNamespaces(e, t1) {
    return t1.forEach(function(t1) {
        t1 && "string" != typeof t1 && !Array.isArray(t1) && Object.keys(t1).forEach(function(r) {
            if ("default" !== r && !(r in e)) {
                var i = Object.getOwnPropertyDescriptor(t1, r);
                Object.defineProperty(e, r, i.get ? i : {
                    enumerable: !0,
                    get: function() {
                        return t1[r];
                    }
                });
            }
        });
    }), Object.freeze(e);
}
function $8225ba78123222c8$var$copyExifWithoutOrientation(e, t1) {
    return new Promise(function(r, i) {
        let o;
        return $8225ba78123222c8$var$getApp1Segment(e).then(function(e) {
            try {
                return o = e, r(new Blob([
                    t1.slice(0, 2),
                    o,
                    t1.slice(2)
                ], {
                    type: "image/jpeg"
                }));
            } catch (e) {
                return i(e);
            }
        }, i);
    });
}
const $8225ba78123222c8$var$getApp1Segment = (e)=>new Promise((t1, r)=>{
        const i = new FileReader;
        i.addEventListener("load", ({ target: { result: e } })=>{
            const i = new DataView(e);
            let o = 0;
            if (65496 !== i.getUint16(o)) return r("not a valid JPEG");
            for(o += 2;;){
                const a = i.getUint16(o);
                if (65498 === a) break;
                const s = i.getUint16(o + 2);
                if (65505 === a && 1165519206 === i.getUint32(o + 4)) {
                    const a = o + 10;
                    let f;
                    switch(i.getUint16(a)){
                        case 18761:
                            f = !0;
                            break;
                        case 19789:
                            f = !1;
                            break;
                        default:
                            return r("TIFF header contains invalid endian");
                    }
                    if (42 !== i.getUint16(a + 2, f)) return r("TIFF header contains invalid version");
                    const l = i.getUint32(a + 4, f), c = a + l + 2 + 12 * i.getUint16(a + l, f);
                    for(let e = a + l + 2; e < c; e += 12)if (274 == i.getUint16(e, f)) {
                        if (3 !== i.getUint16(e + 2, f)) return r("Orientation data type is invalid");
                        if (1 !== i.getUint32(e + 4, f)) return r("Orientation data count is invalid");
                        i.setUint16(e + 8, 1, f);
                        break;
                    }
                    return t1(e.slice(o, o + 2 + s));
                }
                o += 2 + s;
            }
            return t1(new Blob);
        }), i.readAsArrayBuffer(e);
    });
var $8225ba78123222c8$var$e = {}, $8225ba78123222c8$var$t1 = {
    get exports () {
        return $8225ba78123222c8$var$e;
    },
    set exports (t){
        $8225ba78123222c8$var$e = t;
    }
};
!function(e) {
    var r, i, UZIP = {};
    $8225ba78123222c8$var$t1.exports = UZIP, UZIP.parse = function(e, t1) {
        for(var r = UZIP.bin.readUshort, i = UZIP.bin.readUint, o = 0, a = {}, s = new Uint8Array(e), f = s.length - 4; 101010256 != i(s, f);)f--;
        o = f;
        o += 4;
        var l = r(s, o += 4);
        r(s, o += 2);
        var c = i(s, o += 2), u = i(s, o += 4);
        o += 4, o = u;
        for(var h = 0; h < l; h++){
            i(s, o), o += 4, o += 4, o += 4, i(s, o += 4);
            c = i(s, o += 4);
            var d = i(s, o += 4), A = r(s, o += 4), g = r(s, o + 2), p = r(s, o + 4);
            o += 6;
            var m = i(s, o += 8);
            o += 4, o += A + g + p, UZIP._readLocal(s, m, a, c, d, t1);
        }
        return a;
    }, UZIP._readLocal = function(e, t1, r, i, o, a) {
        var s = UZIP.bin.readUshort, f = UZIP.bin.readUint;
        f(e, t1), s(e, t1 += 4), s(e, t1 += 2);
        var l = s(e, t1 += 2);
        f(e, t1 += 2), f(e, t1 += 4), t1 += 4;
        var c = s(e, t1 += 8), u = s(e, t1 += 2);
        t1 += 2;
        var h = UZIP.bin.readUTF8(e, t1, c);
        if (t1 += c, t1 += u, a) r[h] = {
            size: o,
            csize: i
        };
        else {
            var d = new Uint8Array(e.buffer, t1);
            if (0 == l) r[h] = new Uint8Array(d.buffer.slice(t1, t1 + i));
            else {
                if (8 != l) throw "unknown compression method: " + l;
                var A = new Uint8Array(o);
                UZIP.inflateRaw(d, A), r[h] = A;
            }
        }
    }, UZIP.inflateRaw = function(e, t1) {
        return UZIP.F.inflate(e, t1);
    }, UZIP.inflate = function(e, t1) {
        return e[0], e[1], UZIP.inflateRaw(new Uint8Array(e.buffer, e.byteOffset + 2, e.length - 6), t1);
    }, UZIP.deflate = function(e, t1) {
        null == t1 && (t1 = {
            level: 6
        });
        var r = 0, i = new Uint8Array(50 + Math.floor(1.1 * e.length));
        i[r] = 120, i[r + 1] = 156, r += 2, r = UZIP.F.deflateRaw(e, i, r, t1.level);
        var o = UZIP.adler(e, 0, e.length);
        return i[r + 0] = o >>> 24 & 255, i[r + 1] = o >>> 16 & 255, i[r + 2] = o >>> 8 & 255, i[r + 3] = o >>> 0 & 255, new Uint8Array(i.buffer, 0, r + 4);
    }, UZIP.deflateRaw = function(e, t1) {
        null == t1 && (t1 = {
            level: 6
        });
        var r = new Uint8Array(50 + Math.floor(1.1 * e.length)), i = UZIP.F.deflateRaw(e, r, i, t1.level);
        return new Uint8Array(r.buffer, 0, i);
    }, UZIP.encode = function(e, t1) {
        null == t1 && (t1 = !1);
        var r = 0, i = UZIP.bin.writeUint, o = UZIP.bin.writeUshort, a = {};
        for(var s in e){
            var f = !UZIP._noNeed(s) && !t1, l = e[s], c = UZIP.crc.crc(l, 0, l.length);
            a[s] = {
                cpr: f,
                usize: l.length,
                crc: c,
                file: f ? UZIP.deflateRaw(l) : l
            };
        }
        for(var s in a)r += a[s].file.length + 30 + 46 + 2 * UZIP.bin.sizeUTF8(s);
        r += 22;
        var u = new Uint8Array(r), h = 0, d = [];
        for(var s in a){
            var A = a[s];
            d.push(h), h = UZIP._writeHeader(u, h, s, A, 0);
        }
        var g = 0, p = h;
        for(var s in a){
            A = a[s];
            d.push(h), h = UZIP._writeHeader(u, h, s, A, 1, d[g++]);
        }
        var m = h - p;
        return i(u, h, 101010256), h += 4, o(u, h += 4, g), o(u, h += 2, g), i(u, h += 2, m), i(u, h += 4, p), h += 4, h += 2, u.buffer;
    }, UZIP._noNeed = function(e) {
        var t1 = e.split(".").pop().toLowerCase();
        return -1 != "png,jpg,jpeg,zip".indexOf(t1);
    }, UZIP._writeHeader = function(e, t1, r, i, o, a) {
        var s = UZIP.bin.writeUint, f = UZIP.bin.writeUshort, l = i.file;
        return s(e, t1, 0 == o ? 67324752 : 33639248), t1 += 4, 1 == o && (t1 += 2), f(e, t1, 20), f(e, t1 += 2, 0), f(e, t1 += 2, i.cpr ? 8 : 0), s(e, t1 += 2, 0), s(e, t1 += 4, i.crc), s(e, t1 += 4, l.length), s(e, t1 += 4, i.usize), f(e, t1 += 4, UZIP.bin.sizeUTF8(r)), f(e, t1 += 2, 0), t1 += 2, 1 == o && (t1 += 2, t1 += 2, s(e, t1 += 6, a), t1 += 4), t1 += UZIP.bin.writeUTF8(e, t1, r), 0 == o && (e.set(l, t1), t1 += l.length), t1;
    }, UZIP.crc = {
        table: function() {
            for(var e = new Uint32Array(256), t1 = 0; t1 < 256; t1++){
                for(var r = t1, i = 0; i < 8; i++)1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
                e[t1] = r;
            }
            return e;
        }(),
        update: function(e, t1, r, i) {
            for(var o = 0; o < i; o++)e = UZIP.crc.table[255 & (e ^ t1[r + o])] ^ e >>> 8;
            return e;
        },
        crc: function(e, t1, r) {
            return 4294967295 ^ UZIP.crc.update(4294967295, e, t1, r);
        }
    }, UZIP.adler = function(e, t1, r) {
        for(var i = 1, o = 0, a = t1, s = t1 + r; a < s;){
            for(var f = Math.min(a + 5552, s); a < f;)o += i += e[a++];
            i %= 65521, o %= 65521;
        }
        return o << 16 | i;
    }, UZIP.bin = {
        readUshort: function(e, t1) {
            return e[t1] | e[t1 + 1] << 8;
        },
        writeUshort: function(e, t1, r) {
            e[t1] = 255 & r, e[t1 + 1] = r >> 8 & 255;
        },
        readUint: function(e, t1) {
            return 16777216 * e[t1 + 3] + (e[t1 + 2] << 16 | e[t1 + 1] << 8 | e[t1]);
        },
        writeUint: function(e, t1, r) {
            e[t1] = 255 & r, e[t1 + 1] = r >> 8 & 255, e[t1 + 2] = r >> 16 & 255, e[t1 + 3] = r >> 24 & 255;
        },
        readASCII: function(e, t1, r) {
            for(var i = "", o = 0; o < r; o++)i += String.fromCharCode(e[t1 + o]);
            return i;
        },
        writeASCII: function(e, t1, r) {
            for(var i = 0; i < r.length; i++)e[t1 + i] = r.charCodeAt(i);
        },
        pad: function(e) {
            return e.length < 2 ? "0" + e : e;
        },
        readUTF8: function(e, t1, r) {
            for(var i, o = "", a = 0; a < r; a++)o += "%" + UZIP.bin.pad(e[t1 + a].toString(16));
            try {
                i = decodeURIComponent(o);
            } catch (i) {
                return UZIP.bin.readASCII(e, t1, r);
            }
            return i;
        },
        writeUTF8: function(e, t1, r) {
            for(var i = r.length, o = 0, a = 0; a < i; a++){
                var s = r.charCodeAt(a);
                if (0 == (4294967168 & s)) e[t1 + o] = s, o++;
                else if (0 == (4294965248 & s)) e[t1 + o] = 192 | s >> 6, e[t1 + o + 1] = 128 | s >> 0 & 63, o += 2;
                else if (0 == (4294901760 & s)) e[t1 + o] = 224 | s >> 12, e[t1 + o + 1] = 128 | s >> 6 & 63, e[t1 + o + 2] = 128 | s >> 0 & 63, o += 3;
                else {
                    if (0 != (4292870144 & s)) throw "e";
                    e[t1 + o] = 240 | s >> 18, e[t1 + o + 1] = 128 | s >> 12 & 63, e[t1 + o + 2] = 128 | s >> 6 & 63, e[t1 + o + 3] = 128 | s >> 0 & 63, o += 4;
                }
            }
            return o;
        },
        sizeUTF8: function(e) {
            for(var t1 = e.length, r = 0, i = 0; i < t1; i++){
                var o = e.charCodeAt(i);
                if (0 == (4294967168 & o)) r++;
                else if (0 == (4294965248 & o)) r += 2;
                else if (0 == (4294901760 & o)) r += 3;
                else {
                    if (0 != (4292870144 & o)) throw "e";
                    r += 4;
                }
            }
            return r;
        }
    }, UZIP.F = {}, UZIP.F.deflateRaw = function(e, t1, r, i) {
        var o = [
            [
                0,
                0,
                0,
                0,
                0
            ],
            [
                4,
                4,
                8,
                4,
                0
            ],
            [
                4,
                5,
                16,
                8,
                0
            ],
            [
                4,
                6,
                16,
                16,
                0
            ],
            [
                4,
                10,
                16,
                32,
                0
            ],
            [
                8,
                16,
                32,
                32,
                0
            ],
            [
                8,
                16,
                128,
                128,
                0
            ],
            [
                8,
                32,
                128,
                256,
                0
            ],
            [
                32,
                128,
                258,
                1024,
                1
            ],
            [
                32,
                258,
                258,
                4096,
                1
            ]
        ][i], a = UZIP.F.U, s = UZIP.F._goodIndex;
        UZIP.F._hash;
        var f = UZIP.F._putsE, l = 0, c = r << 3, u = 0, h = e.length;
        if (0 == i) {
            for(; l < h;)f(t1, c, l + (_ = Math.min(65535, h - l)) == h ? 1 : 0), c = UZIP.F._copyExact(e, l, _, t1, c + 8), l += _;
            return c >>> 3;
        }
        var d = a.lits, A = a.strt, g = a.prev, p = 0, m = 0, w = 0, v = 0, b = 0, y = 0;
        for(h > 2 && (A[y = UZIP.F._hash(e, 0)] = 0), l = 0; l < h; l++){
            if (b = y, l + 1 < h - 2) {
                y = UZIP.F._hash(e, l + 1);
                var E = l + 1 & 32767;
                g[E] = A[y], A[y] = E;
            }
            if (u <= l) {
                (p > 14e3 || m > 26697) && h - l > 100 && (u < l && (d[p] = l - u, p += 2, u = l), c = UZIP.F._writeBlock(l == h - 1 || u == h ? 1 : 0, d, p, v, e, w, l - w, t1, c), p = m = v = 0, w = l);
                var F = 0;
                l < h - 2 && (F = UZIP.F._bestMatch(e, l, g, b, Math.min(o[2], h - l), o[3]));
                var _ = F >>> 16, B = 65535 & F;
                if (0 != F) {
                    B = 65535 & F;
                    var U = s(_ = F >>> 16, a.of0);
                    a.lhst[257 + U]++;
                    var C = s(B, a.df0);
                    a.dhst[C]++, v += a.exb[U] + a.dxb[C], d[p] = _ << 23 | l - u, d[p + 1] = B << 16 | U << 8 | C, p += 2, u = l + _;
                } else a.lhst[e[l]]++;
                m++;
            }
        }
        for(w == l && 0 != e.length || (u < l && (d[p] = l - u, p += 2, u = l), c = UZIP.F._writeBlock(1, d, p, v, e, w, l - w, t1, c), p = 0, m = 0, p = m = v = 0, w = l); 0 != (7 & c);)c++;
        return c >>> 3;
    }, UZIP.F._bestMatch = function(e, t1, r, i, o, a) {
        var s = 32767 & t1, f = r[s], l = s - f + 32768 & 32767;
        if (f == s || i != UZIP.F._hash(e, t1 - l)) return 0;
        for(var c = 0, u = 0, h = Math.min(32767, t1); l <= h && 0 != --a && f != s;){
            if (0 == c || e[t1 + c] == e[t1 + c - l]) {
                var d = UZIP.F._howLong(e, t1, l);
                if (d > c) {
                    if (u = l, (c = d) >= o) break;
                    l + 2 < d && (d = l + 2);
                    for(var A = 0, g = 0; g < d - 2; g++){
                        var p = t1 - l + g + 32768 & 32767, m = p - r[p] + 32768 & 32767;
                        m > A && (A = m, f = p);
                    }
                }
            }
            l += (s = f) - (f = r[s]) + 32768 & 32767;
        }
        return c << 16 | u;
    }, UZIP.F._howLong = function(e, t1, r) {
        if (e[t1] != e[t1 - r] || e[t1 + 1] != e[t1 + 1 - r] || e[t1 + 2] != e[t1 + 2 - r]) return 0;
        var i = t1, o = Math.min(e.length, t1 + 258);
        for(t1 += 3; t1 < o && e[t1] == e[t1 - r];)t1++;
        return t1 - i;
    }, UZIP.F._hash = function(e, t1) {
        return (e[t1] << 8 | e[t1 + 1]) + (e[t1 + 2] << 4) & 65535;
    }, UZIP.saved = 0, UZIP.F._writeBlock = function(e, t1, r, i, o, a, s, f, l) {
        var c, u, h, d, A, g, p, m, w, v = UZIP.F.U, b = UZIP.F._putsF, y = UZIP.F._putsE;
        v.lhst[256]++, u = (c = UZIP.F.getTrees())[0], h = c[1], d = c[2], A = c[3], g = c[4], p = c[5], m = c[6], w = c[7];
        var E = 32 + (0 == (l + 3 & 7) ? 0 : 8 - (l + 3 & 7)) + (s << 3), F = i + UZIP.F.contSize(v.fltree, v.lhst) + UZIP.F.contSize(v.fdtree, v.dhst), _ = i + UZIP.F.contSize(v.ltree, v.lhst) + UZIP.F.contSize(v.dtree, v.dhst);
        _ += 14 + 3 * p + UZIP.F.contSize(v.itree, v.ihst) + (2 * v.ihst[16] + 3 * v.ihst[17] + 7 * v.ihst[18]);
        for(var B = 0; B < 286; B++)v.lhst[B] = 0;
        for(B = 0; B < 30; B++)v.dhst[B] = 0;
        for(B = 0; B < 19; B++)v.ihst[B] = 0;
        var U = E < F && E < _ ? 0 : F < _ ? 1 : 2;
        if (b(f, l, e), b(f, l + 1, U), l += 3, 0 == U) {
            for(; 0 != (7 & l);)l++;
            l = UZIP.F._copyExact(o, a, s, f, l);
        } else {
            var C, I;
            if (1 == U && (C = v.fltree, I = v.fdtree), 2 == U) {
                UZIP.F.makeCodes(v.ltree, u), UZIP.F.revCodes(v.ltree, u), UZIP.F.makeCodes(v.dtree, h), UZIP.F.revCodes(v.dtree, h), UZIP.F.makeCodes(v.itree, d), UZIP.F.revCodes(v.itree, d), C = v.ltree, I = v.dtree, y(f, l, A - 257), y(f, l += 5, g - 1), y(f, l += 5, p - 4), l += 4;
                for(var Q = 0; Q < p; Q++)y(f, l + 3 * Q, v.itree[1 + (v.ordr[Q] << 1)]);
                l += 3 * p, l = UZIP.F._codeTiny(m, v.itree, f, l), l = UZIP.F._codeTiny(w, v.itree, f, l);
            }
            for(var M = a, x = 0; x < r; x += 2){
                for(var S = t1[x], R = S >>> 23, T = M + (8388607 & S); M < T;)l = UZIP.F._writeLit(o[M++], C, f, l);
                if (0 != R) {
                    var O = t1[x + 1], P = O >> 16, H = O >> 8 & 255, L = 255 & O;
                    y(f, l = UZIP.F._writeLit(257 + H, C, f, l), R - v.of0[H]), l += v.exb[H], b(f, l = UZIP.F._writeLit(L, I, f, l), P - v.df0[L]), l += v.dxb[L], M += R;
                }
            }
            l = UZIP.F._writeLit(256, C, f, l);
        }
        return l;
    }, UZIP.F._copyExact = function(e, t1, r, i, o) {
        var a = o >>> 3;
        return i[a] = r, i[a + 1] = r >>> 8, i[a + 2] = 255 - i[a], i[a + 3] = 255 - i[a + 1], a += 4, i.set(new Uint8Array(e.buffer, t1, r), a), o + (r + 4 << 3);
    }, UZIP.F.getTrees = function() {
        for(var e = UZIP.F.U, t1 = UZIP.F._hufTree(e.lhst, e.ltree, 15), r = UZIP.F._hufTree(e.dhst, e.dtree, 15), i = [], o = UZIP.F._lenCodes(e.ltree, i), a = [], s = UZIP.F._lenCodes(e.dtree, a), f = 0; f < i.length; f += 2)e.ihst[i[f]]++;
        for(f = 0; f < a.length; f += 2)e.ihst[a[f]]++;
        for(var l = UZIP.F._hufTree(e.ihst, e.itree, 7), c = 19; c > 4 && 0 == e.itree[1 + (e.ordr[c - 1] << 1)];)c--;
        return [
            t1,
            r,
            l,
            o,
            s,
            c,
            i,
            a
        ];
    }, UZIP.F.getSecond = function(e) {
        for(var t1 = [], r = 0; r < e.length; r += 2)t1.push(e[r + 1]);
        return t1;
    }, UZIP.F.nonZero = function(e) {
        for(var t1 = "", r = 0; r < e.length; r += 2)0 != e[r + 1] && (t1 += (r >> 1) + ",");
        return t1;
    }, UZIP.F.contSize = function(e, t1) {
        for(var r = 0, i = 0; i < t1.length; i++)r += t1[i] * e[1 + (i << 1)];
        return r;
    }, UZIP.F._codeTiny = function(e, t1, r, i) {
        for(var o = 0; o < e.length; o += 2){
            var a = e[o], s = e[o + 1];
            i = UZIP.F._writeLit(a, t1, r, i);
            var f = 16 == a ? 2 : 17 == a ? 3 : 7;
            a > 15 && (UZIP.F._putsE(r, i, s, f), i += f);
        }
        return i;
    }, UZIP.F._lenCodes = function(e, t1) {
        for(var r = e.length; 2 != r && 0 == e[r - 1];)r -= 2;
        for(var i = 0; i < r; i += 2){
            var o = e[i + 1], a = i + 3 < r ? e[i + 3] : -1, s = i + 5 < r ? e[i + 5] : -1, f = 0 == i ? -1 : e[i - 1];
            if (0 == o && a == o && s == o) {
                for(var l = i + 5; l + 2 < r && e[l + 2] == o;)l += 2;
                (c = Math.min(l + 1 - i >>> 1, 138)) < 11 ? t1.push(17, c - 3) : t1.push(18, c - 11), i += 2 * c - 2;
            } else if (o == f && a == o && s == o) {
                for(l = i + 5; l + 2 < r && e[l + 2] == o;)l += 2;
                var c = Math.min(l + 1 - i >>> 1, 6);
                t1.push(16, c - 3), i += 2 * c - 2;
            } else t1.push(o, 0);
        }
        return r >>> 1;
    }, UZIP.F._hufTree = function(e, t1, r) {
        var i = [], o = e.length, a = t1.length, s = 0;
        for(s = 0; s < a; s += 2)t1[s] = 0, t1[s + 1] = 0;
        for(s = 0; s < o; s++)0 != e[s] && i.push({
            lit: s,
            f: e[s]
        });
        var f = i.length, l = i.slice(0);
        if (0 == f) return 0;
        if (1 == f) {
            var c = i[0].lit;
            l = 0 == c ? 1 : 0;
            return t1[1 + (c << 1)] = 1, t1[1 + (l << 1)] = 1, 1;
        }
        i.sort(function(e, t1) {
            return e.f - t1.f;
        });
        var u = i[0], h = i[1], d = 0, A = 1, g = 2;
        for(i[0] = {
            lit: -1,
            f: u.f + h.f,
            l: u,
            r: h,
            d: 0
        }; A != f - 1;)u = d != A && (g == f || i[d].f < i[g].f) ? i[d++] : i[g++], h = d != A && (g == f || i[d].f < i[g].f) ? i[d++] : i[g++], i[A++] = {
            lit: -1,
            f: u.f + h.f,
            l: u,
            r: h
        };
        var p = UZIP.F.setDepth(i[A - 1], 0);
        for(p > r && (UZIP.F.restrictDepth(l, r, p), p = r), s = 0; s < f; s++)t1[1 + (l[s].lit << 1)] = l[s].d;
        return p;
    }, UZIP.F.setDepth = function(e, t1) {
        return -1 != e.lit ? (e.d = t1, t1) : Math.max(UZIP.F.setDepth(e.l, t1 + 1), UZIP.F.setDepth(e.r, t1 + 1));
    }, UZIP.F.restrictDepth = function(e, t1, r) {
        var i = 0, o = 1 << r - t1, a = 0;
        for(e.sort(function(e, t1) {
            return t1.d == e.d ? e.f - t1.f : t1.d - e.d;
        }), i = 0; i < e.length && e[i].d > t1; i++){
            var s = e[i].d;
            e[i].d = t1, a += o - (1 << r - s);
        }
        for(a >>>= r - t1; a > 0;)(s = e[i].d) < t1 ? (e[i].d++, a -= 1 << t1 - s - 1) : i++;
        for(; i >= 0; i--)e[i].d == t1 && a < 0 && (e[i].d--, a++);
        0 != a && console.log("debt left");
    }, UZIP.F._goodIndex = function(e, t1) {
        var r = 0;
        return t1[16 | r] <= e && (r |= 16), t1[8 | r] <= e && (r |= 8), t1[4 | r] <= e && (r |= 4), t1[2 | r] <= e && (r |= 2), t1[1 | r] <= e && (r |= 1), r;
    }, UZIP.F._writeLit = function(e, t1, r, i) {
        return UZIP.F._putsF(r, i, t1[e << 1]), i + t1[1 + (e << 1)];
    }, UZIP.F.inflate = function(e, t1) {
        var r = Uint8Array;
        if (3 == e[0] && 0 == e[1]) return t1 || new r(0);
        var i = UZIP.F, o = i._bitsF, a = i._bitsE, s = i._decodeTiny, f = i.makeCodes, l = i.codes2map, c = i._get17, u = i.U, h = null == t1;
        h && (t1 = new r(e.length >>> 2 << 3));
        for(var d, A, g = 0, p = 0, m = 0, w = 0, v = 0, b = 0, y = 0, E = 0, F = 0; 0 == g;)if (g = o(e, F, 1), p = o(e, F + 1, 2), F += 3, 0 != p) {
            if (h && (t1 = UZIP.F._check(t1, E + 131072)), 1 == p && (d = u.flmap, A = u.fdmap, b = 511, y = 31), 2 == p) {
                m = a(e, F, 5) + 257, w = a(e, F + 5, 5) + 1, v = a(e, F + 10, 4) + 4, F += 14;
                for(var _ = 0; _ < 38; _ += 2)u.itree[_] = 0, u.itree[_ + 1] = 0;
                var B = 1;
                for(_ = 0; _ < v; _++){
                    var U = a(e, F + 3 * _, 3);
                    u.itree[1 + (u.ordr[_] << 1)] = U, U > B && (B = U);
                }
                F += 3 * v, f(u.itree, B), l(u.itree, B, u.imap), d = u.lmap, A = u.dmap, F = s(u.imap, (1 << B) - 1, m + w, e, F, u.ttree);
                var C = i._copyOut(u.ttree, 0, m, u.ltree);
                b = (1 << C) - 1;
                var I = i._copyOut(u.ttree, m, w, u.dtree);
                y = (1 << I) - 1, f(u.ltree, C), l(u.ltree, C, d), f(u.dtree, I), l(u.dtree, I, A);
            }
            for(;;){
                var Q = d[c(e, F) & b];
                F += 15 & Q;
                var M = Q >>> 4;
                if (M >>> 8 == 0) t1[E++] = M;
                else {
                    if (256 == M) break;
                    var x = E + M - 254;
                    if (M > 264) {
                        var S = u.ldef[M - 257];
                        x = E + (S >>> 3) + a(e, F, 7 & S), F += 7 & S;
                    }
                    var R = A[c(e, F) & y];
                    F += 15 & R;
                    var T = R >>> 4, O = u.ddef[T], P = (O >>> 4) + o(e, F, 15 & O);
                    for(F += 15 & O, h && (t1 = UZIP.F._check(t1, E + 131072)); E < x;)t1[E] = t1[E++ - P], t1[E] = t1[E++ - P], t1[E] = t1[E++ - P], t1[E] = t1[E++ - P];
                    E = x;
                }
            }
        } else {
            0 != (7 & F) && (F += 8 - (7 & F));
            var H = 4 + (F >>> 3), L = e[H - 4] | e[H - 3] << 8;
            h && (t1 = UZIP.F._check(t1, E + L)), t1.set(new r(e.buffer, e.byteOffset + H, L), E), F = H + L << 3, E += L;
        }
        return t1.length == E ? t1 : t1.slice(0, E);
    }, UZIP.F._check = function(e, t1) {
        var r = e.length;
        if (t1 <= r) return e;
        var i = new Uint8Array(Math.max(r << 1, t1));
        return i.set(e, 0), i;
    }, UZIP.F._decodeTiny = function(e, t1, r, i, o, a) {
        for(var s = UZIP.F._bitsE, f = UZIP.F._get17, l = 0; l < r;){
            var c = e[f(i, o) & t1];
            o += 15 & c;
            var u = c >>> 4;
            if (u <= 15) a[l] = u, l++;
            else {
                var h = 0, d = 0;
                16 == u ? (d = 3 + s(i, o, 2), o += 2, h = a[l - 1]) : 17 == u ? (d = 3 + s(i, o, 3), o += 3) : 18 == u && (d = 11 + s(i, o, 7), o += 7);
                for(var A = l + d; l < A;)a[l] = h, l++;
            }
        }
        return o;
    }, UZIP.F._copyOut = function(e, t1, r, i) {
        for(var o = 0, a = 0, s = i.length >>> 1; a < r;){
            var f = e[a + t1];
            i[a << 1] = 0, i[1 + (a << 1)] = f, f > o && (o = f), a++;
        }
        for(; a < s;)i[a << 1] = 0, i[1 + (a << 1)] = 0, a++;
        return o;
    }, UZIP.F.makeCodes = function(e, t1) {
        for(var r, i, o, a, s = UZIP.F.U, f = e.length, l = s.bl_count, c = 0; c <= t1; c++)l[c] = 0;
        for(c = 1; c < f; c += 2)l[e[c]]++;
        var u = s.next_code;
        for(r = 0, l[0] = 0, i = 1; i <= t1; i++)r = r + l[i - 1] << 1, u[i] = r;
        for(o = 0; o < f; o += 2)0 != (a = e[o + 1]) && (e[o] = u[a], u[a]++);
    }, UZIP.F.codes2map = function(e, t1, r) {
        for(var i = e.length, o = UZIP.F.U.rev15, a = 0; a < i; a += 2)if (0 != e[a + 1]) for(var s = a >> 1, f = e[a + 1], l = s << 4 | f, c = t1 - f, u = e[a] << c, h = u + (1 << c); u != h;)r[o[u] >>> 15 - t1] = l, u++;
    }, UZIP.F.revCodes = function(e, t1) {
        for(var r = UZIP.F.U.rev15, i = 15 - t1, o = 0; o < e.length; o += 2){
            var a = e[o] << t1 - e[o + 1];
            e[o] = r[a] >>> i;
        }
    }, UZIP.F._putsE = function(e, t1, r) {
        r <<= 7 & t1;
        var i = t1 >>> 3;
        e[i] |= r, e[i + 1] |= r >>> 8;
    }, UZIP.F._putsF = function(e, t1, r) {
        r <<= 7 & t1;
        var i = t1 >>> 3;
        e[i] |= r, e[i + 1] |= r >>> 8, e[i + 2] |= r >>> 16;
    }, UZIP.F._bitsE = function(e, t1, r) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8) >>> (7 & t1) & (1 << r) - 1;
    }, UZIP.F._bitsF = function(e, t1, r) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1) & (1 << r) - 1;
    }, UZIP.F._get17 = function(e, t1) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1);
    }, UZIP.F._get25 = function(e, t1) {
        return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16 | e[3 + (t1 >>> 3)] << 24) >>> (7 & t1);
    }, UZIP.F.U = (r = Uint16Array, i = Uint32Array, {
        next_code: new r(16),
        bl_count: new r(16),
        ordr: [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ],
        of0: [
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            13,
            15,
            17,
            19,
            23,
            27,
            31,
            35,
            43,
            51,
            59,
            67,
            83,
            99,
            115,
            131,
            163,
            195,
            227,
            258,
            999,
            999,
            999
        ],
        exb: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ],
        ldef: new r(32),
        df0: [
            1,
            2,
            3,
            4,
            5,
            7,
            9,
            13,
            17,
            25,
            33,
            49,
            65,
            97,
            129,
            193,
            257,
            385,
            513,
            769,
            1025,
            1537,
            2049,
            3073,
            4097,
            6145,
            8193,
            12289,
            16385,
            24577,
            65535,
            65535
        ],
        dxb: [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ],
        ddef: new i(32),
        flmap: new r(512),
        fltree: [],
        fdmap: new r(32),
        fdtree: [],
        lmap: new r(32768),
        ltree: [],
        ttree: [],
        dmap: new r(32768),
        dtree: [],
        imap: new r(512),
        itree: [],
        rev15: new r(32768),
        lhst: new i(286),
        dhst: new i(30),
        ihst: new i(19),
        lits: new i(15e3),
        strt: new r(65536),
        prev: new r(32768)
    }), function() {
        for(var e = UZIP.F.U, t1 = 0; t1 < 32768; t1++){
            var r = t1;
            r = (4278255360 & (r = (4042322160 & (r = (3435973836 & (r = (2863311530 & r) >>> 1 | (1431655765 & r) << 1)) >>> 2 | (858993459 & r) << 2)) >>> 4 | (252645135 & r) << 4)) >>> 8 | (16711935 & r) << 8, e.rev15[t1] = (r >>> 16 | r << 16) >>> 17;
        }
        function pushV(e, t1, r) {
            for(; 0 != t1--;)e.push(0, r);
        }
        for(t1 = 0; t1 < 32; t1++)e.ldef[t1] = e.of0[t1] << 3 | e.exb[t1], e.ddef[t1] = e.df0[t1] << 4 | e.dxb[t1];
        pushV(e.fltree, 144, 8), pushV(e.fltree, 112, 9), pushV(e.fltree, 24, 7), pushV(e.fltree, 8, 8), UZIP.F.makeCodes(e.fltree, 9), UZIP.F.codes2map(e.fltree, 9, e.flmap), UZIP.F.revCodes(e.fltree, 9), pushV(e.fdtree, 32, 5), UZIP.F.makeCodes(e.fdtree, 5), UZIP.F.codes2map(e.fdtree, 5, e.fdmap), UZIP.F.revCodes(e.fdtree, 5), pushV(e.itree, 19, 0), pushV(e.ltree, 286, 0), pushV(e.dtree, 30, 0), pushV(e.ttree, 320, 0);
    }();
}();
var $8225ba78123222c8$var$UZIP = $8225ba78123222c8$var$_mergeNamespaces({
    __proto__: null,
    default: $8225ba78123222c8$var$e
}, [
    $8225ba78123222c8$var$e
]);
const $8225ba78123222c8$var$UPNG = function() {
    var e = {
        nextZero (e, t1) {
            for(; 0 != e[t1];)t1++;
            return t1;
        },
        readUshort: (e, t1)=>e[t1] << 8 | e[t1 + 1],
        writeUshort (e, t1, r) {
            e[t1] = r >> 8 & 255, e[t1 + 1] = 255 & r;
        },
        readUint: (e, t1)=>16777216 * e[t1] + (e[t1 + 1] << 16 | e[t1 + 2] << 8 | e[t1 + 3]),
        writeUint (e, t1, r) {
            e[t1] = r >> 24 & 255, e[t1 + 1] = r >> 16 & 255, e[t1 + 2] = r >> 8 & 255, e[t1 + 3] = 255 & r;
        },
        readASCII (e, t1, r) {
            let i = "";
            for(let o = 0; o < r; o++)i += String.fromCharCode(e[t1 + o]);
            return i;
        },
        writeASCII (e, t1, r) {
            for(let i = 0; i < r.length; i++)e[t1 + i] = r.charCodeAt(i);
        },
        readBytes (e, t1, r) {
            const i = [];
            for(let o = 0; o < r; o++)i.push(e[t1 + o]);
            return i;
        },
        pad: (e)=>e.length < 2 ? `0${e}` : e,
        readUTF8 (t1, r, i) {
            let o, a = "";
            for(let o = 0; o < i; o++)a += `%${e.pad(t1[r + o].toString(16))}`;
            try {
                o = decodeURIComponent(a);
            } catch (o) {
                return e.readASCII(t1, r, i);
            }
            return o;
        }
    };
    function decodeImage(t1, r, i, o) {
        const a = r * i, s = _getBPP(o), f = Math.ceil(r * s / 8), l = new Uint8Array(4 * a), c = new Uint32Array(l.buffer), { ctype: u } = o, { depth: h } = o, d = e.readUshort;
        if (6 == u) {
            const e = a << 2;
            if (8 == h) for(var A = 0; A < e; A += 4)l[A] = t1[A], l[A + 1] = t1[A + 1], l[A + 2] = t1[A + 2], l[A + 3] = t1[A + 3];
            if (16 == h) for(A = 0; A < e; A++)l[A] = t1[A << 1];
        } else if (2 == u) {
            const e = o.tabs.tRNS;
            if (null == e) {
                if (8 == h) for(A = 0; A < a; A++){
                    var g = 3 * A;
                    c[A] = -16777216 | t1[g + 2] << 16 | t1[g + 1] << 8 | t1[g];
                }
                if (16 == h) for(A = 0; A < a; A++){
                    g = 6 * A;
                    c[A] = -16777216 | t1[g + 4] << 16 | t1[g + 2] << 8 | t1[g];
                }
            } else {
                var p = e[0];
                const r = e[1], i = e[2];
                if (8 == h) for(A = 0; A < a; A++){
                    var m = A << 2;
                    g = 3 * A;
                    c[A] = -16777216 | t1[g + 2] << 16 | t1[g + 1] << 8 | t1[g], t1[g] == p && t1[g + 1] == r && t1[g + 2] == i && (l[m + 3] = 0);
                }
                if (16 == h) for(A = 0; A < a; A++){
                    m = A << 2, g = 6 * A;
                    c[A] = -16777216 | t1[g + 4] << 16 | t1[g + 2] << 8 | t1[g], d(t1, g) == p && d(t1, g + 2) == r && d(t1, g + 4) == i && (l[m + 3] = 0);
                }
            }
        } else if (3 == u) {
            const e = o.tabs.PLTE, s = o.tabs.tRNS, c = s ? s.length : 0;
            if (1 == h) for(var w = 0; w < i; w++){
                var v = w * f, b = w * r;
                for(A = 0; A < r; A++){
                    m = b + A << 2;
                    var y = 3 * (E = t1[v + (A >> 3)] >> 7 - ((7 & A) << 0) & 1);
                    l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
                }
            }
            if (2 == h) for(w = 0; w < i; w++)for(v = w * f, b = w * r, A = 0; A < r; A++){
                m = b + A << 2, y = 3 * (E = t1[v + (A >> 2)] >> 6 - ((3 & A) << 1) & 3);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
            if (4 == h) for(w = 0; w < i; w++)for(v = w * f, b = w * r, A = 0; A < r; A++){
                m = b + A << 2, y = 3 * (E = t1[v + (A >> 1)] >> 4 - ((1 & A) << 2) & 15);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
            if (8 == h) for(A = 0; A < a; A++){
                var E;
                m = A << 2, y = 3 * (E = t1[A]);
                l[m] = e[y], l[m + 1] = e[y + 1], l[m + 2] = e[y + 2], l[m + 3] = E < c ? s[E] : 255;
            }
        } else if (4 == u) {
            if (8 == h) for(A = 0; A < a; A++){
                m = A << 2;
                var F = t1[_ = A << 1];
                l[m] = F, l[m + 1] = F, l[m + 2] = F, l[m + 3] = t1[_ + 1];
            }
            if (16 == h) for(A = 0; A < a; A++){
                var _;
                m = A << 2, F = t1[_ = A << 2];
                l[m] = F, l[m + 1] = F, l[m + 2] = F, l[m + 3] = t1[_ + 2];
            }
        } else if (0 == u) for(p = o.tabs.tRNS ? o.tabs.tRNS : -1, w = 0; w < i; w++){
            const e = w * f, i = w * r;
            if (1 == h) for(var B = 0; B < r; B++){
                var U = (F = 255 * (t1[e + (B >>> 3)] >>> 7 - (7 & B) & 1)) == 255 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (2 == h) for(B = 0; B < r; B++){
                U = (F = 85 * (t1[e + (B >>> 2)] >>> 6 - ((3 & B) << 1) & 3)) == 85 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (4 == h) for(B = 0; B < r; B++){
                U = (F = 17 * (t1[e + (B >>> 1)] >>> 4 - ((1 & B) << 2) & 15)) == 17 * p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (8 == h) for(B = 0; B < r; B++){
                U = (F = t1[e + B]) == p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
            else if (16 == h) for(B = 0; B < r; B++){
                F = t1[e + (B << 1)], U = d(t1, e + (B << 1)) == p ? 0 : 255;
                c[i + B] = U << 24 | F << 16 | F << 8 | F;
            }
        }
        return l;
    }
    function _decompress(e, r, i, o) {
        const a = _getBPP(e), s = Math.ceil(i * a / 8), f = new Uint8Array((s + 1 + e.interlace) * o);
        return r = e.tabs.CgBI ? t1(r, f) : _inflate(r, f), 0 == e.interlace ? r = _filterZero(r, e, 0, i, o) : 1 == e.interlace && (r = function _readInterlace(e, t1) {
            const r = t1.width, i = t1.height, o = _getBPP(t1), a = o >> 3, s = Math.ceil(r * o / 8), f = new Uint8Array(i * s);
            let l = 0;
            const c = [
                0,
                0,
                4,
                0,
                2,
                0,
                1
            ], u = [
                0,
                4,
                0,
                2,
                0,
                1,
                0
            ], h = [
                8,
                8,
                8,
                4,
                4,
                2,
                2
            ], d = [
                8,
                8,
                4,
                4,
                2,
                2,
                1
            ];
            let A = 0;
            for(; A < 7;){
                const p = h[A], m = d[A];
                let w = 0, v = 0, b = c[A];
                for(; b < i;)b += p, v++;
                let y = u[A];
                for(; y < r;)y += m, w++;
                const E = Math.ceil(w * o / 8);
                _filterZero(e, t1, l, w, v);
                let F = 0, _ = c[A];
                for(; _ < i;){
                    let t1 = u[A], i = l + F * E << 3;
                    for(; t1 < r;){
                        var g;
                        if (1 == o) g = (g = e[i >> 3]) >> 7 - (7 & i) & 1, f[_ * s + (t1 >> 3)] |= g << 7 - ((7 & t1) << 0);
                        if (2 == o) g = (g = e[i >> 3]) >> 6 - (7 & i) & 3, f[_ * s + (t1 >> 2)] |= g << 6 - ((3 & t1) << 1);
                        if (4 == o) g = (g = e[i >> 3]) >> 4 - (7 & i) & 15, f[_ * s + (t1 >> 1)] |= g << 4 - ((1 & t1) << 2);
                        if (o >= 8) {
                            const r = _ * s + t1 * a;
                            for(let t1 = 0; t1 < a; t1++)f[r + t1] = e[(i >> 3) + t1];
                        }
                        i += o, t1 += m;
                    }
                    F++, _ += p;
                }
                w * v != 0 && (l += v * (1 + E)), A += 1;
            }
            return f;
        }(r, e)), r;
    }
    function _inflate(e, r) {
        return t1(new Uint8Array(e.buffer, 2, e.length - 6), r);
    }
    var t1 = function() {
        const e = {
            H: {}
        };
        return e.H.N = function(t1, r) {
            const i = Uint8Array;
            let o, a, s = 0, f = 0, l = 0, c = 0, u = 0, h = 0, d = 0, A = 0, g = 0;
            if (3 == t1[0] && 0 == t1[1]) return r || new i(0);
            const p = e.H, m = p.b, w = p.e, v = p.R, b = p.n, y = p.A, E = p.Z, F = p.m, _ = null == r;
            for(_ && (r = new i(t1.length >>> 2 << 5)); 0 == s;)if (s = m(t1, g, 1), f = m(t1, g + 1, 2), g += 3, 0 != f) {
                if (_ && (r = e.H.W(r, A + 131072)), 1 == f && (o = F.J, a = F.h, h = 511, d = 31), 2 == f) {
                    l = w(t1, g, 5) + 257, c = w(t1, g + 5, 5) + 1, u = w(t1, g + 10, 4) + 4, g += 14;
                    let e = 1;
                    for(var B = 0; B < 38; B += 2)F.Q[B] = 0, F.Q[B + 1] = 0;
                    for(B = 0; B < u; B++){
                        const r = w(t1, g + 3 * B, 3);
                        F.Q[1 + (F.X[B] << 1)] = r, r > e && (e = r);
                    }
                    g += 3 * u, b(F.Q, e), y(F.Q, e, F.u), o = F.w, a = F.d, g = v(F.u, (1 << e) - 1, l + c, t1, g, F.v);
                    const r = p.V(F.v, 0, l, F.C);
                    h = (1 << r) - 1;
                    const i = p.V(F.v, l, c, F.D);
                    d = (1 << i) - 1, b(F.C, r), y(F.C, r, o), b(F.D, i), y(F.D, i, a);
                }
                for(;;){
                    const e = o[E(t1, g) & h];
                    g += 15 & e;
                    const i = e >>> 4;
                    if (i >>> 8 == 0) r[A++] = i;
                    else {
                        if (256 == i) break;
                        {
                            let e = A + i - 254;
                            if (i > 264) {
                                const r = F.q[i - 257];
                                e = A + (r >>> 3) + w(t1, g, 7 & r), g += 7 & r;
                            }
                            const o = a[E(t1, g) & d];
                            g += 15 & o;
                            const s = o >>> 4, f = F.c[s], l = (f >>> 4) + m(t1, g, 15 & f);
                            for(g += 15 & f; A < e;)r[A] = r[A++ - l], r[A] = r[A++ - l], r[A] = r[A++ - l], r[A] = r[A++ - l];
                            A = e;
                        }
                    }
                }
            } else {
                0 != (7 & g) && (g += 8 - (7 & g));
                const o = 4 + (g >>> 3), a = t1[o - 4] | t1[o - 3] << 8;
                _ && (r = e.H.W(r, A + a)), r.set(new i(t1.buffer, t1.byteOffset + o, a), A), g = o + a << 3, A += a;
            }
            return r.length == A ? r : r.slice(0, A);
        }, e.H.W = function(e, t1) {
            const r = e.length;
            if (t1 <= r) return e;
            const i = new Uint8Array(r << 1);
            return i.set(e, 0), i;
        }, e.H.R = function(t1, r, i, o, a, s) {
            const f = e.H.e, l = e.H.Z;
            let c = 0;
            for(; c < i;){
                const e = t1[l(o, a) & r];
                a += 15 & e;
                const i = e >>> 4;
                if (i <= 15) s[c] = i, c++;
                else {
                    let e = 0, t1 = 0;
                    16 == i ? (t1 = 3 + f(o, a, 2), a += 2, e = s[c - 1]) : 17 == i ? (t1 = 3 + f(o, a, 3), a += 3) : 18 == i && (t1 = 11 + f(o, a, 7), a += 7);
                    const r = c + t1;
                    for(; c < r;)s[c] = e, c++;
                }
            }
            return a;
        }, e.H.V = function(e, t1, r, i) {
            let o = 0, a = 0;
            const s = i.length >>> 1;
            for(; a < r;){
                const r = e[a + t1];
                i[a << 1] = 0, i[1 + (a << 1)] = r, r > o && (o = r), a++;
            }
            for(; a < s;)i[a << 1] = 0, i[1 + (a << 1)] = 0, a++;
            return o;
        }, e.H.n = function(t1, r) {
            const i = e.H.m, o = t1.length;
            let a, s, f;
            let l;
            const c = i.j;
            for(var u = 0; u <= r; u++)c[u] = 0;
            for(u = 1; u < o; u += 2)c[t1[u]]++;
            const h = i.K;
            for(a = 0, c[0] = 0, s = 1; s <= r; s++)a = a + c[s - 1] << 1, h[s] = a;
            for(f = 0; f < o; f += 2)l = t1[f + 1], 0 != l && (t1[f] = h[l], h[l]++);
        }, e.H.A = function(t1, r, i) {
            const o = t1.length, a = e.H.m.r;
            for(let e = 0; e < o; e += 2)if (0 != t1[e + 1]) {
                const o = e >> 1, s = t1[e + 1], f = o << 4 | s, l = r - s;
                let c = t1[e] << l;
                const u = c + (1 << l);
                for(; c != u;)i[a[c] >>> 15 - r] = f, c++;
            }
        }, e.H.l = function(t1, r) {
            const i = e.H.m.r, o = 15 - r;
            for(let e = 0; e < t1.length; e += 2){
                const a = t1[e] << r - t1[e + 1];
                t1[e] = i[a] >>> o;
            }
        }, e.H.M = function(e, t1, r) {
            r <<= 7 & t1;
            const i = t1 >>> 3;
            e[i] |= r, e[i + 1] |= r >>> 8;
        }, e.H.I = function(e, t1, r) {
            r <<= 7 & t1;
            const i = t1 >>> 3;
            e[i] |= r, e[i + 1] |= r >>> 8, e[i + 2] |= r >>> 16;
        }, e.H.e = function(e, t1, r) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8) >>> (7 & t1) & (1 << r) - 1;
        }, e.H.b = function(e, t1, r) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1) & (1 << r) - 1;
        }, e.H.Z = function(e, t1) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16) >>> (7 & t1);
        }, e.H.i = function(e, t1) {
            return (e[t1 >>> 3] | e[1 + (t1 >>> 3)] << 8 | e[2 + (t1 >>> 3)] << 16 | e[3 + (t1 >>> 3)] << 24) >>> (7 & t1);
        }, e.H.m = function() {
            const e = Uint16Array, t1 = Uint32Array;
            return {
                K: new e(16),
                j: new e(16),
                X: [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ],
                S: [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    999,
                    999,
                    999
                ],
                T: [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0,
                    0,
                    0,
                    0
                ],
                q: new e(32),
                p: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    65535,
                    65535
                ],
                z: [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13,
                    0,
                    0
                ],
                c: new t1(32),
                J: new e(512),
                _: [],
                h: new e(32),
                $: [],
                w: new e(32768),
                C: [],
                v: [],
                d: new e(32768),
                D: [],
                u: new e(512),
                Q: [],
                r: new e(32768),
                s: new t1(286),
                Y: new t1(30),
                a: new t1(19),
                t: new t1(15e3),
                k: new e(65536),
                g: new e(32768)
            };
        }(), function() {
            const t1 = e.H.m;
            for(var r = 0; r < 32768; r++){
                let e = r;
                e = (2863311530 & e) >>> 1 | (1431655765 & e) << 1, e = (3435973836 & e) >>> 2 | (858993459 & e) << 2, e = (4042322160 & e) >>> 4 | (252645135 & e) << 4, e = (4278255360 & e) >>> 8 | (16711935 & e) << 8, t1.r[r] = (e >>> 16 | e << 16) >>> 17;
            }
            function n(e, t1, r) {
                for(; 0 != t1--;)e.push(0, r);
            }
            for(r = 0; r < 32; r++)t1.q[r] = t1.S[r] << 3 | t1.T[r], t1.c[r] = t1.p[r] << 4 | t1.z[r];
            n(t1._, 144, 8), n(t1._, 112, 9), n(t1._, 24, 7), n(t1._, 8, 8), e.H.n(t1._, 9), e.H.A(t1._, 9, t1.J), e.H.l(t1._, 9), n(t1.$, 32, 5), e.H.n(t1.$, 5), e.H.A(t1.$, 5, t1.h), e.H.l(t1.$, 5), n(t1.Q, 19, 0), n(t1.C, 286, 0), n(t1.D, 30, 0), n(t1.v, 320, 0);
        }(), e.H.N;
    }();
    function _getBPP(e) {
        return [
            1,
            null,
            3,
            1,
            2,
            null,
            4
        ][e.ctype] * e.depth;
    }
    function _filterZero(e, t1, r, i, o) {
        let a = _getBPP(t1);
        const s = Math.ceil(i * a / 8);
        let f, l;
        a = Math.ceil(a / 8);
        let c = e[r], u = 0;
        if (c > 1 && (e[r] = [
            0,
            0,
            1
        ][c - 2]), 3 == c) for(u = a; u < s; u++)e[u + 1] = e[u + 1] + (e[u + 1 - a] >>> 1) & 255;
        for(let t1 = 0; t1 < o; t1++)if (f = r + t1 * s, l = f + t1 + 1, c = e[l - 1], u = 0, 0 == c) for(; u < s; u++)e[f + u] = e[l + u];
        else if (1 == c) {
            for(; u < a; u++)e[f + u] = e[l + u];
            for(; u < s; u++)e[f + u] = e[l + u] + e[f + u - a];
        } else if (2 == c) for(; u < s; u++)e[f + u] = e[l + u] + e[f + u - s];
        else if (3 == c) {
            for(; u < a; u++)e[f + u] = e[l + u] + (e[f + u - s] >>> 1);
            for(; u < s; u++)e[f + u] = e[l + u] + (e[f + u - s] + e[f + u - a] >>> 1);
        } else {
            for(; u < a; u++)e[f + u] = e[l + u] + _paeth(0, e[f + u - s], 0);
            for(; u < s; u++)e[f + u] = e[l + u] + _paeth(e[f + u - a], e[f + u - s], e[f + u - a - s]);
        }
        return e;
    }
    function _paeth(e, t1, r) {
        const i = e + t1 - r, o = i - e, a = i - t1, s = i - r;
        return o * o <= a * a && o * o <= s * s ? e : a * a <= s * s ? t1 : r;
    }
    function _IHDR(t1, r, i) {
        i.width = e.readUint(t1, r), r += 4, i.height = e.readUint(t1, r), r += 4, i.depth = t1[r], r++, i.ctype = t1[r], r++, i.compress = t1[r], r++, i.filter = t1[r], r++, i.interlace = t1[r], r++;
    }
    function _copyTile(e, t1, r, i, o, a, s, f, l) {
        const c = Math.min(t1, o), u = Math.min(r, a);
        let h = 0, d = 0;
        for(let r = 0; r < u; r++)for(let a = 0; a < c; a++)if (s >= 0 && f >= 0 ? (h = r * t1 + a << 2, d = (f + r) * o + s + a << 2) : (h = (-f + r) * t1 - s + a << 2, d = r * o + a << 2), 0 == l) i[d] = e[h], i[d + 1] = e[h + 1], i[d + 2] = e[h + 2], i[d + 3] = e[h + 3];
        else if (1 == l) {
            var A = e[h + 3] * (1 / 255), g = e[h] * A, p = e[h + 1] * A, m = e[h + 2] * A, w = i[d + 3] * (1 / 255), v = i[d] * w, b = i[d + 1] * w, y = i[d + 2] * w;
            const t1 = 1 - A, r = A + w * t1, o = 0 == r ? 0 : 1 / r;
            i[d + 3] = 255 * r, i[d + 0] = (g + v * t1) * o, i[d + 1] = (p + b * t1) * o, i[d + 2] = (m + y * t1) * o;
        } else if (2 == l) {
            A = e[h + 3], g = e[h], p = e[h + 1], m = e[h + 2], w = i[d + 3], v = i[d], b = i[d + 1], y = i[d + 2];
            A == w && g == v && p == b && m == y ? (i[d] = 0, i[d + 1] = 0, i[d + 2] = 0, i[d + 3] = 0) : (i[d] = g, i[d + 1] = p, i[d + 2] = m, i[d + 3] = A);
        } else if (3 == l) {
            A = e[h + 3], g = e[h], p = e[h + 1], m = e[h + 2], w = i[d + 3], v = i[d], b = i[d + 1], y = i[d + 2];
            if (A == w && g == v && p == b && m == y) continue;
            if (A < 220 && w > 20) return !1;
        }
        return !0;
    }
    return {
        decode: function decode(r) {
            const i = new Uint8Array(r);
            let o = 8;
            const a = e, s = a.readUshort, f = a.readUint, l = {
                tabs: {},
                frames: []
            }, c = new Uint8Array(i.length);
            let u, h = 0, d = 0;
            const A = [
                137,
                80,
                78,
                71,
                13,
                10,
                26,
                10
            ];
            for(var g = 0; g < 8; g++)if (i[g] != A[g]) throw "The input is not a PNG file!";
            for(; o < i.length;){
                const e = a.readUint(i, o);
                o += 4;
                const r = a.readASCII(i, o, 4);
                if (o += 4, "IHDR" == r) _IHDR(i, o, l);
                else if ("iCCP" == r) {
                    for(var p = o; 0 != i[p];)p++;
                    a.readASCII(i, o, p - o), i[p + 1];
                    const s = i.slice(p + 2, o + e);
                    let f = null;
                    try {
                        f = _inflate(s);
                    } catch (e) {
                        f = t1(s);
                    }
                    l.tabs[r] = f;
                } else if ("CgBI" == r) l.tabs[r] = i.slice(o, o + 4);
                else if ("IDAT" == r) {
                    for(g = 0; g < e; g++)c[h + g] = i[o + g];
                    h += e;
                } else if ("acTL" == r) l.tabs[r] = {
                    num_frames: f(i, o),
                    num_plays: f(i, o + 4)
                }, u = new Uint8Array(i.length);
                else if ("fcTL" == r) {
                    if (0 != d) (E = l.frames[l.frames.length - 1]).data = _decompress(l, u.slice(0, d), E.rect.width, E.rect.height), d = 0;
                    const e = {
                        x: f(i, o + 12),
                        y: f(i, o + 16),
                        width: f(i, o + 4),
                        height: f(i, o + 8)
                    };
                    let t1 = s(i, o + 22);
                    t1 = s(i, o + 20) / (0 == t1 ? 100 : t1);
                    const r = {
                        rect: e,
                        delay: Math.round(1e3 * t1),
                        dispose: i[o + 24],
                        blend: i[o + 25]
                    };
                    l.frames.push(r);
                } else if ("fdAT" == r) {
                    for(g = 0; g < e - 4; g++)u[d + g] = i[o + g + 4];
                    d += e - 4;
                } else if ("pHYs" == r) l.tabs[r] = [
                    a.readUint(i, o),
                    a.readUint(i, o + 4),
                    i[o + 8]
                ];
                else if ("cHRM" == r) {
                    l.tabs[r] = [];
                    for(g = 0; g < 8; g++)l.tabs[r].push(a.readUint(i, o + 4 * g));
                } else if ("tEXt" == r || "zTXt" == r) {
                    null == l.tabs[r] && (l.tabs[r] = {});
                    var m = a.nextZero(i, o), w = a.readASCII(i, o, m - o), v = o + e - m - 1;
                    if ("tEXt" == r) y = a.readASCII(i, m + 1, v);
                    else {
                        var b = _inflate(i.slice(m + 2, m + 2 + v));
                        y = a.readUTF8(b, 0, b.length);
                    }
                    l.tabs[r][w] = y;
                } else if ("iTXt" == r) {
                    null == l.tabs[r] && (l.tabs[r] = {});
                    m = 0, p = o;
                    m = a.nextZero(i, p);
                    w = a.readASCII(i, p, m - p);
                    const t1 = i[p = m + 1];
                    var y;
                    i[p + 1], p += 2, m = a.nextZero(i, p), a.readASCII(i, p, m - p), p = m + 1, m = a.nextZero(i, p), a.readUTF8(i, p, m - p);
                    v = e - ((p = m + 1) - o);
                    if (0 == t1) y = a.readUTF8(i, p, v);
                    else {
                        b = _inflate(i.slice(p, p + v));
                        y = a.readUTF8(b, 0, b.length);
                    }
                    l.tabs[r][w] = y;
                } else if ("PLTE" == r) l.tabs[r] = a.readBytes(i, o, e);
                else if ("hIST" == r) {
                    const e = l.tabs.PLTE.length / 3;
                    l.tabs[r] = [];
                    for(g = 0; g < e; g++)l.tabs[r].push(s(i, o + 2 * g));
                } else if ("tRNS" == r) 3 == l.ctype ? l.tabs[r] = a.readBytes(i, o, e) : 0 == l.ctype ? l.tabs[r] = s(i, o) : 2 == l.ctype && (l.tabs[r] = [
                    s(i, o),
                    s(i, o + 2),
                    s(i, o + 4)
                ]);
                else if ("gAMA" == r) l.tabs[r] = a.readUint(i, o) / 1e5;
                else if ("sRGB" == r) l.tabs[r] = i[o];
                else if ("bKGD" == r) 0 == l.ctype || 4 == l.ctype ? l.tabs[r] = [
                    s(i, o)
                ] : 2 == l.ctype || 6 == l.ctype ? l.tabs[r] = [
                    s(i, o),
                    s(i, o + 2),
                    s(i, o + 4)
                ] : 3 == l.ctype && (l.tabs[r] = i[o]);
                else if ("IEND" == r) break;
                o += e, a.readUint(i, o), o += 4;
            }
            var E;
            return 0 != d && ((E = l.frames[l.frames.length - 1]).data = _decompress(l, u.slice(0, d), E.rect.width, E.rect.height)), l.data = _decompress(l, c, l.width, l.height), delete l.compress, delete l.interlace, delete l.filter, l;
        },
        toRGBA8: function toRGBA8(e) {
            const t1 = e.width, r = e.height;
            if (null == e.tabs.acTL) return [
                decodeImage(e.data, t1, r, e).buffer
            ];
            const i = [];
            null == e.frames[0].data && (e.frames[0].data = e.data);
            const o = t1 * r * 4, a = new Uint8Array(o), s = new Uint8Array(o), f = new Uint8Array(o);
            for(let c = 0; c < e.frames.length; c++){
                const u = e.frames[c], h = u.rect.x, d = u.rect.y, A = u.rect.width, g = u.rect.height, p = decodeImage(u.data, A, g, e);
                if (0 != c) for(var l = 0; l < o; l++)f[l] = a[l];
                if (0 == u.blend ? _copyTile(p, A, g, a, t1, r, h, d, 0) : 1 == u.blend && _copyTile(p, A, g, a, t1, r, h, d, 1), i.push(a.buffer.slice(0)), 0 == u.dispose) ;
                else if (1 == u.dispose) _copyTile(s, A, g, a, t1, r, h, d, 0);
                else if (2 == u.dispose) for(l = 0; l < o; l++)a[l] = f[l];
            }
            return i;
        },
        _paeth: _paeth,
        _copyTile: _copyTile,
        _bin: e
    };
}();
!function() {
    const { _copyTile: e } = $8225ba78123222c8$var$UPNG, { _bin: t1 } = $8225ba78123222c8$var$UPNG, r = $8225ba78123222c8$var$UPNG._paeth;
    var i = {
        table: function() {
            const e = new Uint32Array(256);
            for(let t1 = 0; t1 < 256; t1++){
                let r = t1;
                for(let e = 0; e < 8; e++)1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
                e[t1] = r;
            }
            return e;
        }(),
        update (e, t1, r, o) {
            for(let a = 0; a < o; a++)e = i.table[255 & (e ^ t1[r + a])] ^ e >>> 8;
            return e;
        },
        crc: (e, t1, r)=>4294967295 ^ i.update(4294967295, e, t1, r)
    };
    function addErr(e, t1, r, i) {
        t1[r] += e[0] * i >> 4, t1[r + 1] += e[1] * i >> 4, t1[r + 2] += e[2] * i >> 4, t1[r + 3] += e[3] * i >> 4;
    }
    function N(e) {
        return Math.max(0, Math.min(255, e));
    }
    function D(e, t1) {
        const r = e[0] - t1[0], i = e[1] - t1[1], o = e[2] - t1[2], a = e[3] - t1[3];
        return r * r + i * i + o * o + a * a;
    }
    function dither(e, t1, r, i, o, a, s) {
        null == s && (s = 1);
        const f = i.length, l = [];
        for(var c = 0; c < f; c++){
            const e = i[c];
            l.push([
                e >>> 0 & 255,
                e >>> 8 & 255,
                e >>> 16 & 255,
                e >>> 24 & 255
            ]);
        }
        for(c = 0; c < f; c++){
            let e = 4294967295;
            for(var u = 0, h = 0; h < f; h++){
                var d = D(l[c], l[h]);
                h != c && d < e && (e = d, u = h);
            }
        }
        const A = new Uint32Array(o.buffer), g = new Int16Array(t1 * r * 4), p = [
            0,
            8,
            2,
            10,
            12,
            4,
            14,
            6,
            3,
            11,
            1,
            9,
            15,
            7,
            13,
            5
        ];
        for(c = 0; c < p.length; c++)p[c] = 255 * ((p[c] + .5) / 16 - .5);
        for(let o = 0; o < r; o++)for(let w = 0; w < t1; w++){
            var m;
            c = 4 * (o * t1 + w);
            if (2 != s) m = [
                N(e[c] + g[c]),
                N(e[c + 1] + g[c + 1]),
                N(e[c + 2] + g[c + 2]),
                N(e[c + 3] + g[c + 3])
            ];
            else {
                d = p[4 * (3 & o) + (3 & w)];
                m = [
                    N(e[c] + d),
                    N(e[c + 1] + d),
                    N(e[c + 2] + d),
                    N(e[c + 3] + d)
                ];
            }
            u = 0;
            let v = 16777215;
            for(h = 0; h < f; h++){
                const e = D(m, l[h]);
                e < v && (v = e, u = h);
            }
            const b = l[u], y = [
                m[0] - b[0],
                m[1] - b[1],
                m[2] - b[2],
                m[3] - b[3]
            ];
            1 == s && (w != t1 - 1 && addErr(y, g, c + 4, 7), o != r - 1 && (0 != w && addErr(y, g, c + 4 * t1 - 4, 3), addErr(y, g, c + 4 * t1, 5), w != t1 - 1 && addErr(y, g, c + 4 * t1 + 4, 1))), a[c >> 2] = u, A[c >> 2] = i[u];
        }
    }
    function _main(e, r, o, a, s) {
        null == s && (s = {});
        const { crc: f } = i, l = t1.writeUint, c = t1.writeUshort, u = t1.writeASCII;
        let h = 8;
        const d = e.frames.length > 1;
        let A, g = !1, p = 33 + (d ? 20 : 0);
        if (null != s.sRGB && (p += 13), null != s.pHYs && (p += 21), null != s.iCCP && (A = pako.deflate(s.iCCP), p += 21 + A.length + 4), 3 == e.ctype) {
            for(var m = e.plte.length, w = 0; w < m; w++)e.plte[w] >>> 24 != 255 && (g = !0);
            p += 8 + 3 * m + 4 + (g ? 8 + 1 * m + 4 : 0);
        }
        for(var v = 0; v < e.frames.length; v++)d && (p += 38), p += (F = e.frames[v]).cimg.length + 12, 0 != v && (p += 4);
        p += 12;
        const b = new Uint8Array(p), y = [
            137,
            80,
            78,
            71,
            13,
            10,
            26,
            10
        ];
        for(w = 0; w < 8; w++)b[w] = y[w];
        if (l(b, h, 13), h += 4, u(b, h, "IHDR"), h += 4, l(b, h, r), h += 4, l(b, h, o), h += 4, b[h] = e.depth, h++, b[h] = e.ctype, h++, b[h] = 0, h++, b[h] = 0, h++, b[h] = 0, h++, l(b, h, f(b, h - 17, 17)), h += 4, null != s.sRGB && (l(b, h, 1), h += 4, u(b, h, "sRGB"), h += 4, b[h] = s.sRGB, h++, l(b, h, f(b, h - 5, 5)), h += 4), null != s.iCCP) {
            const e = 13 + A.length;
            l(b, h, e), h += 4, u(b, h, "iCCP"), h += 4, u(b, h, "ICC profile"), h += 11, h += 2, b.set(A, h), h += A.length, l(b, h, f(b, h - (e + 4), e + 4)), h += 4;
        }
        if (null != s.pHYs && (l(b, h, 9), h += 4, u(b, h, "pHYs"), h += 4, l(b, h, s.pHYs[0]), h += 4, l(b, h, s.pHYs[1]), h += 4, b[h] = s.pHYs[2], h++, l(b, h, f(b, h - 13, 13)), h += 4), d && (l(b, h, 8), h += 4, u(b, h, "acTL"), h += 4, l(b, h, e.frames.length), h += 4, l(b, h, null != s.loop ? s.loop : 0), h += 4, l(b, h, f(b, h - 12, 12)), h += 4), 3 == e.ctype) {
            l(b, h, 3 * (m = e.plte.length)), h += 4, u(b, h, "PLTE"), h += 4;
            for(w = 0; w < m; w++){
                const t1 = 3 * w, r = e.plte[w], i = 255 & r, o = r >>> 8 & 255, a = r >>> 16 & 255;
                b[h + t1 + 0] = i, b[h + t1 + 1] = o, b[h + t1 + 2] = a;
            }
            if (h += 3 * m, l(b, h, f(b, h - 3 * m - 4, 3 * m + 4)), h += 4, g) {
                l(b, h, m), h += 4, u(b, h, "tRNS"), h += 4;
                for(w = 0; w < m; w++)b[h + w] = e.plte[w] >>> 24 & 255;
                h += m, l(b, h, f(b, h - m - 4, m + 4)), h += 4;
            }
        }
        let E = 0;
        for(v = 0; v < e.frames.length; v++){
            var F = e.frames[v];
            d && (l(b, h, 26), h += 4, u(b, h, "fcTL"), h += 4, l(b, h, E++), h += 4, l(b, h, F.rect.width), h += 4, l(b, h, F.rect.height), h += 4, l(b, h, F.rect.x), h += 4, l(b, h, F.rect.y), h += 4, c(b, h, a[v]), h += 2, c(b, h, 1e3), h += 2, b[h] = F.dispose, h++, b[h] = F.blend, h++, l(b, h, f(b, h - 30, 30)), h += 4);
            const t1 = F.cimg;
            l(b, h, (m = t1.length) + (0 == v ? 0 : 4)), h += 4;
            const r = h;
            u(b, h, 0 == v ? "IDAT" : "fdAT"), h += 4, 0 != v && (l(b, h, E++), h += 4), b.set(t1, h), h += m, l(b, h, f(b, r, h - r)), h += 4;
        }
        return l(b, h, 0), h += 4, u(b, h, "IEND"), h += 4, l(b, h, f(b, h - 4, 4)), h += 4, b.buffer;
    }
    function compressPNG(e, t1, r) {
        for(let i = 0; i < e.frames.length; i++){
            const o = e.frames[i];
            o.rect.width;
            const a = o.rect.height, s = new Uint8Array(a * o.bpl + a);
            o.cimg = _filterZero(o.img, a, o.bpp, o.bpl, s, t1, r);
        }
    }
    function compress(t1, r, i, o, a) {
        const s = a[0], f = a[1], l = a[2], c = a[3], u = a[4], h = a[5];
        let d = 6, A = 8, g = 255;
        for(var p = 0; p < t1.length; p++){
            const e = new Uint8Array(t1[p]);
            for(var m = e.length, w = 0; w < m; w += 4)g &= e[w + 3];
        }
        const v = 255 != g, b = function framize(t1, r, i, o, a, s) {
            const f = [];
            for(var l = 0; l < t1.length; l++){
                const h = new Uint8Array(t1[l]), A = new Uint32Array(h.buffer);
                var c;
                let g = 0, p = 0, m = r, w = i, v = o ? 1 : 0;
                if (0 != l) {
                    const b = s || o || 1 == l || 0 != f[l - 2].dispose ? 1 : 2;
                    let y = 0, E = 1e9;
                    for(let e = 0; e < b; e++){
                        var u = new Uint8Array(t1[l - 1 - e]);
                        const o = new Uint32Array(t1[l - 1 - e]);
                        let s = r, f = i, c = -1, h = -1;
                        for(let e = 0; e < i; e++)for(let t1 = 0; t1 < r; t1++)A[d = e * r + t1] != o[d] && (t1 < s && (s = t1), t1 > c && (c = t1), e < f && (f = e), e > h && (h = e));
                        -1 == c && (s = f = c = h = 0), a && (1 == (1 & s) && s--, 1 == (1 & f) && f--);
                        const v = (c - s + 1) * (h - f + 1);
                        v < E && (E = v, y = e, g = s, p = f, m = c - s + 1, w = h - f + 1);
                    }
                    u = new Uint8Array(t1[l - 1 - y]);
                    1 == y && (f[l - 1].dispose = 2), c = new Uint8Array(m * w * 4), e(u, r, i, c, m, w, -g, -p, 0), v = e(h, r, i, c, m, w, -g, -p, 3) ? 1 : 0, 1 == v ? _prepareDiff(h, r, i, c, {
                        x: g,
                        y: p,
                        width: m,
                        height: w
                    }) : e(h, r, i, c, m, w, -g, -p, 0);
                } else c = h.slice(0);
                f.push({
                    rect: {
                        x: g,
                        y: p,
                        width: m,
                        height: w
                    },
                    img: c,
                    blend: v,
                    dispose: 0
                });
            }
            if (o) for(l = 0; l < f.length; l++){
                if (1 == (A = f[l]).blend) continue;
                const e = A.rect, o = f[l - 1].rect, s = Math.min(e.x, o.x), c = Math.min(e.y, o.y), u = {
                    x: s,
                    y: c,
                    width: Math.max(e.x + e.width, o.x + o.width) - s,
                    height: Math.max(e.y + e.height, o.y + o.height) - c
                };
                f[l - 1].dispose = 1, l - 1 != 0 && _updateFrame(t1, r, i, f, l - 1, u, a), _updateFrame(t1, r, i, f, l, u, a);
            }
            let h = 0;
            if (1 != t1.length) for(var d = 0; d < f.length; d++){
                var A;
                h += (A = f[d]).rect.width * A.rect.height;
            }
            return f;
        }(t1, r, i, s, f, l), y = {}, E = [], F = [];
        if (0 != o) {
            const e = [];
            for(w = 0; w < b.length; w++)e.push(b[w].img.buffer);
            const t1 = function concatRGBA(e) {
                let t1 = 0;
                for(var r = 0; r < e.length; r++)t1 += e[r].byteLength;
                const i = new Uint8Array(t1);
                let o = 0;
                for(r = 0; r < e.length; r++){
                    const t1 = new Uint8Array(e[r]), a = t1.length;
                    for(let e = 0; e < a; e += 4){
                        let r = t1[e], a = t1[e + 1], s = t1[e + 2];
                        const f = t1[e + 3];
                        0 == f && (r = a = s = 0), i[o + e] = r, i[o + e + 1] = a, i[o + e + 2] = s, i[o + e + 3] = f;
                    }
                    o += a;
                }
                return i.buffer;
            }(e), r = quantize(t1, o);
            for(w = 0; w < r.plte.length; w++)E.push(r.plte[w].est.rgba);
            let i = 0;
            for(w = 0; w < b.length; w++){
                const e = (B = b[w]).img.length;
                var _ = new Uint8Array(r.inds.buffer, i >> 2, e >> 2);
                F.push(_);
                const t1 = new Uint8Array(r.abuf, i, e);
                h && dither(B.img, B.rect.width, B.rect.height, E, t1, _), B.img.set(t1), i += e;
            }
        } else for(p = 0; p < b.length; p++){
            var B = b[p];
            const e = new Uint32Array(B.img.buffer);
            var U = B.rect.width;
            m = e.length, _ = new Uint8Array(m);
            F.push(_);
            for(w = 0; w < m; w++){
                const t1 = e[w];
                if (0 != w && t1 == e[w - 1]) _[w] = _[w - 1];
                else if (w > U && t1 == e[w - U]) _[w] = _[w - U];
                else {
                    let e = y[t1];
                    if (null == e && (y[t1] = e = E.length, E.push(t1), E.length >= 300)) break;
                    _[w] = e;
                }
            }
        }
        const C = E.length;
        C <= 256 && 0 == u && (A = C <= 2 ? 1 : C <= 4 ? 2 : C <= 16 ? 4 : 8, A = Math.max(A, c));
        for(p = 0; p < b.length; p++){
            (B = b[p]).rect.x, B.rect.y;
            U = B.rect.width;
            const e = B.rect.height;
            let t1 = B.img;
            new Uint32Array(t1.buffer);
            let r = 4 * U, i = 4;
            if (C <= 256 && 0 == u) {
                r = Math.ceil(A * U / 8);
                var I = new Uint8Array(r * e);
                const o = F[p];
                for(let t1 = 0; t1 < e; t1++){
                    w = t1 * r;
                    const e = t1 * U;
                    if (8 == A) for(var Q = 0; Q < U; Q++)I[w + Q] = o[e + Q];
                    else if (4 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 1)] |= o[e + Q] << 4 - 4 * (1 & Q);
                    else if (2 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 2)] |= o[e + Q] << 6 - 2 * (3 & Q);
                    else if (1 == A) for(Q = 0; Q < U; Q++)I[w + (Q >> 3)] |= o[e + Q] << 7 - 1 * (7 & Q);
                }
                t1 = I, d = 3, i = 1;
            } else if (0 == v && 1 == b.length) {
                I = new Uint8Array(U * e * 3);
                const o = U * e;
                for(w = 0; w < o; w++){
                    const e = 3 * w, r = 4 * w;
                    I[e] = t1[r], I[e + 1] = t1[r + 1], I[e + 2] = t1[r + 2];
                }
                t1 = I, d = 2, i = 3, r = 3 * U;
            }
            B.img = t1, B.bpl = r, B.bpp = i;
        }
        return {
            ctype: d,
            depth: A,
            plte: E,
            frames: b
        };
    }
    function _updateFrame(t1, r, i, o, a, s, f) {
        const l = Uint8Array, c = Uint32Array, u = new l(t1[a - 1]), h = new c(t1[a - 1]), d = a + 1 < t1.length ? new l(t1[a + 1]) : null, A = new l(t1[a]), g = new c(A.buffer);
        let p = r, m = i, w = -1, v = -1;
        for(let e = 0; e < s.height; e++)for(let t1 = 0; t1 < s.width; t1++){
            const i = s.x + t1, f = s.y + e, l = f * r + i, c = g[l];
            0 == c || 0 == o[a - 1].dispose && h[l] == c && (null == d || 0 != d[4 * l + 3]) || (i < p && (p = i), i > w && (w = i), f < m && (m = f), f > v && (v = f));
        }
        -1 == w && (p = m = w = v = 0), f && (1 == (1 & p) && p--, 1 == (1 & m) && m--), s = {
            x: p,
            y: m,
            width: w - p + 1,
            height: v - m + 1
        };
        const b = o[a];
        b.rect = s, b.blend = 1, b.img = new Uint8Array(s.width * s.height * 4), 0 == o[a - 1].dispose ? (e(u, r, i, b.img, s.width, s.height, -s.x, -s.y, 0), _prepareDiff(A, r, i, b.img, s)) : e(A, r, i, b.img, s.width, s.height, -s.x, -s.y, 0);
    }
    function _prepareDiff(t1, r, i, o, a) {
        e(t1, r, i, o, a.width, a.height, -a.x, -a.y, 2);
    }
    function _filterZero(e, t1, r, i, o, a, s) {
        const f = [];
        let l, c = [
            0,
            1,
            2,
            3,
            4
        ];
        -1 != a ? c = [
            a
        ] : (t1 * i > 5e5 || 1 == r) && (c = [
            0
        ]), s && (l = {
            level: 0
        });
        const u = $8225ba78123222c8$var$UZIP;
        for(var h = 0; h < c.length; h++){
            for(let a = 0; a < t1; a++)_filterLine(o, e, a, i, r, c[h]);
            f.push(u.deflate(o, l));
        }
        let d, A = 1e9;
        for(h = 0; h < f.length; h++)f[h].length < A && (d = h, A = f[h].length);
        return f[d];
    }
    function _filterLine(e, t1, i, o, a, s) {
        const f = i * o;
        let l = f + i;
        if (e[l] = s, l++, 0 == s) {
            if (o < 500) for(var c = 0; c < o; c++)e[l + c] = t1[f + c];
            else e.set(new Uint8Array(t1.buffer, f, o), l);
        } else if (1 == s) {
            for(c = 0; c < a; c++)e[l + c] = t1[f + c];
            for(c = a; c < o; c++)e[l + c] = t1[f + c] - t1[f + c - a] + 256 & 255;
        } else if (0 == i) {
            for(c = 0; c < a; c++)e[l + c] = t1[f + c];
            if (2 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c];
            if (3 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c] - (t1[f + c - a] >> 1) + 256 & 255;
            if (4 == s) for(c = a; c < o; c++)e[l + c] = t1[f + c] - r(t1[f + c - a], 0, 0) + 256 & 255;
        } else {
            if (2 == s) for(c = 0; c < o; c++)e[l + c] = t1[f + c] + 256 - t1[f + c - o] & 255;
            if (3 == s) {
                for(c = 0; c < a; c++)e[l + c] = t1[f + c] + 256 - (t1[f + c - o] >> 1) & 255;
                for(c = a; c < o; c++)e[l + c] = t1[f + c] + 256 - (t1[f + c - o] + t1[f + c - a] >> 1) & 255;
            }
            if (4 == s) {
                for(c = 0; c < a; c++)e[l + c] = t1[f + c] + 256 - r(0, t1[f + c - o], 0) & 255;
                for(c = a; c < o; c++)e[l + c] = t1[f + c] + 256 - r(t1[f + c - a], t1[f + c - o], t1[f + c - a - o]) & 255;
            }
        }
    }
    function quantize(e, t1) {
        const r = new Uint8Array(e), i = r.slice(0), o = new Uint32Array(i.buffer), a = getKDtree(i, t1), s = a[0], f = a[1], l = r.length, c = new Uint8Array(l >> 2);
        let u;
        if (r.length < 2e7) for(var h = 0; h < l; h += 4)u = getNearest(s, d = r[h] * (1 / 255), A = r[h + 1] * (1 / 255), g = r[h + 2] * (1 / 255), p = r[h + 3] * (1 / 255)), c[h >> 2] = u.ind, o[h >> 2] = u.est.rgba;
        else for(h = 0; h < l; h += 4){
            var d = r[h] * (1 / 255), A = r[h + 1] * (1 / 255), g = r[h + 2] * (1 / 255), p = r[h + 3] * (1 / 255);
            for(u = s; u.left;)u = planeDst(u.est, d, A, g, p) <= 0 ? u.left : u.right;
            c[h >> 2] = u.ind, o[h >> 2] = u.est.rgba;
        }
        return {
            abuf: i.buffer,
            inds: c,
            plte: f
        };
    }
    function getKDtree(e, t1, r) {
        null == r && (r = 1e-4);
        const i = new Uint32Array(e.buffer), o = {
            i0: 0,
            i1: e.length,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        o.bst = stats(e, o.i0, o.i1), o.est = estats(o.bst);
        const a = [
            o
        ];
        for(; a.length < t1;){
            let t1 = 0, o = 0;
            for(var s = 0; s < a.length; s++)a[s].est.L > t1 && (t1 = a[s].est.L, o = s);
            if (t1 < r) break;
            const f = a[o], l = splitPixels(e, i, f.i0, f.i1, f.est.e, f.est.eMq255);
            if (f.i0 >= l || f.i1 <= l) {
                f.est.L = 0;
                continue;
            }
            const c = {
                i0: f.i0,
                i1: l,
                bst: null,
                est: null,
                tdst: 0,
                left: null,
                right: null
            };
            c.bst = stats(e, c.i0, c.i1), c.est = estats(c.bst);
            const u = {
                i0: l,
                i1: f.i1,
                bst: null,
                est: null,
                tdst: 0,
                left: null,
                right: null
            };
            u.bst = {
                R: [],
                m: [],
                N: f.bst.N - c.bst.N
            };
            for(s = 0; s < 16; s++)u.bst.R[s] = f.bst.R[s] - c.bst.R[s];
            for(s = 0; s < 4; s++)u.bst.m[s] = f.bst.m[s] - c.bst.m[s];
            u.est = estats(u.bst), f.left = c, f.right = u, a[o] = c, a.push(u);
        }
        a.sort((e, t1)=>t1.bst.N - e.bst.N);
        for(s = 0; s < a.length; s++)a[s].ind = s;
        return [
            o,
            a
        ];
    }
    function getNearest(e, t1, r, i, o) {
        if (null == e.left) return e.tdst = function dist(e, t1, r, i, o) {
            const a = t1 - e[0], s = r - e[1], f = i - e[2], l = o - e[3];
            return a * a + s * s + f * f + l * l;
        }(e.est.q, t1, r, i, o), e;
        const a = planeDst(e.est, t1, r, i, o);
        let s = e.left, f = e.right;
        a > 0 && (s = e.right, f = e.left);
        const l = getNearest(s, t1, r, i, o);
        if (l.tdst <= a * a) return l;
        const c = getNearest(f, t1, r, i, o);
        return c.tdst < l.tdst ? c : l;
    }
    function planeDst(e, t1, r, i, o) {
        const { e: a } = e;
        return a[0] * t1 + a[1] * r + a[2] * i + a[3] * o - e.eMq;
    }
    function splitPixels(e, t1, r, i, o, a) {
        for(i -= 4; r < i;){
            for(; vecDot(e, r, o) <= a;)r += 4;
            for(; vecDot(e, i, o) > a;)i -= 4;
            if (r >= i) break;
            const s = t1[r >> 2];
            t1[r >> 2] = t1[i >> 2], t1[i >> 2] = s, r += 4, i -= 4;
        }
        for(; vecDot(e, r, o) > a;)r -= 4;
        return r + 4;
    }
    function vecDot(e, t1, r) {
        return e[t1] * r[0] + e[t1 + 1] * r[1] + e[t1 + 2] * r[2] + e[t1 + 3] * r[3];
    }
    function stats(e, t1, r) {
        const i = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], o = [
            0,
            0,
            0,
            0
        ], a = r - t1 >> 2;
        for(let a = t1; a < r; a += 4){
            const t1 = e[a] * (1 / 255), r = e[a + 1] * (1 / 255), s = e[a + 2] * (1 / 255), f = e[a + 3] * (1 / 255);
            o[0] += t1, o[1] += r, o[2] += s, o[3] += f, i[0] += t1 * t1, i[1] += t1 * r, i[2] += t1 * s, i[3] += t1 * f, i[5] += r * r, i[6] += r * s, i[7] += r * f, i[10] += s * s, i[11] += s * f, i[15] += f * f;
        }
        return i[4] = i[1], i[8] = i[2], i[9] = i[6], i[12] = i[3], i[13] = i[7], i[14] = i[11], {
            R: i,
            m: o,
            N: a
        };
    }
    function estats(e) {
        const { R: t1 } = e, { m: r } = e, { N: i } = e, a = r[0], s = r[1], f = r[2], l = r[3], c = 0 == i ? 0 : 1 / i, u = [
            t1[0] - a * a * c,
            t1[1] - a * s * c,
            t1[2] - a * f * c,
            t1[3] - a * l * c,
            t1[4] - s * a * c,
            t1[5] - s * s * c,
            t1[6] - s * f * c,
            t1[7] - s * l * c,
            t1[8] - f * a * c,
            t1[9] - f * s * c,
            t1[10] - f * f * c,
            t1[11] - f * l * c,
            t1[12] - l * a * c,
            t1[13] - l * s * c,
            t1[14] - l * f * c,
            t1[15] - l * l * c
        ], h = u, d = o;
        let A = [
            Math.random(),
            Math.random(),
            Math.random(),
            Math.random()
        ], g = 0, p = 0;
        if (0 != i) for(let e = 0; e < 16 && (A = d.multVec(h, A), p = Math.sqrt(d.dot(A, A)), A = d.sml(1 / p, A), !(0 != e && Math.abs(p - g) < 1e-9)); e++)g = p;
        const m = [
            a * c,
            s * c,
            f * c,
            l * c
        ];
        return {
            Cov: u,
            q: m,
            e: A,
            L: g,
            eMq255: d.dot(d.sml(255, m), A),
            eMq: d.dot(A, m),
            rgba: (Math.round(255 * m[3]) << 24 | Math.round(255 * m[2]) << 16 | Math.round(255 * m[1]) << 8 | Math.round(255 * m[0]) << 0) >>> 0
        };
    }
    var o = {
        multVec: (e, t1)=>[
                e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3],
                e[4] * t1[0] + e[5] * t1[1] + e[6] * t1[2] + e[7] * t1[3],
                e[8] * t1[0] + e[9] * t1[1] + e[10] * t1[2] + e[11] * t1[3],
                e[12] * t1[0] + e[13] * t1[1] + e[14] * t1[2] + e[15] * t1[3]
            ],
        dot: (e, t1)=>e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3],
        sml: (e, t1)=>[
                e * t1[0],
                e * t1[1],
                e * t1[2],
                e * t1[3]
            ]
    };
    $8225ba78123222c8$var$UPNG.encode = function encode(e, t1, r, i, o, a, s) {
        null == i && (i = 0), null == s && (s = !1);
        const f = compress(e, t1, r, i, [
            !1,
            !1,
            !1,
            0,
            s,
            !1
        ]);
        return compressPNG(f, -1), _main(f, t1, r, o, a);
    }, $8225ba78123222c8$var$UPNG.encodeLL = function encodeLL(e, t1, r, i, o, a, s, f) {
        const l = {
            ctype: 0 + (1 == i ? 0 : 2) + (0 == o ? 0 : 4),
            depth: a,
            frames: []
        }, c = (i + o) * a, u = c * t1;
        for(let i = 0; i < e.length; i++)l.frames.push({
            rect: {
                x: 0,
                y: 0,
                width: t1,
                height: r
            },
            img: new Uint8Array(e[i]),
            blend: 0,
            dispose: 1,
            bpp: Math.ceil(c / 8),
            bpl: Math.ceil(u / 8)
        });
        return compressPNG(l, 0, !0), _main(l, t1, r, s, f);
    }, $8225ba78123222c8$var$UPNG.encode.compress = compress, $8225ba78123222c8$var$UPNG.encode.dither = dither, $8225ba78123222c8$var$UPNG.quantize = quantize, $8225ba78123222c8$var$UPNG.quantize.getKDtree = getKDtree, $8225ba78123222c8$var$UPNG.quantize.getNearest = getNearest;
}();
const $8225ba78123222c8$var$r = {
    toArrayBuffer (e, t1) {
        const i = e.width, o = e.height, a = i << 2, s = e.getContext("2d").getImageData(0, 0, i, o), f = new Uint32Array(s.data.buffer), l = (32 * i + 31) / 32 << 2, c = l * o, u = 122 + c, h = new ArrayBuffer(u), d = new DataView(h), A = 1048576;
        let g, p, m, w, v = A, b = 0, y = 0, E = 0;
        function set16(e) {
            d.setUint16(y, e, !0), y += 2;
        }
        function set32(e) {
            d.setUint32(y, e, !0), y += 4;
        }
        function seek(e) {
            y += e;
        }
        set16(19778), set32(u), seek(4), set32(122), set32(108), set32(i), set32(-o >>> 0), set16(1), set16(32), set32(3), set32(c), set32(2835), set32(2835), seek(8), set32(16711680), set32(65280), set32(255), set32(4278190080), set32(1466527264), function convert() {
            for(; b < o && v > 0;){
                for(w = 122 + b * l, g = 0; g < a;)v--, p = f[E++], m = p >>> 24, d.setUint32(w + g, p << 8 | m), g += 4;
                b++;
            }
            E < f.length ? (v = A, setTimeout(convert, $8225ba78123222c8$var$r._dly)) : t1(h);
        }();
    },
    toBlob (e, t1) {
        this.toArrayBuffer(e, (e)=>{
            t1(new Blob([
                e
            ], {
                type: "image/bmp"
            }));
        });
    },
    _dly: 9
};
var $8225ba78123222c8$var$i = {
    CHROME: "CHROME",
    FIREFOX: "FIREFOX",
    DESKTOP_SAFARI: "DESKTOP_SAFARI",
    IE: "IE",
    IOS: "IOS",
    ETC: "ETC"
}, $8225ba78123222c8$var$o = {
    [$8225ba78123222c8$var$i.CHROME]: 16384,
    [$8225ba78123222c8$var$i.FIREFOX]: 11180,
    [$8225ba78123222c8$var$i.DESKTOP_SAFARI]: 16384,
    [$8225ba78123222c8$var$i.IE]: 8192,
    [$8225ba78123222c8$var$i.IOS]: 4096,
    [$8225ba78123222c8$var$i.ETC]: 8192
};
const $8225ba78123222c8$var$a = "undefined" != typeof window, $8225ba78123222c8$var$s = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, $8225ba78123222c8$var$f = $8225ba78123222c8$var$a && window.cordova && window.cordova.require && window.cordova.require("cordova/modulemapper"), $8225ba78123222c8$var$CustomFile = ($8225ba78123222c8$var$a || $8225ba78123222c8$var$s) && ($8225ba78123222c8$var$f && $8225ba78123222c8$var$f.getOriginalSymbol(window, "File") || "undefined" != typeof File && File), $8225ba78123222c8$var$CustomFileReader = ($8225ba78123222c8$var$a || $8225ba78123222c8$var$s) && ($8225ba78123222c8$var$f && $8225ba78123222c8$var$f.getOriginalSymbol(window, "FileReader") || "undefined" != typeof FileReader && FileReader);
function $8225ba78123222c8$var$getFilefromDataUrl(e, t1, r = Date.now()) {
    return new Promise((i)=>{
        const o = e.split(","), a = o[0].match(/:(.*?);/)[1], s = globalThis.atob(o[1]);
        let f = s.length;
        const l = new Uint8Array(f);
        for(; f--;)l[f] = s.charCodeAt(f);
        const c = new Blob([
            l
        ], {
            type: a
        });
        c.name = t1, c.lastModified = r, i(c);
    });
}
function $8225ba78123222c8$var$getDataUrlFromFile(e) {
    return new Promise((t1, r)=>{
        const i = new $8225ba78123222c8$var$CustomFileReader;
        i.onload = ()=>t1(i.result), i.onerror = (e)=>r(e), i.readAsDataURL(e);
    });
}
function $8225ba78123222c8$var$loadImage(e) {
    return new Promise((t1, r)=>{
        const i = new Image;
        i.onload = ()=>t1(i), i.onerror = (e)=>r(e), i.src = e;
    });
}
function $8225ba78123222c8$var$getBrowserName() {
    if (void 0 !== $8225ba78123222c8$var$getBrowserName.cachedResult) return $8225ba78123222c8$var$getBrowserName.cachedResult;
    let e = $8225ba78123222c8$var$i.ETC;
    const { userAgent: t1 } = navigator;
    return /Chrom(e|ium)/i.test(t1) ? e = $8225ba78123222c8$var$i.CHROME : /iP(ad|od|hone)/i.test(t1) && /WebKit/i.test(t1) ? e = $8225ba78123222c8$var$i.IOS : /Safari/i.test(t1) ? e = $8225ba78123222c8$var$i.DESKTOP_SAFARI : /Firefox/i.test(t1) ? e = $8225ba78123222c8$var$i.FIREFOX : (/MSIE/i.test(t1) || !0 == !!document.documentMode) && (e = $8225ba78123222c8$var$i.IE), $8225ba78123222c8$var$getBrowserName.cachedResult = e, $8225ba78123222c8$var$getBrowserName.cachedResult;
}
function $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser(e, t1) {
    const r = $8225ba78123222c8$var$getBrowserName(), i = $8225ba78123222c8$var$o[r];
    let a = e, s = t1, f = a * s;
    const l = a > s ? s / a : a / s;
    for(; f > i * i;){
        const e = (i + a) / 2, t1 = (i + s) / 2;
        e < t1 ? (s = t1, a = t1 * l) : (s = e * l, a = e), f = a * s;
    }
    return {
        width: a,
        height: s
    };
}
function $8225ba78123222c8$var$getNewCanvasAndCtx(e, t1) {
    let r, i;
    try {
        if (r = new OffscreenCanvas(e, t1), i = r.getContext("2d"), null === i) throw new Error("getContext of OffscreenCanvas returns null");
    } catch (e) {
        r = document.createElement("canvas"), i = r.getContext("2d");
    }
    return r.width = e, r.height = t1, [
        r,
        i
    ];
}
function $8225ba78123222c8$var$drawImageInCanvas(e, t1) {
    const { width: r, height: i } = $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser(e.width, e.height), [o, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i);
    return t1 && /jpe?g/.test(t1) && (a.fillStyle = "white", a.fillRect(0, 0, o.width, o.height)), a.drawImage(e, 0, 0, o.width, o.height), o;
}
function $8225ba78123222c8$var$isIOS() {
    return void 0 !== $8225ba78123222c8$var$isIOS.cachedResult || ($8225ba78123222c8$var$isIOS.cachedResult = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "undefined" != typeof document && "ontouchend" in document), $8225ba78123222c8$var$isIOS.cachedResult;
}
function $8225ba78123222c8$var$drawFileInCanvas(e, t1 = {}) {
    return new Promise(function(r, o) {
        let a, s;
        var $Try_2_Post = function() {
            try {
                return s = $8225ba78123222c8$var$drawImageInCanvas(a, t1.fileType || e.type), r([
                    a,
                    s
                ]);
            } catch (e) {
                return o(e);
            }
        }, $Try_2_Catch = function(t1) {
            try {
                var $Try_3_Catch = function(e) {
                    try {
                        throw e;
                    } catch (e) {
                        return o(e);
                    }
                };
                try {
                    let t1;
                    return $8225ba78123222c8$var$getDataUrlFromFile(e).then(function(e) {
                        try {
                            return t1 = e, $8225ba78123222c8$var$loadImage(t1).then(function(e) {
                                try {
                                    return a = e, function() {
                                        try {
                                            return $Try_2_Post();
                                        } catch (e) {
                                            return o(e);
                                        }
                                    }();
                                } catch (e) {
                                    return $Try_3_Catch(e);
                                }
                            }, $Try_3_Catch);
                        } catch (e) {
                            return $Try_3_Catch(e);
                        }
                    }, $Try_3_Catch);
                } catch (e) {
                    $Try_3_Catch(e);
                }
            } catch (e) {
                return o(e);
            }
        };
        try {
            if ($8225ba78123222c8$var$isIOS() || [
                $8225ba78123222c8$var$i.DESKTOP_SAFARI,
                $8225ba78123222c8$var$i.MOBILE_SAFARI
            ].includes($8225ba78123222c8$var$getBrowserName())) throw new Error("Skip createImageBitmap on IOS and Safari");
            return createImageBitmap(e).then(function(e) {
                try {
                    return a = e, $Try_2_Post();
                } catch (e) {
                    return $Try_2_Catch();
                }
            }, $Try_2_Catch);
        } catch (e) {
            $Try_2_Catch();
        }
    });
}
function $8225ba78123222c8$var$canvasToFile(e, t1, i, o, a = 1) {
    return new Promise(function(s, f) {
        let l;
        if ("image/png" === t1) {
            let c, u, h;
            return c = e.getContext("2d"), { data: u } = c.getImageData(0, 0, e.width, e.height), h = $8225ba78123222c8$var$UPNG.encode([
                u.buffer
            ], e.width, e.height, 4096 * a), l = new Blob([
                h
            ], {
                type: t1
            }), l.name = i, l.lastModified = o, $If_4.call(this);
        }
        {
            if ("image/bmp" === t1) return new Promise((t1)=>$8225ba78123222c8$var$r.toBlob(e, t1)).then((function(e) {
                try {
                    return l = e, l.name = i, l.lastModified = o, $If_5.call(this);
                } catch (e) {
                    return f(e);
                }
            }).bind(this), f);
            {
                if ("function" == typeof OffscreenCanvas && e instanceof OffscreenCanvas) return e.convertToBlob({
                    type: t1,
                    quality: a
                }).then((function(e) {
                    try {
                        return l = e, l.name = i, l.lastModified = o, $If_6.call(this);
                    } catch (e) {
                        return f(e);
                    }
                }).bind(this), f);
                {
                    let d;
                    return d = e.toDataURL(t1, a), $8225ba78123222c8$var$getFilefromDataUrl(d, i, o).then((function(e) {
                        try {
                            return l = e, $If_6.call(this);
                        } catch (e) {
                            return f(e);
                        }
                    }).bind(this), f);
                }
                function $If_6() {
                    return $If_5.call(this);
                }
            }
            function $If_5() {
                return $If_4.call(this);
            }
        }
        function $If_4() {
            return s(l);
        }
    });
}
function $8225ba78123222c8$var$cleanupCanvasMemory(e) {
    e.width = 0, e.height = 0;
}
function $8225ba78123222c8$var$isAutoOrientationInBrowser() {
    return new Promise(function(e, t1) {
        let r, i, o, a, s;
        return void 0 !== $8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult ? e($8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult) : (r = "data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", $8225ba78123222c8$var$getFilefromDataUrl("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", "test.jpg", Date.now()).then(function(r) {
            try {
                return i = r, $8225ba78123222c8$var$drawFileInCanvas(i).then(function(r) {
                    try {
                        return o = r[1], $8225ba78123222c8$var$canvasToFile(o, i.type, i.name, i.lastModified).then(function(r) {
                            try {
                                return a = r, $8225ba78123222c8$var$cleanupCanvasMemory(o), $8225ba78123222c8$var$drawFileInCanvas(a).then(function(r) {
                                    try {
                                        return s = r[0], $8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult = 1 === s.width && 2 === s.height, e($8225ba78123222c8$var$isAutoOrientationInBrowser.cachedResult);
                                    } catch (e) {
                                        return t1(e);
                                    }
                                }, t1);
                            } catch (e) {
                                return t1(e);
                            }
                        }, t1);
                    } catch (e) {
                        return t1(e);
                    }
                }, t1);
            } catch (e) {
                return t1(e);
            }
        }, t1));
    });
}
function $8225ba78123222c8$var$getExifOrientation(e) {
    return new Promise((t1, r)=>{
        const i = new $8225ba78123222c8$var$CustomFileReader;
        i.onload = (e)=>{
            const r = new DataView(e.target.result);
            if (65496 != r.getUint16(0, !1)) return t1(-2);
            const i = r.byteLength;
            let o = 2;
            for(; o < i;){
                if (r.getUint16(o + 2, !1) <= 8) return t1(-1);
                const e = r.getUint16(o, !1);
                if (o += 2, 65505 == e) {
                    if (1165519206 != r.getUint32(o += 2, !1)) return t1(-1);
                    const e = 18761 == r.getUint16(o += 6, !1);
                    o += r.getUint32(o + 4, e);
                    const i = r.getUint16(o, e);
                    o += 2;
                    for(let a = 0; a < i; a++)if (274 == r.getUint16(o + 12 * a, e)) return t1(r.getUint16(o + 12 * a + 8, e));
                } else {
                    if (65280 != (65280 & e)) break;
                    o += r.getUint16(o, !1);
                }
            }
            return t1(-1);
        }, i.onerror = (e)=>r(e), i.readAsArrayBuffer(e);
    });
}
function $8225ba78123222c8$var$handleMaxWidthOrHeight(e, t1) {
    const { width: r } = e, { height: i } = e, { maxWidthOrHeight: o } = t1;
    let a, s = e;
    return isFinite(o) && (r > o || i > o) && ([s, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i), r > i ? (s.width = o, s.height = i / r * o) : (s.width = r / i * o, s.height = o), a.drawImage(e, 0, 0, s.width, s.height), $8225ba78123222c8$var$cleanupCanvasMemory(e)), s;
}
function $8225ba78123222c8$var$followExifOrientation(e, t1) {
    const { width: r } = e, { height: i } = e, [o, a] = $8225ba78123222c8$var$getNewCanvasAndCtx(r, i);
    switch(t1 > 4 && t1 < 9 ? (o.width = i, o.height = r) : (o.width = r, o.height = i), t1){
        case 2:
            a.transform(-1, 0, 0, 1, r, 0);
            break;
        case 3:
            a.transform(-1, 0, 0, -1, r, i);
            break;
        case 4:
            a.transform(1, 0, 0, -1, 0, i);
            break;
        case 5:
            a.transform(0, 1, 1, 0, 0, 0);
            break;
        case 6:
            a.transform(0, 1, -1, 0, i, 0);
            break;
        case 7:
            a.transform(0, -1, -1, 0, i, r);
            break;
        case 8:
            a.transform(0, -1, 1, 0, 0, r);
    }
    return a.drawImage(e, 0, 0, r, i), $8225ba78123222c8$var$cleanupCanvasMemory(e), o;
}
function $8225ba78123222c8$var$compress(e, t1, r = 0) {
    return new Promise(function(i, o) {
        let a, s, f, l, c, u, h, d, A, g, p, m, w, v, b, y, E, F, _, B;
        function incProgress(e = 5) {
            if (t1.signal && t1.signal.aborted) throw t1.signal.reason;
            a += e, t1.onProgress(Math.min(a, 100));
        }
        function setProgress(e) {
            if (t1.signal && t1.signal.aborted) throw t1.signal.reason;
            a = Math.min(Math.max(e, a), 100), t1.onProgress(a);
        }
        return a = r, s = t1.maxIteration || 10, f = 1024 * t1.maxSizeMB * 1024, incProgress(), $8225ba78123222c8$var$drawFileInCanvas(e, t1).then((function(r) {
            try {
                return [, l] = r, incProgress(), c = $8225ba78123222c8$var$handleMaxWidthOrHeight(l, t1), incProgress(), new Promise(function(r, i) {
                    var o;
                    if (!(o = t1.exifOrientation)) return $8225ba78123222c8$var$getExifOrientation(e).then((function(e) {
                        try {
                            return o = e, $If_2.call(this);
                        } catch (e) {
                            return i(e);
                        }
                    }).bind(this), i);
                    function $If_2() {
                        return r(o);
                    }
                    return $If_2.call(this);
                }).then((function(r) {
                    try {
                        return u = r, incProgress(), $8225ba78123222c8$var$isAutoOrientationInBrowser().then((function(r) {
                            try {
                                return h = r ? c : $8225ba78123222c8$var$followExifOrientation(c, u), incProgress(), d = t1.initialQuality || 1, A = t1.fileType || e.type, $8225ba78123222c8$var$canvasToFile(h, A, e.name, e.lastModified, d).then((function(r) {
                                    try {
                                        {
                                            if (g = r, incProgress(), p = g.size > f, m = g.size > e.size, !p && !m) return setProgress(100), i(g);
                                            var a;
                                            function $Loop_3() {
                                                if (s-- && (b > f || b > w)) {
                                                    let t1, r;
                                                    return t1 = B ? .95 * _.width : _.width, r = B ? .95 * _.height : _.height, [E, F] = $8225ba78123222c8$var$getNewCanvasAndCtx(t1, r), F.drawImage(_, 0, 0, t1, r), d *= "image/png" === A ? .85 : .95, $8225ba78123222c8$var$canvasToFile(E, A, e.name, e.lastModified, d).then(function(e) {
                                                        try {
                                                            return y = e, $8225ba78123222c8$var$cleanupCanvasMemory(_), _ = E, b = y.size, setProgress(Math.min(99, Math.floor((v - b) / (v - f) * 100))), $Loop_3;
                                                        } catch (e) {
                                                            return o(e);
                                                        }
                                                    }, o);
                                                }
                                                return [
                                                    1
                                                ];
                                            }
                                            return w = e.size, v = g.size, b = v, _ = h, B = !t1.alwaysKeepResolution && p, (a = (function(e) {
                                                for(; e;){
                                                    if (e.then) return void e.then(a, o);
                                                    try {
                                                        if (e.pop) {
                                                            if (e.length) return e.pop() ? $Loop_3_exit.call(this) : e;
                                                            e = $Loop_3;
                                                        } else e = e.call(this);
                                                    } catch (e) {
                                                        return o(e);
                                                    }
                                                }
                                            }).bind(this))($Loop_3);
                                            function $Loop_3_exit() {
                                                return $8225ba78123222c8$var$cleanupCanvasMemory(_), $8225ba78123222c8$var$cleanupCanvasMemory(E), $8225ba78123222c8$var$cleanupCanvasMemory(c), $8225ba78123222c8$var$cleanupCanvasMemory(h), $8225ba78123222c8$var$cleanupCanvasMemory(l), setProgress(100), i(y);
                                            }
                                        }
                                    } catch (u) {
                                        return o(u);
                                    }
                                }).bind(this), o);
                            } catch (e) {
                                return o(e);
                            }
                        }).bind(this), o);
                    } catch (e) {
                        return o(e);
                    }
                }).bind(this), o);
            } catch (e) {
                return o(e);
            }
        }).bind(this), o);
    });
}
const $8225ba78123222c8$var$l = "\nlet scriptImported = false\nself.addEventListener('message', async (e) => {\n  const { file, id, imageCompressionLibUrl, options } = e.data\n  options.onProgress = (progress) => self.postMessage({ progress, id })\n  try {\n    if (!scriptImported) {\n      // console.log('[worker] importScripts', imageCompressionLibUrl)\n      self.importScripts(imageCompressionLibUrl)\n      scriptImported = true\n    }\n    // console.log('[worker] self', self)\n    const compressedFile = await imageCompression(file, options)\n    self.postMessage({ file: compressedFile, id })\n  } catch (e) {\n    // console.error('[worker] error', e)\n    self.postMessage({ error: e.message + '\\n' + e.stack, id })\n  }\n})\n";
let $8225ba78123222c8$var$c;
function $8225ba78123222c8$var$compressOnWebWorker(e, t1) {
    return new Promise((r, i)=>{
        $8225ba78123222c8$var$c || ($8225ba78123222c8$var$c = function createWorkerScriptURL(e) {
            const t1 = [];
            return "function" == typeof e ? t1.push(`(${e})()`) : t1.push(e), URL.createObjectURL(new Blob(t1));
        }($8225ba78123222c8$var$l));
        const o = new Worker($8225ba78123222c8$var$c);
        o.addEventListener("message", function handler(e) {
            if (t1.signal && t1.signal.aborted) o.terminate();
            else if (void 0 === e.data.progress) {
                if (e.data.error) return i(new Error(e.data.error)), void o.terminate();
                r(e.data.file), o.terminate();
            } else t1.onProgress(e.data.progress);
        }), o.addEventListener("error", i), t1.signal && t1.signal.addEventListener("abort", ()=>{
            i(t1.signal.reason), o.terminate();
        }), o.postMessage({
            file: e,
            imageCompressionLibUrl: t1.libURL,
            options: {
                ...t1,
                onProgress: void 0,
                signal: void 0
            }
        });
    });
}
function $8225ba78123222c8$export$2e2bcd8739ae039(e, t1) {
    return new Promise(function(r, i) {
        let o, a, s, f, l, c;
        if (o = {
            ...t1
        }, s = 0, { onProgress: f } = o, o.maxSizeMB = o.maxSizeMB || Number.POSITIVE_INFINITY, l = "boolean" != typeof o.useWebWorker || o.useWebWorker, delete o.useWebWorker, o.onProgress = (e)=>{
            s = e, "function" == typeof f && f(s);
        }, !(e instanceof Blob || e instanceof $8225ba78123222c8$var$CustomFile)) return i(new Error("The file given is not an instance of Blob or File"));
        if (!/^image/.test(e.type)) return i(new Error("The file given is not an image"));
        if (c = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, !l || "function" != typeof Worker || c) return $8225ba78123222c8$var$compress(e, o).then((function(e) {
            try {
                return a = e, $If_4.call(this);
            } catch (e) {
                return i(e);
            }
        }).bind(this), i);
        var u = (function() {
            try {
                return $If_4.call(this);
            } catch (e) {
                return i(e);
            }
        }).bind(this), $Try_1_Catch = function(t1) {
            try {
                return $8225ba78123222c8$var$compress(e, o).then(function(e) {
                    try {
                        return a = e, u();
                    } catch (e) {
                        return i(e);
                    }
                }, i);
            } catch (e) {
                return i(e);
            }
        };
        try {
            return o.libURL = o.libURL || "https://cdn.jsdelivr.net/npm/browser-image-compression@2.0.2/dist/browser-image-compression.js", $8225ba78123222c8$var$compressOnWebWorker(e, o).then(function(e) {
                try {
                    return a = e, u();
                } catch (e) {
                    return $Try_1_Catch();
                }
            }, $Try_1_Catch);
        } catch (e) {
            $Try_1_Catch();
        }
        function $If_4() {
            try {
                a.name = e.name, a.lastModified = e.lastModified;
            } catch (e) {}
            try {
                o.preserveExif && "image/jpeg" === e.type && (!o.fileType || o.fileType && o.fileType === e.type) && (a = $8225ba78123222c8$var$copyExifWithoutOrientation(e, a));
            } catch (e) {}
            return r(a);
        }
    });
}
$8225ba78123222c8$export$2e2bcd8739ae039.getDataUrlFromFile = $8225ba78123222c8$var$getDataUrlFromFile, $8225ba78123222c8$export$2e2bcd8739ae039.getFilefromDataUrl = $8225ba78123222c8$var$getFilefromDataUrl, $8225ba78123222c8$export$2e2bcd8739ae039.loadImage = $8225ba78123222c8$var$loadImage, $8225ba78123222c8$export$2e2bcd8739ae039.drawImageInCanvas = $8225ba78123222c8$var$drawImageInCanvas, $8225ba78123222c8$export$2e2bcd8739ae039.drawFileInCanvas = $8225ba78123222c8$var$drawFileInCanvas, $8225ba78123222c8$export$2e2bcd8739ae039.canvasToFile = $8225ba78123222c8$var$canvasToFile, $8225ba78123222c8$export$2e2bcd8739ae039.getExifOrientation = $8225ba78123222c8$var$getExifOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.handleMaxWidthOrHeight = $8225ba78123222c8$var$handleMaxWidthOrHeight, $8225ba78123222c8$export$2e2bcd8739ae039.followExifOrientation = $8225ba78123222c8$var$followExifOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.cleanupCanvasMemory = $8225ba78123222c8$var$cleanupCanvasMemory, $8225ba78123222c8$export$2e2bcd8739ae039.isAutoOrientationInBrowser = $8225ba78123222c8$var$isAutoOrientationInBrowser, $8225ba78123222c8$export$2e2bcd8739ae039.approximateBelowMaximumCanvasSizeOfBrowser = $8225ba78123222c8$var$approximateBelowMaximumCanvasSizeOfBrowser, $8225ba78123222c8$export$2e2bcd8739ae039.copyExifWithoutOrientation = $8225ba78123222c8$var$copyExifWithoutOrientation, $8225ba78123222c8$export$2e2bcd8739ae039.getBrowserName = $8225ba78123222c8$var$getBrowserName, $8225ba78123222c8$export$2e2bcd8739ae039.version = "2.0.2";


var $39a7390a80231473$exports = {};
$39a7390a80231473$exports = import.meta.resolve("fzOqi");


const $1a6cd9663479e45c$var$aiImg = new URL($39a7390a80231473$exports).href;
var $7c87d5038c406b33$exports = {};
$7c87d5038c406b33$exports = import.meta.resolve("cEXr0");


const $1a6cd9663479e45c$var$cityImg = new URL($7c87d5038c406b33$exports).href;
var $fc50db9bc849340e$exports = {};
$fc50db9bc849340e$exports = import.meta.resolve("fnjEC");


const $1a6cd9663479e45c$var$ghibliImg = new URL($fc50db9bc849340e$exports).href;
var $2abec586563604e5$exports = {};
$2abec586563604e5$exports = import.meta.resolve("fVT9e");


const $1a6cd9663479e45c$var$giftcardImg = new URL($2abec586563604e5$exports).href;
var $93a95ff25253437b$exports = {};
$93a95ff25253437b$exports = import.meta.resolve("h28sK");


const $1a6cd9663479e45c$var$indianImg = new URL($93a95ff25253437b$exports).href;
var $58d6e09ea2e6482c$exports = {};
$58d6e09ea2e6482c$exports = import.meta.resolve("aj4rE");


const $1a6cd9663479e45c$var$natureImg = new URL($58d6e09ea2e6482c$exports).href;
var $fd85cf4b22a2ecf5$exports = {};
$fd85cf4b22a2ecf5$exports = import.meta.resolve("k0Br5");


const $1a6cd9663479e45c$var$picnicImg = new URL($fd85cf4b22a2ecf5$exports).href;
let $1a6cd9663479e45c$export$7a7e7f0c34e94296 = {};
let $1a6cd9663479e45c$export$793c2b1bc57c6254 = false;
// Memory Management: Track active Object URLs to revoke them later
let $1a6cd9663479e45c$var$activeObjectUrls = [];
// --- INDEXEDDB CONFIGURATION ---
const $1a6cd9663479e45c$var$DB_NAME = 'InaiyaLocalDB';
const $1a6cd9663479e45c$var$DB_VERSION = 2;
const $1a6cd9663479e45c$var$STORE_CONTENT = 'site_content';
const $1a6cd9663479e45c$var$STORE_PHOTOS = 'photos';
function $1a6cd9663479e45c$var$openDB() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open($1a6cd9663479e45c$var$DB_NAME, $1a6cd9663479e45c$var$DB_VERSION);
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains($1a6cd9663479e45c$var$STORE_CONTENT)) db.createObjectStore($1a6cd9663479e45c$var$STORE_CONTENT, {
                keyPath: 'id'
            });
            if (!db.objectStoreNames.contains($1a6cd9663479e45c$var$STORE_PHOTOS)) db.createObjectStore($1a6cd9663479e45c$var$STORE_PHOTOS, {
                keyPath: 'id',
                autoIncrement: true
            });
        };
        request.onsuccess = (event)=>resolve(event.target.result);
        request.onerror = (event)=>reject(new Error(`OpenDB Error: ${event.target.error}`));
    });
}
function $1a6cd9663479e45c$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        request.onsuccess = ()=>resolve(request.result);
        request.onerror = ()=>reject(request.error);
    });
}
function $1a6cd9663479e45c$var$cleanupMemory() {
    $1a6cd9663479e45c$var$activeObjectUrls.forEach((url)=>URL.revokeObjectURL(url));
    $1a6cd9663479e45c$var$activeObjectUrls = [];
}
/**
 * Generates the default JSON structure for the application.
 */ // function getDefaults() {
//     return {
//         homepage: {
//             mainImage: natureImg,
//             introMessage: 'Welcome to the world I created just for you to celebrate the wonderful person you are. It is a treasure to look back at our journey, our joys, and all the moments that make our life together so special. Every day with you is a new adventure, and I cherish every moment we share together. I love you more than words can say.',
//             relationshipTag: 'My Soulmate',
//             relationshipStart: '2020-01-01T00:00:00.000Z'
//         },
//         events: [
//             {
//                 date: '2023-09-10',
//                 title: 'Said "I Love You"',
//                 description: 'The moment I finally told you how I really felt. Best decision ever.',
//                 showYear: false,
//                 type: 'milestone'
//             },
//             {
//                 date: '2024-07-04',
//                 title: 'Beach Weekend',
//                 description: 'Watching the sunset together by the ocean. Pure magic.',
//                 showYear: true,
//                 type: 'trip'
//             }
//         ],
//         notes: [
//             { date: '2025-12-15', text: 'Plan surprise dinner for anniversary' }
//         ],
//         photoGallery: [
//             { image: cityImg, caption: "Love Proposal..." },
//             { image: natureImg }
//         ],
//         promises: {
//             intro: "I'll always be there for you, through every season of life. Here are my promises to you...",
//             promises: [
//                 'I promise to always make you laugh, even on the hardest days',
//                 'I promise to support your dreams and celebrate your victories'
//             ]
//         },
//         loveReasons: {
//             intro: "I could list hundreds of reasons why I love you, but here are just a few that make my heart full...",
//             reasons: [
//                 'The way you care so deeply about everyone around you',
//                 'Your adventurous spirit that makes life exciting'
//             ]
//         },
//         loveLanguages: {
//             intro: "They say there are many ways to say 'I love you', and this is how I speak my love to you.",
//             languages: [
//                 {
//                     name: 'Words of Affirmation',
//                     icon: 'fas fa-comments',
//                     description: 'Telling you how much you mean to me, complimenting you, and expressing my love through heartfelt words and messages.'
//                 },
//                 {
//                     name: 'Physical Touch',
//                     icon: 'fas fa-hand-holding-heart',
//                     description: 'Holding hands, warm hugs, and gentle kisses. Physical connection that reminds us we\'re always there for each other.'
//                 }
//             ]
//         },
//         bucketList: {
//             intro: "The future is bright and full of possibilities. Here's what I'm dreaming of experiencing with you.",
//             items: [
//                 {
//                     title: 'Go Skydiving',
//                     description: 'Experience the thrill of freefalling together and conquer our fears.',
//                     targetDate: '2026-08-15',
//                     icon: 'fas fa-parachute-box',
//                     completed: false
//                 }
//             ]
//         },
//         memoryBook: [
//             { date: '2023-05-14', message: 'Getting caught in the rain and laughing until our sides hurt. Pure joy.', author: 'Him' }
//         ],
//         playlist: {
//             intro: "Some songs that make me think of you and some are the soundtracks of our love story...",
//             songs: [
//                 {
//                     title: 'Make You Feel My Love',
//                     embedId: 'https://www.youtube.com/watch?v=zeVWTY31Vn8',
//                     note: 'I\'d do anything to make you happy'
//                 }
//             ]
//         },
//         videoMontage: {
//             intro: 'A special clip of our favorite moments together, for the person who means everything to me...',
//             fileId: 'https://www.youtube.com/watch?v=xdHx1YEsWwk'
//         },
//         surprise: {
//             title: "You're My Everything!",
//             message: "Every day with you is a gift. Thank you for being you, for loving me, and for making life so beautiful. I can't wait to create a million more memories with you. 💕",
//             image: giftcardImg,
//             wheelItems: ['Fancy Dinner', 'Movie Marathon', 'Couples Massage', 'Beach Picnic', 'Game Night', 'Cooking Together', 'Sunrise Hike', 'Wine Tasting']
//         }
//     };
// }
function $1a6cd9663479e45c$var$getDefaults() {
    return {
        homepage: {
            // Use the variable, not the string './images/nature.jpg'
            mainImage: $1a6cd9663479e45c$var$natureImg,
            introMessage: 'Welcome to the world I created just for you to celebrate the wonderful person you are. It is a treasure to look back at our journey, our joys, and all the moments that make our life together so special. Every day with you is a new adventure, and I cherish every moment we share together. I love you more than words can say.',
            relationshipTag: 'My Soulmate',
            relationshipStart: '2020-01-01T00:00:00.000Z'
        },
        events: [
            {
                date: '2023-09-10',
                title: 'Said "I Love You"',
                description: 'The moment I finally told you how I really felt. Best decision ever.',
                showYear: false,
                type: 'milestone'
            },
            {
                date: '2024-07-04',
                title: 'Beach Weekend',
                description: 'Watching the sunset together by the ocean. Pure magic.',
                showYear: true,
                type: 'trip'
            },
            {
                date: '2024-10-30',
                title: 'Cozy Fall Evening',
                description: 'Hot cocoa, blankets, and your favorite movie. Perfect winter night.',
                showYear: true,
                type: 'memory'
            }
        ],
        notes: [
            {
                date: '2025-12-15',
                text: 'Plan surprise dinner for anniversary'
            },
            {
                date: '2026-02-14',
                text: 'Book spa weekend for Valentine\'s Day'
            },
            {
                date: '2026-06-20',
                text: 'Research summer vacation destinations together'
            }
        ],
        photoGallery: [
            {
                "image": $1a6cd9663479e45c$var$cityImg,
                "caption": "Love Proposal..."
            },
            {
                "image": $1a6cd9663479e45c$var$natureImg
            },
            {
                "image": $1a6cd9663479e45c$var$picnicImg,
                "caption": "Sunday Evening..."
            },
            {
                "image": $1a6cd9663479e45c$var$aiImg
            },
            {
                "image": $1a6cd9663479e45c$var$ghibliImg
            },
            {
                "image": $1a6cd9663479e45c$var$indianImg
            }
        ],
        promises: {
            intro: "I'll always be there for you, through every season of life. Here are my promises to you...",
            promises: [
                'I promise to always make you laugh, even on the hardest days',
                'I promise to support your dreams and celebrate your victories',
                'I promise to always choose you, every single day'
            ]
        },
        loveReasons: {
            intro: "I could list hundreds of reasons why I love you, but here are just a few that make my heart full...",
            reasons: [
                'The way you care so deeply about everyone around you',
                'Your adventurous spirit that makes life exciting',
                'How comfortable I feel being completely myself with you'
            ]
        },
        loveLanguages: {
            intro: "They say there are many ways to say 'I love you', and this is how I speak my love to you.",
            languages: [
                {
                    name: 'Words of Affirmation',
                    icon: 'fas fa-comments',
                    description: 'Telling you how much you mean to me, complimenting you, and expressing my love through heartfelt words and messages.'
                },
                {
                    name: 'Physical Touch',
                    icon: 'fas fa-hand-holding-heart',
                    description: 'Holding hands, warm hugs, and gentle kisses. Physical connection that reminds us we\'re always there for each other.'
                },
                {
                    name: 'Gift Giving',
                    icon: 'fas fa-gift',
                    description: 'Thoughtful surprises that show I\'m always thinking of you - from your favorite snack to something that reminded me of us.'
                }
            ]
        },
        bucketList: {
            intro: "The future is bright and full of possibilities. Here's what I'm dreaming of experiencing with you.",
            items: [
                {
                    item: 'Go Skydiving',
                    description: 'Experience the thrill of freefalling together and conquer our fears.',
                    targetDate: '2026-08-15',
                    icon: 'fas fa-parachute-box',
                    completed: false
                },
                {
                    item: 'Watch Sunrise from a Mountain',
                    description: 'Hike up early and witness the world wake up from a beautiful peak.',
                    targetDate: '2024-09-20',
                    icon: 'fas fa-mountain-sun',
                    completed: true
                },
                {
                    item: 'Road Trip Across the Country',
                    description: 'Take a spontaneous adventure with no strict plans, just us and the open road.',
                    targetDate: '2027-06-01',
                    icon: 'fas fa-road',
                    completed: false
                }
            ]
        },
        memoryBook: [
            {
                date: '2023-05-14',
                message: 'Getting caught in the rain and laughing until our sides hurt. Pure joy.',
                author: 'Him'
            },
            {
                date: '2024-03-17',
                message: 'Building that bookshelf together and only arguing once. We make a great team!',
                author: 'Him'
            },
            {
                date: '2024-08-25',
                message: 'Your face when I told you I love your weird laugh - priceless and adorable.',
                author: 'Her'
            }
        ],
        playlist: {
            intro: "Some songs that make me think of you and some are the soundtracks of our love story...",
            songs: [
                {
                    title: '',
                    embedId: 'https://www.youtube.com/watch?v=EmsNH47y7Jo&pp=ygUZYWxsIHRpbWUgbG92ZSBzb25ncyB0YW1pbA%3D%3D',
                    note: 'Reminds me of our first date'
                },
                {
                    title: 'You are my everything',
                    embedId: 'https://www.youtube.com/watch?v=_NhwOcq_2Bw&pp=ygUbYWxsIHRpbWUgbG92ZSBzb25ncyBlbmdsaXNo',
                    note: 'Our song - reminds me of our first dance together'
                },
                {
                    title: 'Make You Feel My Love',
                    artist: 'Adele',
                    embedId: 'https://www.youtube.com/watch?v=zeVWTY31Vn8&pp=ygUZYWxsIHRpbWUgbG92ZSBzb25ncyBoaW5kaQ%3D%3D',
                    note: 'I\'d do anything to make you happy'
                }
            ]
        },
        videoMontage: {
            intro: 'A special clip of our favorite moments together, for the person who means everything to me...',
            fileId: 'https://www.youtube.com/watch?v=xdHx1YEsWwk&pp=ygUoQ2FydG9vbiByb21hbnRpYyB2aWRlb3MgZm9yIHJlbGF0aW9uc2hpcNIHCQkLCgGHKiGM7w%3D%3D'
        },
        surprise: {
            title: "You're My Everything!",
            message: "Every day with you is a gift. Thank you for being you, for loving me, and for making life so beautiful. I can't wait to create a million more memories with you. \uD83D\uDC95",
            image: $1a6cd9663479e45c$var$giftcardImg,
            wheelItems: [
                'Fancy Dinner',
                'Movie Marathon',
                'Couples Massage',
                'Beach Picnic',
                'Game Night',
                'Cooking Together',
                'Sunrise Hike',
                'Wine Tasting'
            ]
        }
    };
}
async function $1a6cd9663479e45c$export$1686aec5678ceb1c() {
    try {
        const db = await $1a6cd9663479e45c$var$openDB();
        // 1. Fetch Data
        const contentTx = db.transaction($1a6cd9663479e45c$var$STORE_CONTENT, 'readonly');
        const contentReq = contentTx.objectStore($1a6cd9663479e45c$var$STORE_CONTENT).get('main');
        const photosTx = db.transaction($1a6cd9663479e45c$var$STORE_PHOTOS, 'readonly');
        const photosReq = photosTx.objectStore($1a6cd9663479e45c$var$STORE_PHOTOS).getAll();
        const [contentResult, photosResult] = await Promise.all([
            $1a6cd9663479e45c$var$promisifyRequest(contentReq),
            $1a6cd9663479e45c$var$promisifyRequest(photosReq)
        ]);
        // 2. Clean up old memory before creating new blobs
        $1a6cd9663479e45c$var$cleanupMemory();
        const defaults = $1a6cd9663479e45c$var$getDefaults();
        if (contentResult && contentResult.content) {
            // RETURNING USER
            $1a6cd9663479e45c$export$7a7e7f0c34e94296 = (0, $9423fef94170f602$export$6969335ea1e4e77c)(defaults, contentResult.content);
            if (photosResult && photosResult.length > 0) {
                $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery = photosResult.map((p)=>{
                    let imageUrl = p.url;
                    if (p.blob) {
                        imageUrl = URL.createObjectURL(p.blob);
                        $1a6cd9663479e45c$var$activeObjectUrls.push(imageUrl);
                    }
                    return {
                        id: p.id,
                        image: imageUrl,
                        caption: p.caption
                    };
                });
                $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery.reverse();
            } else // FIX: Use defaults if no photos in DB
            $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery = defaults.photoGallery;
        } else {
            // FIRST RUN - Initialize DB
            console.log("Initializing new database...");
            $1a6cd9663479e45c$export$7a7e7f0c34e94296 = defaults;
            // Save main content
            const contentTx = db.transaction($1a6cd9663479e45c$var$STORE_CONTENT, 'readwrite');
            await $1a6cd9663479e45c$var$promisifyRequest(contentTx.objectStore($1a6cd9663479e45c$var$STORE_CONTENT).put({
                id: 'main',
                content: $1a6cd9663479e45c$export$7a7e7f0c34e94296
            }));
            // FIX: Insert default photos into IndexedDB
            if (defaults.photoGallery && defaults.photoGallery.length > 0) {
                const photoTx = db.transaction($1a6cd9663479e45c$var$STORE_PHOTOS, 'readwrite');
                const photoStore = photoTx.objectStore($1a6cd9663479e45c$var$STORE_PHOTOS);
                for (const photo of defaults.photoGallery)await $1a6cd9663479e45c$var$promisifyRequest(photoStore.add({
                    url: photo.image,
                    caption: photo.caption || '',
                    createdat: new Date().toISOString()
                }));
                console.log(`Initialized ${defaults.photoGallery.length} default photos`);
            }
        }
        $1a6cd9663479e45c$export$7a7e7f0c34e94296.SpouseName = window.SITE_CONFIG?.SpouseName || 'My Love';
        $1a6cd9663479e45c$export$793c2b1bc57c6254 = false;
    } catch (err) {
        console.error("Data Load Error:", err);
        $1a6cd9663479e45c$export$793c2b1bc57c6254 = true;
        throw err;
    }
}
async function $1a6cd9663479e45c$export$15d8621db9a88346(silent = false, showAlertFn) {
    if ($1a6cd9663479e45c$export$793c2b1bc57c6254) return {
        success: false,
        error: 'Global error state. Refresh page.'
    };
    try {
        const dataToSave = JSON.parse(JSON.stringify($1a6cd9663479e45c$export$7a7e7f0c34e94296));
        delete dataToSave.photoGallery; // Photos stored separately
        delete dataToSave.SpouseName; // Config based
        dataToSave.lastUpdated = new Date().toISOString();
        const db = await $1a6cd9663479e45c$var$openDB();
        const tx = db.transaction($1a6cd9663479e45c$var$STORE_CONTENT, 'readwrite');
        await $1a6cd9663479e45c$var$promisifyRequest(tx.objectStore($1a6cd9663479e45c$var$STORE_CONTENT).put({
            id: 'main',
            content: dataToSave
        }));
        if (!silent && showAlertFn) showAlertFn("Saved", "Changes saved to device.", true);
        return {
            success: true
        };
    } catch (err) {
        console.error('Save error:', err);
        if (showAlertFn) showAlertFn("Error", "Save failed.");
        return {
            success: false,
            error: err.message
        };
    }
}
async function $1a6cd9663479e45c$export$425019a80ecc179b() {
    try {
        const db = await $1a6cd9663479e45c$var$openDB();
        const tx = db.transaction([
            $1a6cd9663479e45c$var$STORE_CONTENT,
            $1a6cd9663479e45c$var$STORE_PHOTOS
        ], 'readwrite');
        tx.objectStore($1a6cd9663479e45c$var$STORE_CONTENT).clear();
        tx.objectStore($1a6cd9663479e45c$var$STORE_PHOTOS).clear();
        await new Promise((resolve, reject)=>{
            tx.oncomplete = ()=>resolve();
            tx.onerror = ()=>reject(tx.error);
        });
        $1a6cd9663479e45c$var$cleanupMemory();
        localStorage.removeItem('app_theme');
        localStorage.removeItem('app_edit_mode');
        return {
            success: true
        };
    } catch (error) {
        return {
            success: false,
            error: error.message
        };
    }
}
async function $1a6cd9663479e45c$export$2094c78cd5451031(file, caption) {
    if (!file) throw new Error('No file provided');
    try {
        const compressedFile = await (0, $8225ba78123222c8$export$2e2bcd8739ae039)(file, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920
        });
        const db = await $1a6cd9663479e45c$var$openDB();
        const tx = db.transaction($1a6cd9663479e45c$var$STORE_PHOTOS, 'readwrite');
        const newRecord = {
            blob: compressedFile,
            caption: caption || '',
            created_at: new Date().toISOString()
        };
        const id = await $1a6cd9663479e45c$var$promisifyRequest(tx.objectStore($1a6cd9663479e45c$var$STORE_PHOTOS).add(newRecord));
        const objectUrl = URL.createObjectURL(compressedFile);
        $1a6cd9663479e45c$var$activeObjectUrls.push(objectUrl);
        $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery.unshift({
            id: id,
            image: objectUrl,
            caption: caption || ''
        });
        return {
            success: true
        };
    } catch (error) {
        console.error('Error adding photo:', error);
        throw error;
    }
}
async function $1a6cd9663479e45c$export$10635228250a8e49(index, caption, newFile = null) {
    const photo = $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery[index];
    try {
        const db = await $1a6cd9663479e45c$var$openDB();
        const tx = db.transaction($1a6cd9663479e45c$var$STORE_PHOTOS, 'readwrite');
        const store = tx.objectStore($1a6cd9663479e45c$var$STORE_PHOTOS);
        const record = await $1a6cd9663479e45c$var$promisifyRequest(store.get(photo.id));
        if (record) {
            record.caption = caption || '';
            if (newFile) {
                const compressedFile = await (0, $8225ba78123222c8$export$2e2bcd8739ae039)(newFile, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1920
                });
                record.blob = compressedFile;
                record.url = null;
                if (photo.image.startsWith('blob:')) URL.revokeObjectURL(photo.image);
                const objectUrl = URL.createObjectURL(compressedFile);
                $1a6cd9663479e45c$var$activeObjectUrls.push(objectUrl);
                $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery[index].image = objectUrl;
            }
            await $1a6cd9663479e45c$var$promisifyRequest(store.put(record));
        }
        $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery[index].caption = caption || '';
        return {
            success: true
        };
    } catch (e) {
        console.error(e);
        throw e;
    }
}
function $1a6cd9663479e45c$export$7397bbb6aee3d43(newData) {
    $1a6cd9663479e45c$export$7a7e7f0c34e94296 = newData;
}
async function $1a6cd9663479e45c$export$24b331154e79a600(index) {
    const photo = $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery[index];
    try {
        const db = await $1a6cd9663479e45c$var$openDB();
        const tx = db.transaction($1a6cd9663479e45c$var$STORE_PHOTOS, 'readwrite');
        await $1a6cd9663479e45c$var$promisifyRequest(tx.objectStore($1a6cd9663479e45c$var$STORE_PHOTOS).delete(photo.id));
        if (photo.image.startsWith('blob:')) URL.revokeObjectURL(photo.image);
        $1a6cd9663479e45c$export$7a7e7f0c34e94296.photoGallery.splice(index, 1);
        return {
            success: true
        };
    } catch (e) {
        console.error(e);
        throw e;
    }
}
async function $1a6cd9663479e45c$export$994fda0f79164d5a(file) {
    const compressedFile = await (0, $8225ba78123222c8$export$2e2bcd8739ae039)(file, {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1000
    });
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
    });
}


// render.js
/**
 * ============================================================================
 * VIEW CONTROLLER / RENDER ENGINE (Local PWA Version)
 * ============================================================================
 * Handles generating HTML markup from the local data state.
 * * CHANGES FROM CLOUD VERSION:
 * - Removed Supabase Image Transformation parameters (e.g., ?width=500).
 * Local Blob URLs (blob:http://...) do not support query parameters.
 */ 

// ==========================================
// INTERNAL HELPERS
// ==========================================
function $4463b5b4a6e7ec34$var$getRawActionButtons(pageId) {
    const add = (ctx, text)=>`<button type="button" onclick="window.app.openModal('${pageId}', -1, '${ctx}')" class="btn btn-primary text-sm whitespace-nowrap hover:scale-105 transition-transform"><i class="fas fa-plus mr-2"></i>${text}</button>`;
    let buttons = '';
    if (pageId === 'journey') buttons = add('default', 'Add Event');
    if (pageId === 'gallery') buttons = add('default', 'Add Photo');
    if (pageId === 'allMyLove') buttons = add('loveLanguages', 'Language') + add('loveReasons', 'Reason');
    if (pageId === 'surprise') buttons = add('default', 'Add Item') + `<button type="button" onclick="window.app.openModal('wheel')" class="btn btn-secondary text-sm whitespace-nowrap ml-2"><i class="fas fa-dharmachakra mr-2"></i>Edit Wheel</button>`;
    if (pageId === 'promises') buttons = add('default', 'Add Promise');
    if (pageId === 'memories') buttons = add('memoryBook', 'Add Memory');
    if (pageId === 'playlist') buttons = add('default', 'Add Song');
    return buttons;
}
function $4463b5b4a6e7ec34$export$5999ca150006b0ea(pageId, navLinks) {
    const sectionTitle = navLinks.find((link)=>link.id === pageId)?.text || 'Page';
    const actionButtonsHtml = $4463b5b4a6e7ec34$var$getRawActionButtons(pageId);
    const editIntro = (ctx)=>`<button type="button" class="btn-icon text-base ml-2 edit-mode-only" onclick="window.app.openModal('${pageId}', -1, '${ctx}')" aria-label="Edit Intro"><i class="fas fa-edit"></i></button>`;
    let headerExtra = '';
    if ([
        'bucketList',
        'promises',
        'playlist',
        'allMyLove'
    ].includes(pageId)) headerExtra = editIntro('intro');
    if (pageId === 'video') headerExtra = editIntro('default');
    const header = pageId !== 'home' ? `
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 border-b pb-4 gap-4">
      <div class="flex items-center">
        <h2 class="text-2xl md:text-3xl font-bold">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(sectionTitle)}</h2>
        ${headerExtra}
      </div>
      ${actionButtonsHtml ? `<div class="flex flex-wrap gap-2 edit-mode-only self-start md:self-auto">${actionButtonsHtml}</div>` : ''}
    </div>
  ` : '';
    let content;
    switch(pageId){
        case 'home':
            content = $4463b5b4a6e7ec34$var$renderHomepage();
            break;
        case 'gallery':
            content = $4463b5b4a6e7ec34$var$renderGallery();
            break;
        case 'video':
            content = $4463b5b4a6e7ec34$var$renderVideoMontage();
            break;
        case 'allMyLove':
            content = $4463b5b4a6e7ec34$var$renderAllMyLovePage();
            break;
        case 'bucketList':
            content = $4463b5b4a6e7ec34$var$renderBucketListPage();
            break;
        case 'promises':
            content = $4463b5b4a6e7ec34$var$renderPromises();
            break;
        case 'memories':
            content = $4463b5b4a6e7ec34$var$renderMemoriesAndNotesPage();
            break;
        case 'playlist':
            content = $4463b5b4a6e7ec34$var$renderPlaylist();
            break;
        case 'surprise':
            content = $4463b5b4a6e7ec34$var$renderSurprise();
            break;
        case 'settings':
            content = $4463b5b4a6e7ec34$var$renderSettingsPage();
            break;
        default:
            content = `<div id="dynamic-content"></div>`;
    }
    return `<div class="card rounded-2xl shadow-lg p-6 md:p-8 relative min-h-[50vh]">${header}${content}</div>`;
}
// ==========================================
// SUB-RENDERERS
// ==========================================
function $4463b5b4a6e7ec34$var$renderHomepage() {
    const { homepage: homepage, SpouseName: SpouseName, events: events } = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296);
    const now = new Date();
    let title = '', subtitle = '';
    const hour = now.getHours();
    if (hour < 12) subtitle = `Good Morning, ${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(SpouseName)}!`;
    else if (hour < 18) subtitle = `Good Afternoon, ${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(SpouseName)}!`;
    else subtitle = `Good Evening, ${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(SpouseName)}!`;
    const todaysEvents = events.filter((e)=>{
        if (!e.date) return false;
        const eventMonthDay = e.date.slice(5, 10);
        const todayMonthDay = now.toISOString().slice(5, 10);
        if (e.showYear === false) return eventMonthDay === todayMonthDay;
        return e.date === now.toISOString().slice(0, 10);
    });
    if (todaysEvents.some((e)=>e.title.toLowerCase().includes('birthday'))) title = `<h1 class="text-4xl md:text-5xl font-bold mb-2 text-primary">\u{1F389} Happy Birthday, ${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(SpouseName)}! \u{1F389}</h1>`;
    const mobileHeader = `
    <div class="md:hidden flex items-center justify-center gap-3 mb-6 pb-4 border-b border-slate-100">
      <img src="${homepage.mainImage || 'https://placehold.co/100x100'}" class="w-12 h-12 rounded-full object-cover shadow-sm">
      <div class="text-left">
        <div class="font-bold text-lg leading-none">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(SpouseName)}</div>
        <div class="text-xs text-gray-400">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(homepage.relationshipTag || 'My Love')}</div>
      </div>
    </div>
  `;
    return `
    <div class="text-center pt-4">
      ${mobileHeader}
      ${title}
      <h2 class="text-2xl text-gray-500">${subtitle}</h2>
      <div class="relative max-w-3xl mx-auto mt-4">
        <img src="${homepage.mainImage || 'https://placehold.co/800x600/FFEAE3/432C39?text=Us'}" class="w-full h-96 object-cover rounded-xl shadow-lg mb-6" alt="Our Main Photo">
        <button class="absolute top-2 right-2 btn-icon bg-white/80 edit-mode-only" onclick="window.app.openModal('home', -1, 'default')" aria-label="Edit Home Photo"><i class="fas fa-edit"></i></button>
        <p class="text-lg leading-relaxed whitespace-pre-wrap">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(homepage.introMessage)}</p>
      </div>
      <div class="my-8 p-4 bg-soft rounded-xl inline-block max-w-full">
        <h4 class="text-lg font-bold mb-2 text-primary">\u{23F3} Relationship Clock</h4>
        <div id="relationship-timer" class="text-xl md:text-3xl font-bold text-slate-700 flex flex-wrap justify-center items-center gap-x-4 gap-y-1" aria-live="polite">Loading...</div>
        <div class="edit-mode-only mt-2"><button onclick="window.app.openModal('home', -1, 'timer')" class="text-xs underline text-gray-500">Edit Start Date</button></div>
      </div>
    </div>
  `;
}
function $4463b5b4a6e7ec34$var$renderGallery() {
    if (!(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery.length) return `<p class="text-center text-gray-500 italic py-10">No photos yet. Tap "Add Photo" to begin!</p>`;
    const slideshowBtn = `<div class="w-full flex justify-end mb-4"><button onclick="window.app.startSlideshowFromPage()" class="btn btn-primary shadow-md"><i class="fas fa-play mr-2"></i>Play Slideshow</button></div>`;
    return slideshowBtn + `<div class="grid grid-cols-1 md:grid-cols-3 gap-6">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery.map((p, i)=>`
      <div class="rounded-xl shadow-lg overflow-hidden group relative bg-white">
        <button type="button" class="w-full p-0 border-0 cursor-pointer" onclick="window.app.openImageModal(${i})">
          <!-- NOTE: No resizing params here. Used p.image directly for Blob URL support -->
          <img src="${p.image}" loading="lazy" class="w-full h-60 object-cover" alt="${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(p.caption)}">
        </button>
        <div class="absolute top-2 right-2 flex space-x-1 edit-mode-only">
          <button class="btn-icon bg-white/90 w-8 h-8 flex items-center justify-center" onclick="event.stopPropagation(); window.app.openModal('gallery', ${i})" aria-label="Edit Photo"><i class="fas fa-edit"></i></button>
          <button class="btn-icon bg-white/90 w-8 h-8 flex items-center justify-center" onclick="event.stopPropagation(); window.app.deleteItem('photoGallery', ${i})" aria-label="Delete Photo"><i class="fas fa-trash"></i></button>
        </div>
        <div class="p-4"><p class="text-sm truncate">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(p.caption)}</p></div>
      </div>
    `).join('')}</div>`;
}
function $4463b5b4a6e7ec34$var$renderVideoMontage() {
    const embedUrl = (0, $9423fef94170f602$export$719951a5f84653c6)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).videoMontage.fileId);
    return `
    <p class="mb-6">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).videoMontage.intro)}</p>
    <div class="aspect-w-16 aspect-h-9 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
      ${embedUrl ? `<iframe src="${embedUrl}" class="w-full h-[250px] md:h-[400px]" allowfullscreen title="YouTube Video"></iframe>` : `<p class="p-10 text-gray-500">No video URL set. Switch to Edit Mode to add a YouTube URL.</p>`}
    </div>
  `;
}
function $4463b5b4a6e7ec34$var$renderPromises() {
    return `
    <p class="mb-8 text-gray-600">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.intro)}</p>
    <div class="space-y-4">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.promises.map((p, i)=>`
        <div class="p-5 rounded-r-lg border-l-4 border-primary bg-soft flex justify-between items-start gap-4">
          <p class="italic flex-1 font-medium text-sm md:text-base">"${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(p)}"</p>
          <div class="flex space-x-2 shrink-0 edit-mode-only">
            <button class="btn-icon" onclick="window.app.openModal('promises', ${i})" aria-label="Edit Promise"><i class="fas fa-edit"></i></button>
            <button class="btn-icon" onclick="window.app.deleteItem('promises', ${i})" aria-label="Delete Promise"><i class="fas fa-trash"></i></button>
          </div>
        </div>
      `).join('')}</div>
  `;
}
function $4463b5b4a6e7ec34$var$renderPlaylist() {
    return `
    <p class="mb-6">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.intro)}</p>
    <div class="grid md:grid-cols-2 gap-6">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.songs.map((s, i)=>`
        <div class="bg-white p-4 rounded-lg shadow">
          <div class="flex justify-between mb-2">
            <h3 class="font-bold truncate pr-2">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(s.title)}</h3>
            <div class="edit-mode-only shrink-0">
              <button class="btn-icon" onclick="window.app.openModal('playlist', ${i})" aria-label="Edit Song"><i class="fas fa-edit"></i></button>
              <button class="btn-icon" onclick="window.app.deleteItem('playlist', ${i})" aria-label="Delete Song"><i class="fas fa-trash"></i></button>
            </div>
          </div>
          <iframe src="${(0, $9423fef94170f602$export$719951a5f84653c6)(s.embedId)}" class="w-full h-48 rounded" frameborder="0" allowfullscreen title="Song Embed"></iframe>
          <p class="text-sm mt-2 italic text-gray-600">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(s.note)}</p>
        </div>
      `).join('')}</div>
  `;
}
function $4463b5b4a6e7ec34$var$renderSurprise() {
    const wheelColors = [
        '#FFD1DC',
        '#E0F2FE',
        '#D1FAE5',
        '#FEF3C7',
        '#F3E8FF'
    ];
    const wheelItems = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise?.wheelItems?.length > 0 ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.wheelItems : [
        'Hug',
        'Kiss',
        'Date',
        'Walk'
    ];
    const sliceDeg = 360 / wheelItems.length;
    let gradient = 'conic-gradient(';
    wheelItems.forEach((_, i)=>{
        const color = wheelColors[i % wheelColors.length];
        gradient += `${color} ${i * sliceDeg}deg ${(i + 1) * sliceDeg}deg, `;
    });
    gradient = gradient.slice(0, -2) + ')';
    return `
    <div class="text-center">
      <div class="text-5xl mb-4">\u{1F381}</div>
      <h2 class="text-3xl md:text-4xl font-bold mb-4 text-primary">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.title)}</h2>
      <p class="text-lg mb-6 break-words text-gray-600">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.message)}</p>
      ${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.image ? `<img src="${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.image}" class="rounded-lg max-w-full md:max-w-md mx-auto shadow-lg mb-8" alt="Surprise">` : ''}

      <!-- Spin Wheel Section -->
      <div class="mt-8 p-6 bg-soft rounded-xl border border-pink-100">
        <h3 class="text-2xl font-bold mb-6 text-slate-700 text-center"> Let's play - Spin the wheel \u{1F3B2}</h3>
        <div class="wheel-container">
          <div class="wheel-arrow"></div>
          <div id="the-wheel" class="wheel" style="background: ${gradient}"></div>
          <div class="wheel-center"></div>
        </div>
        <button id="spin-btn" onclick="window.app.spinWheel()" class="btn btn-primary mt-8 px-8 mx-auto block"> Spin It!</button>
        <p id="wheel-result" class="mt-4 font-bold text-lg h-8 text-slate-700 text-center" aria-live="polite"></p>
      </div>
    </div>
  `;
}
function $4463b5b4a6e7ec34$var$renderAllMyLovePage() {
    return `<div>
    <h3 class="text-xl font-bold mb-4">\u{1F496} The Ways I Love You</h3>
    <p class="mb-6 text-gray-600">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.intro)}</p>
    <div class="grid gap-4 mb-10">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.languages.map((l, i)=>`
        <div class="bg-soft p-4 rounded flex items-start">
          <i class="${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(l.icon || 'fas fa-heart')} text-2xl w-10 text-primary mt-1 shrink-0" aria-hidden="true"></i>
          <div class="flex-1 min-w-0">
            <h4 class="font-bold truncate">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(l.name)}</h4>
            <p class="text-sm break-words">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(l.description)}</p>
          </div>
          <div class="edit-mode-only shrink-0 ml-2">
            <button class="btn-icon" onclick="window.app.openModal('loveLanguages', ${i})" aria-label="Edit"><i class="fas fa-edit"></i></button>
            <button class="btn-icon" onclick="window.app.deleteItem('loveLanguages', ${i})" aria-label="Delete"><i class="fas fa-trash"></i></button>
          </div>
        </div>
      `).join('')}</div>

    <div class="border-t pt-6">
      <div class="flex items-center gap-2 mb-4">
        <h3 class="text-xl font-bold">\u{1F498} A Few Reasons Why</h3>
        <button type="button" class="btn-icon text-base edit-mode-only" onclick="window.app.openModal('allMyLove', -1, 'loveReasonsIntro')" aria-label="Edit Introduction"><i class="fas fa-edit"></i></button>
      </div>
      <p class="mb-6 text-gray-600">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.intro)}</p>
      <ul class="space-y-3">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.reasons.map((r, i)=>`
          <li class="flex items-center bg-soft p-3 rounded">
            <span class="w-6 h-6 bg-white text-primary rounded-full flex items-center justify-center text-xs font-bold mr-3 shrink-0">${i + 1}</span>
            <span class="flex-1 break-words">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(r)}</span>
            <div class="edit-mode-only shrink-0">
              <button class="btn-icon" onclick="window.app.openModal('loveReasons', ${i})" aria-label="Edit"><i class="fas fa-edit"></i></button>
              <button class="btn-icon" onclick="window.app.deleteItem('loveReasons', ${i})" aria-label="Delete"><i class="fas fa-trash"></i></button>
            </div>
          </li>
        `).join('')}</ul>
    </div>
  </div>`;
}
function $4463b5b4a6e7ec34$var$renderMemoriesAndNotesPage() {
    const notesHtml = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).notes.map((note, index)=>`
    <div class="flex items-center p-3 rounded-lg bg-white border mb-2 shadow-sm">
      <input type="checkbox" onchange="window.app.toggleNote(${index})" ${note.done ? 'checked' : ''} class="h-5 w-5 text-primary rounded focus:ring-pink-500 shrink-0" aria-label="Mark as done">
      <span class="ml-3 flex-1 ${note.done ? 'line-through text-gray-400' : ''} break-words">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(note.text)}</span>
      <button class="btn-icon edit-mode-only shrink-0" onclick="window.app.deleteItem('notes', ${index})" aria-label="Delete note"><i class="fas fa-trash"></i></button>
    </div>
  `).join('');
    return `<div>
    <h3 class="text-xl font-bold mb-4">\u{1F4D6} Times Together</h3>
    <div class="space-y-4 mb-10">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).memoryBook.map((m, i)=>`
        <div class="p-4 bg-soft border-l-4 border-primary rounded relative">
          <p class="italic mb-2 text-sm md:text-base">"${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(m.message)}"</p>
          <p class="text-right font-bold text-sm"> - ${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(m.author)}</p>
          <div class="absolute top-2 right-2 edit-mode-only">
            <button class="btn-icon w-8 h-8" onclick="window.app.openModal('memoryBook', ${i})" aria-label="Edit Memory"><i class="fas fa-edit"></i></button>
            <button class="btn-icon w-8 h-8" onclick="window.app.deleteItem('memoryBook', ${i})" aria-label="Delete Memory"><i class="fas fa-trash"></i></button>
          </div>
        </div>
      `).join('')}</div>

    <div class="border-t pt-8">
      <h3 class="text-xl font-bold mb-4">\u{1F4DD} Our Notepad</h3>
      <div class="flex gap-2 mb-4 edit-mode-only">
        <input type="text" id="new-note-input" class="form-input flex-1" placeholder="Add a to-do...">
        <button id="add-note-btn" class="btn btn-primary">Add</button>
      </div>
      <div id="notes-list">${notesHtml}</div>
    </div>
  </div>`;
}
function $4463b5b4a6e7ec34$var$renderBucketListPage() {
    return `
    <p class="mb-8 text-gray-600">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.intro)}</p>
    <div class="space-y-4 mb-12">${(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.items.map((item, i)=>`
        <div class="p-5 rounded-lg bg-soft border border-slate-100">
          <div class="flex items-start">
            <i class="${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(item.icon || 'fas fa-star')} text-2xl w-8 text-primary mr-4 mt-1 shrink-0" aria-hidden="true"></i>
            <div class="flex-grow min-w-0">
              <h3 class="font-bold text-xl truncate">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(item.title)}</h3>
              <p class="text-gray-600 break-words">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(item.description)}</p>
            </div>
            <div class="flex space-x-1 edit-mode-only shrink-0">
              <button class="btn-icon" onclick="window.app.openModal('bucketList', ${i})" aria-label="Edit Item"><i class="fas fa-edit"></i></button>
              <button class="btn-icon" onclick="window.app.deleteItem('bucketList', ${i})" aria-label="Delete Item"><i class="fas fa-trash"></i></button>
            </div>
          </div>
          ${item.targetDate ? `
            <div class="mt-4 pt-4 border-t border-slate-200">
              <div class="countdown-container grid grid-cols-4 gap-2 text-center" data-countdown-target="${item.targetDate}">
                <div class="bg-white p-2 rounded shadow-sm"><div class="text-lg font-bold days">0</div><div class="text-xs">Days</div></div>
                <div class="bg-white p-2 rounded shadow-sm"><div class="text-lg font-bold hours">0</div><div class="text-xs">Hrs</div></div>
                <div class="bg-white p-2 rounded shadow-sm"><div class="text-lg font-bold minutes">0</div><div class="text-xs">Min</div></div>
                <div class="bg-white p-2 rounded shadow-sm"><div class="text-lg font-bold seconds">0</div><div class="text-xs">Sec</div></div>
              </div>
            </div>
          ` : ''}
        </div>
      `).join('')}</div>
  `;
}
function $4463b5b4a6e7ec34$var$renderSettingsPage() {
    const currentTheme = localStorage.getItem('app_theme') || 'default';
    const isEditMode = localStorage.getItem('app_edit_mode') === 'true';
    const themeOptions = {
        'default': {
            primary: '#FFEAE3',
            border: 'border-pink-200',
            name: "Rose \uD83C\uDF39"
        },
        'ocean': {
            primary: '#E0F2FE',
            border: 'border-blue-200',
            name: "Ocean \uD83C\uDF0A"
        },
        'nature': {
            primary: '#ECFCCB',
            border: 'border-green-200',
            name: "Nature \uD83C\uDF3F"
        },
        'lavender': {
            primary: '#F3E8FF',
            border: 'border-purple-200',
            name: "Lavender \uD83D\uDC9C"
        },
        'cherry': {
            primary: '#FFE4E6',
            border: 'border-red-200',
            name: "Cherry \uD83C\uDF52"
        },
        'sunshine': {
            primary: '#FEF9C3',
            border: 'border-yellow-200',
            name: "Sunshine \u2600\uFE0F"
        },
        'coral': {
            primary: '#FFEDD5',
            border: 'border-orange-200',
            name: "Coral \uD83E\uDDE1"
        },
        'teal': {
            primary: '#CCFBF1',
            border: 'border-teal-200',
            name: "Teal \uD83D\uDC9A"
        },
        'mocha': {
            primary: '#E7E5E4',
            border: 'border-stone-200',
            name: "Mocha \u2615"
        },
        'berry': {
            primary: '#FCE7F3',
            border: 'border-pink-300',
            name: "Berry \uD83C\uDF77"
        }
    };
    const themeCircles = Object.entries(themeOptions).map(([key, { primary: primary, border: border, name: name }])=>{
        const isActive = key === currentTheme;
        const activeClass = isActive ? 'scale-110 ring-2 ring-offset-2 ring-primary' : '';
        return `
      <div class="text-center flex-shrink-0">
        <button onclick="window.app.applyTheme('${key}')" class="w-12 h-12 rounded-full ${border} border-2 shadow-sm transition-transform hover:scale-110 ${activeClass}" style="background-color: ${primary}" aria-label="${name}" title="${name}"></button>
        <p class="text-xs mt-2 text-gray-500">${name}</p>
      </div>
    `;
    }).join('');
    const toggleBgClass = isEditMode ? 'peer-checked:bg-green-500 bg-red-500' : 'peer-checked:bg-green-500 bg-red-500';
    const toggleInitialClass = isEditMode ? 'bg-green-500' : 'bg-red-500';
    const toggleText = isEditMode ? "\uD83D\uDD13 Enabled" : "\uD83D\uDD12 Disabled";
    return `
    <div class="space-y-8">
      <div class="card p-6">
        <h3 class="text-2xl font-bold mb-4"><i class="fas fa-cog mr-2"></i>Edit Mode</h3>
        <p class="text-gray-600 mb-4">Enable to edit content.</p>
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" id="edit-mode-toggle" class="sr-only peer" ${isEditMode ? 'checked' : ''}>
          <div class="w-11 h-6 ${toggleInitialClass} peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-pink-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${toggleBgClass}"></div>
          <span class="ml-3 text-sm font-medium text-gray-700">${toggleText}</span>
        </label>
      </div>

      <div class="card p-8">
        <h3 class="text-2xl font-bold mb-4"><i class="fas fa-palette mr-2"></i>Theme</h3>
        <p class="text-gray-600 mb-6">Tap a circle to switch the vibe.</p>
        <div class="flex flex-row overflow-x-auto gap-4 p-4">
          ${themeCircles}
        </div>
      </div>

      <div class="card p-6">
        <h3 class="text-2xl font-bold mb-4"><i class="fas fa-file-export mr-2"></i>Data Management</h3>
        <p class="text-gray-600 mb-4">Export your data for backup or import previously saved data.</p>
        <div class="flex gap-3 flex-wrap">
          <button id="export-data-button" class="btn btn-primary" onclick="window.app.exportData()">
            <i class="fas fa-download mr-2"></i>Export Data
          </button>
          <button id="import-data-button" class="btn btn-secondary" onclick="document.getElementById('import-file-input').click()">
            <i class="fas fa-upload mr-2"></i>Import Data
          </button>
          <input type="file" id="import-file-input" accept=".json" class="hidden" onchange="window.app.importData(event)">
        </div>
      </div>

      <div class="card p-6 border-2 border-red-200">
        <h3 class="text-2xl font-bold mb-4 text-red-600"><i class="fas fa-exclamation-triangle mr-2"></i>Danger Zone</h3>
        <p class="text-gray-600 mb-4">Reset all data and start fresh. This action cannot be undone.</p>
        <button id="clear-data-button" class="btn bg-red-500 text-white hover:bg-red-600">
          <i class="fas fa-trash mr-2"></i>Reset All Data
        </button>
      </div>
    </div>
  `;
}
function $4463b5b4a6e7ec34$export$c1a8fd48acd59fbd(date) {
    const year = date.getFullYear(), month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    let grid = '';
    for(let i = 0; i < firstDay; i++)grid += `<div></div>`;
    for(let d = 1; d <= daysInMonth; d++){
        const iso = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
        const isToday = new Date().toISOString().slice(0, 10) === iso;
        const hasEvent = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events.some((e)=>{
            if (!e.date) return false;
            if (e.date === iso) return true;
            if (e.showYear === false && e.date.slice(5) === iso.slice(5)) return true;
            return false;
        });
        let cls = 'w-8 h-8 flex items-center justify-center rounded-full text-sm';
        if (isToday) cls += ' bg-primary text-white font-bold';
        else if (hasEvent) cls += ' bg-soft text-primary font-bold';
        grid += `<div class="flex justify-center"><div class="${cls}">${d}</div></div>`;
    }
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const monthOptions = months.map((m, i)=>`<option value="${i}" ${i === month ? 'selected' : ''}>${m}</option>`).join('');
    const currentYear = new Date().getFullYear();
    let yearOptions = '';
    for(let y = currentYear - 10; y <= currentYear + 10; y++)yearOptions += `<option value="${y}" ${y === year ? 'selected' : ''}>${y}</option>`;
    return `
    <div class="flex justify-between items-center mb-4 bg-soft p-2 rounded-lg">
      <button onclick="window.app.navigateMonth(-1)" class="btn-icon" aria-label="Previous Month"><i class="fas fa-chevron-left"></i></button>
      <div class="flex items-center gap-2">
        <select id="cal-month" class="calendar-select bg-transparent" aria-label="Select Month" onchange="window.app.jumpToDate()">${monthOptions}</select>
        <select id="cal-year" class="calendar-select bg-transparent" aria-label="Select Year" onchange="window.app.jumpToDate()">${yearOptions}</select>
      </div>
      <button onclick="window.app.navigateMonth(1)" class="btn-icon" aria-label="Next Month"><i class="fas fa-chevron-right"></i></button>
    </div>
    <div class="grid grid-cols-7 text-center text-xs text-gray-400 mb-2">
      <div>S</div><div>M</div><div>T</div><div>W</div><div>T</div><div>F</div><div>S</div>
    </div>
    <div class="grid grid-cols-7 gap-y-2">${grid}</div>
  `;
}
function $4463b5b4a6e7ec34$export$5ac06981e396d354() {
    const events = [
        ...(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events
    ].sort((a, b)=>b.date.localeCompare(a.date));
    return events.map((e)=>{
        const idx = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events.indexOf(e);
        const isRecurring = e.showYear === false;
        return `
      <div class="flex gap-4 mb-6">
        <div class="w-24 text-right text-sm text-primary font-bold pt-1 shrink-0">
          ${e.date || 'Someday'}
          ${isRecurring ? '<br><span class="text-xs text-gray-400 font-normal">Annual</span>' : ''}
        </div>
        <div class="border-l-2 border-slate-200 pl-4 pb-2 relative">
          <div class="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-soft border-2 border-white"></div>
          <h4 class="font-bold text-lg">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(e.title)}</h4>
          <p class="text-gray-600 text-sm">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(e.description)}</p>
          <div class="mt-2 flex gap-2 edit-mode-only">
            <button class="text-xs text-gray-400 hover:text-primary" onclick="window.app.openModal('journey', ${idx})">Edit</button>
            <button class="text-xs text-gray-400 hover:text-red-500" onclick="window.app.deleteItem('events', ${idx})">Delete</button>
          </div>
        </div>
      </div>
    `;
    }).join('');
}



// DOM Elements
const $efd3ba4ec2608b1d$var$mainContent = document.getElementById('main-content');
const $efd3ba4ec2608b1d$var$desktopNavContainer = document.getElementById('desktop-nav-items');
const $efd3ba4ec2608b1d$var$mobileNavContainer = document.getElementById('mobile-nav-items');
const $efd3ba4ec2608b1d$var$sidebarPhoto = document.getElementById('sidebar-spouse-photo');
const $efd3ba4ec2608b1d$var$sidebarName = document.getElementById('sidebar-spouse-name');
const $efd3ba4ec2608b1d$var$sidebarTag = document.getElementById('sidebar-spouse-tag');
const $efd3ba4ec2608b1d$var$formModalBackdrop = document.getElementById('form-modal-backdrop');
const $efd3ba4ec2608b1d$var$loginOverlay = document.getElementById('login-overlay');
const $efd3ba4ec2608b1d$var$passwordOverlay = document.getElementById('password-overlay');
const $efd3ba4ec2608b1d$var$appContainer = document.getElementById('app-container');
const $efd3ba4ec2608b1d$var$mobileNav = document.getElementById('mobile-nav');
// Themes
const $efd3ba4ec2608b1d$var$THEMES = {
    'default': {
        '--bg-light': '#FFF8F0',
        '--bg-soft': '#FFEAE3',
        '--primary': '#E8A0BF',
        '--accent': '#BA90C6',
        '--text-dark': '#432C39',
        '--text-light': '#6D5D6E'
    },
    'ocean': {
        '--bg-light': '#F0F9FF',
        '--bg-soft': '#E0F2FE',
        '--primary': '#38BDF8',
        '--accent': '#0284C7',
        '--text-dark': '#0C4A6E',
        '--text-light': '#475569'
    },
    'nature': {
        '--bg-light': '#F7FEE7',
        '--bg-soft': '#ECFCCB',
        '--primary': '#84CC16',
        '--accent': '#4D7C0F',
        '--text-dark': '#14532D',
        '--text-light': '#3F6212'
    },
    'lavender': {
        '--bg-light': '#FAF5FF',
        '--bg-soft': '#F3E8FF',
        '--primary': '#A855F7',
        '--accent': '#7E22CE',
        '--text-dark': '#3B0764',
        '--text-light': '#6B21A8'
    },
    'cherry': {
        '--bg-light': '#FFF1F2',
        '--bg-soft': '#FFE4E6',
        '--primary': '#FB7185',
        '--accent': '#E11D48',
        '--text-dark': '#881337',
        '--text-light': '#9F1239'
    },
    'sunshine': {
        '--bg-light': '#FEFCE8',
        '--bg-soft': '#FEF9C3',
        '--primary': '#FACC15',
        '--accent': '#CA8A04',
        '--text-dark': '#422006',
        '--text-light': '#713F12'
    },
    'coral': {
        '--bg-light': '#FFF7ED',
        '--bg-soft': '#FFEDD5',
        '--primary': '#FB923C',
        '--accent': '#EA580C',
        '--text-dark': '#431407',
        '--text-light': '#7C2D12'
    },
    'teal': {
        '--bg-light': '#F0FDFA',
        '--bg-soft': '#CCFBF1',
        '--primary': '#2DD4BF',
        '--accent': '#0D9488',
        '--text-dark': '#134E4A',
        '--text-light': '#115E59'
    },
    'mocha': {
        '--bg-light': '#F5F5F4',
        '--bg-soft': '#E7E5E4',
        '--primary': '#A8A29E',
        '--accent': '#57534E',
        '--text-dark': '#292524',
        '--text-light': '#44403C'
    },
    'berry': {
        '--bg-light': '#FDF2F8',
        '--bg-soft': '#FCE7F3',
        '--primary': '#F472B6',
        '--accent': '#DB2777',
        '--text-dark': '#500724',
        '--text-light': '#831843'
    }
};
let $efd3ba4ec2608b1d$var$isProcessingAuth = false;
let $efd3ba4ec2608b1d$var$countdownInterval, $efd3ba4ec2608b1d$var$relationshipInterval, $efd3ba4ec2608b1d$var$slideshowInterval;
let $efd3ba4ec2608b1d$var$currentCalendarDate = new Date();
let $efd3ba4ec2608b1d$var$galleryIndex = 0;
const $efd3ba4ec2608b1d$var$navLinks = [
    {
        id: 'home',
        icon: 'fas fa-heart',
        text: 'Home'
    },
    {
        id: 'journey',
        icon: 'fas fa-calendar-alt',
        text: 'Journey'
    },
    {
        id: 'gallery',
        icon: 'fas fa-images',
        text: 'Gallery'
    },
    {
        id: 'allMyLove',
        icon: 'fas fa-heart-pulse',
        text: 'All My Love'
    },
    {
        id: 'bucketList',
        icon: 'fas fa-map-signs',
        text: 'Bucket List'
    },
    {
        id: 'promises',
        icon: 'fas fa-hand-holding-heart',
        text: 'Promises'
    },
    {
        id: 'memories',
        icon: 'fas fa-book-open',
        text: 'Memories'
    },
    {
        id: 'playlist',
        icon: 'fas fa-music',
        text: 'Playlist'
    },
    {
        id: 'video',
        icon: 'fas fa-video',
        text: 'Video'
    },
    {
        id: 'surprise',
        icon: 'fas fa-gift',
        text: 'Surprise'
    },
    {
        id: 'settings',
        icon: 'fas fa-cog',
        text: 'Settings'
    }
];
async function $efd3ba4ec2608b1d$var$init() {
    console.log("Initializing Local PWA...");
    // Theme
    const savedTheme = localStorage.getItem('app_theme') || (window.SITE_CONFIG ? window.SITE_CONFIG.theme : 'default');
    if (savedTheme && $efd3ba4ec2608b1d$var$THEMES[savedTheme]) $efd3ba4ec2608b1d$var$applyThemeInternal(savedTheme);
    // Network listeners
    window.addEventListener('offline', ()=>$efd3ba4ec2608b1d$var$showCustomAlert("Connection Lost", "You are offline (Local mode active).", true));
    window.addEventListener('online', ()=>$efd3ba4ec2608b1d$var$showCustomAlert("Back Online", "Connection restored.", true));
    // Hash routing
    window.addEventListener('hashchange', ()=>{
        const page = window.location.hash.substring(1);
        const validPage = $efd3ba4ec2608b1d$var$navLinks.find((l)=>l.id === page) ? page : 'home';
        $efd3ba4ec2608b1d$var$navigateTo(validPage);
    });
    // EMERGENCY FIX: Always add 'loaded' class after a short delay
    setTimeout(()=>{
        document.body.classList.add('loaded');
    }, 100);
    // Check session
    if (sessionStorage.getItem('inaiya_session')) // Already has session, proceed
    $efd3ba4ec2608b1d$var$handleAuthenticatedState();
    else {
        // Show login
        $efd3ba4ec2608b1d$var$loginOverlay.classList.remove('hidden');
        document.body.classList.add('loaded'); // Ensure login shows
    }
    // Setup auth callbacks
    (0, $e7ff1b009dd6583c$export$6d3c879d7a79980d)((session)=>{
        if (!$efd3ba4ec2608b1d$var$isProcessingAuth) {
            $efd3ba4ec2608b1d$var$isProcessingAuth = true;
            $efd3ba4ec2608b1d$var$handleAuthenticatedState();
        }
    }, ()=>{
        window.location.reload();
    });
}
function $efd3ba4ec2608b1d$var$applyThemeInternal(themeKey) {
    const theme = $efd3ba4ec2608b1d$var$THEMES[themeKey];
    if (!theme) return;
    const root = document.documentElement;
    Object.entries(theme).forEach(([property, value])=>{
        root.style.setProperty(property, value);
    });
    localStorage.setItem('app_theme', themeKey);
}
async function $efd3ba4ec2608b1d$var$handleAuthenticatedState() {
    console.log('Authentication successful');
    // Hide overlays
    $efd3ba4ec2608b1d$var$loginOverlay.classList.add('hidden');
    // Check for App Password
    const isPassOk = sessionStorage.getItem('isAppAuthenticated') === 'true';
    if (!isPassOk && window.SITE_CONFIG?.appPasswordHash) {
        $efd3ba4ec2608b1d$var$passwordOverlay.classList.remove('hidden');
        $efd3ba4ec2608b1d$var$passwordOverlay.style.display = 'flex';
        document.body.classList.add('loaded'); // Ensure password screen shows
        await $efd3ba4ec2608b1d$var$promptForAppPassword();
    }
    $efd3ba4ec2608b1d$var$passwordOverlay.classList.add('hidden');
    $efd3ba4ec2608b1d$var$passwordOverlay.style.display = 'none';
    // Show app containers
    $efd3ba4ec2608b1d$var$appContainer.classList.remove('hidden');
    $efd3ba4ec2608b1d$var$mobileNav.classList.remove('hidden');
    if (localStorage.getItem('app_edit_mode') === 'true') document.body.classList.add('is-editing');
    // Ensure screen is visible
    document.body.classList.add('loaded');
    try {
        await (0, $1a6cd9663479e45c$export$1686aec5678ceb1c)();
        $efd3ba4ec2608b1d$var$renderAll();
    } catch (e) {
        console.error('Data load error:', e);
        renderErrorState(e);
    }
}
function $efd3ba4ec2608b1d$var$renderAll() {
    // 1. Sync Sidebar
    $efd3ba4ec2608b1d$var$sidebarPhoto.src = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.mainImage || 'https://placehold.co/100x100';
    $efd3ba4ec2608b1d$var$sidebarName.textContent = window.SITE_CONFIG?.SpouseName || 'My Love';
    if ($efd3ba4ec2608b1d$var$sidebarTag) $efd3ba4ec2608b1d$var$sidebarTag.textContent = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipTag || 'For You';
    $efd3ba4ec2608b1d$var$updateMetaTags();
    // 2. CRITICAL: Build navigation
    $efd3ba4ec2608b1d$var$buildNavigation();
    // 3. Container setup
    $efd3ba4ec2608b1d$var$mainContent.innerHTML = $efd3ba4ec2608b1d$var$navLinks.map((link)=>`<div id="${link.id}" class="content-section" role="tabpanel" aria-labelledby="nav-${link.id}"></div>`).join('');
    // 4. Route to initial page
    const initialPage = window.location.hash.substring(1) || 'home';
    $efd3ba4ec2608b1d$var$navigateTo(initialPage);
}
function $efd3ba4ec2608b1d$var$buildNavigation() {
    // FIXED: Add null checks
    if (!$efd3ba4ec2608b1d$var$desktopNavContainer || !$efd3ba4ec2608b1d$var$mobileNavContainer) {
        console.error('Navigation containers not found in DOM');
        return;
    }
    $efd3ba4ec2608b1d$var$desktopNavContainer.innerHTML = '';
    $efd3ba4ec2608b1d$var$mobileNavContainer.innerHTML = '';
    $efd3ba4ec2608b1d$var$navLinks.forEach((link)=>{
        // Desktop Link
        const a = document.createElement('a');
        a.href = `#${link.id}`;
        a.id = `nav-${link.id}`;
        a.className = 'nav-item block font-bold text-slate-600 rounded-lg p-3 transition-colors focus:outline-none focus:ring-2 focus:ring-primary';
        a.dataset.page = link.id;
        a.setAttribute('role', 'tab');
        a.innerHTML = `<i class="${link.icon} w-6 mr-2 text-center"></i> ${link.text}`;
        a.onclick = (e)=>{
            e.preventDefault();
            $efd3ba4ec2608b1d$var$navigateTo(link.id);
        };
        $efd3ba4ec2608b1d$var$desktopNavContainer.appendChild(a);
        // Mobile Link
        const ma = document.createElement('a');
        ma.href = `#${link.id}`;
        ma.className = 'mobile-nav-item flex flex-col items-center justify-center h-full focus:outline-none';
        ma.dataset.page = link.id;
        ma.innerHTML = `<i class="${link.icon}"></i><span>${link.text}</span>`;
        ma.onclick = (e)=>{
            e.preventDefault();
            $efd3ba4ec2608b1d$var$navigateTo(link.id);
        };
        $efd3ba4ec2608b1d$var$mobileNavContainer.appendChild(ma);
    });
    console.log('Navigation built successfully');
}
function $efd3ba4ec2608b1d$var$navigateTo(pageId) {
    if (!$efd3ba4ec2608b1d$var$navLinks.find((l)=>l.id === pageId)) return;
    if (window.location.hash.substring(1) !== pageId) {
        window.location.hash = pageId;
        return;
    }
    if ($efd3ba4ec2608b1d$var$countdownInterval) clearInterval($efd3ba4ec2608b1d$var$countdownInterval);
    if ($efd3ba4ec2608b1d$var$relationshipInterval) clearInterval($efd3ba4ec2608b1d$var$relationshipInterval);
    document.querySelectorAll('.content-section.active').forEach((s)=>s.classList.remove('active', 'fade-in'));
    const activeSection = document.getElementById(pageId);
    if (activeSection) {
        activeSection.innerHTML = (0, $4463b5b4a6e7ec34$export$5999ca150006b0ea)(pageId, $efd3ba4ec2608b1d$var$navLinks);
        if (pageId === 'journey') {
            const placeholder = activeSection.querySelector('#dynamic-content');
            const journeyContent = `<div id="calendar-container" class="mb-8">${(0, $4463b5b4a6e7ec34$export$c1a8fd48acd59fbd)($efd3ba4ec2608b1d$var$currentCalendarDate)}</div><div class="border-t pt-6"><h3 class="text-xl font-bold mb-4">\u{1F5D3}\u{FE0F} Our Timeline</h3><div id="timeline-list">${(0, $4463b5b4a6e7ec34$export$5ac06981e396d354)()}</div></div>`;
            if (placeholder) placeholder.outerHTML = journeyContent;
        }
        activeSection.classList.add('active');
        setTimeout(()=>activeSection.classList.add('fade-in'), 10);
    }
    if (pageId === 'bucketList') {
        $efd3ba4ec2608b1d$var$updateAllCountdowns();
        $efd3ba4ec2608b1d$var$countdownInterval = setInterval($efd3ba4ec2608b1d$var$updateAllCountdowns, 1000);
    } else if (pageId === 'home') {
        $efd3ba4ec2608b1d$var$updateRelationshipTimer();
        $efd3ba4ec2608b1d$var$relationshipInterval = setInterval($efd3ba4ec2608b1d$var$updateRelationshipTimer, 1000);
    } else if (pageId === 'memories') $efd3ba4ec2608b1d$var$addNoteEventListeners();
    else if (pageId === 'settings') $efd3ba4ec2608b1d$var$bindSettingsEvents();
    document.querySelectorAll('.nav-item').forEach((item)=>item.classList.toggle('active', item.dataset.page === pageId));
    document.querySelectorAll('.mobile-nav-item').forEach((item)=>item.classList.toggle('active', item.dataset.page === pageId));
    window.scrollTo(0, 0);
}
function $efd3ba4ec2608b1d$var$toggleEditMode(enable) {
    if (enable) {
        document.body.classList.add('is-editing');
        localStorage.setItem('app_edit_mode', 'true');
        $efd3ba4ec2608b1d$var$showCustomAlert('Edit Mode On', 'You can now add, edit, and delete items.', true);
    } else {
        document.body.classList.remove('is-editing');
        localStorage.setItem('app_edit_mode', 'false');
    }
    const currentPage = window.location.hash.substring(1) || 'home';
    $efd3ba4ec2608b1d$var$navigateTo(currentPage);
}
// --- Universal Save Handler (Local) ---
async function $efd3ba4ec2608b1d$var$saveEntry(pageId, index, context) {
    const btn = document.getElementById('modal-save-btn');
    const val = (id)=>document.getElementById(id)?.value.trim();
    const checked = (id)=>document.getElementById(id)?.checked;
    const isNew = index === -1;
    let error = null;
    if (pageId === 'home' && context === 'timer') error = (0, $9423fef94170f602$export$4d09d4ac8ba225dd)(val('date'), 'date', 'Relationship Date');
    else if (pageId === 'journey') error = (0, $9423fef94170f602$export$4d09d4ac8ba225dd)(val('date'), 'date', 'Date') || (0, $9423fef94170f602$export$4d09d4ac8ba225dd)(val('title'), 'required', 'Title');
    if (error) {
        $efd3ba4ec2608b1d$var$showCustomAlert('Validation Error', error);
        return;
    }
    btn.innerHTML = 'Saving...';
    btn.disabled = true;
    try {
        const fileInput = document.getElementById('image-file') || document.querySelector('input[type="file"]');
        let uploadedUrl = null;
        // --- HANDLE GALLERY UPLOAD (BLOB STORAGE) ---
        if (pageId === 'gallery') {
            if (isNew) {
                if (fileInput && fileInput.files.length > 0) await (0, $1a6cd9663479e45c$export$2094c78cd5451031)(fileInput.files[0], val('caption'));
            } else {
                // UPDATE EXISTING PHOTO
                const fileToUpdate = fileInput && fileInput.files.length > 0 ? fileInput.files[0] : null;
                await (0, $1a6cd9663479e45c$export$10635228250a8e49)(index, val('caption'), fileToUpdate);
            }
        } else {
            if (fileInput && fileInput.files.length > 0) uploadedUrl = await (0, $1a6cd9663479e45c$export$994fda0f79164d5a)(fileInput.files[0]);
            const getImgVal = (id)=>uploadedUrl || val(id);
            if (pageId === 'home') {
                if (context === 'timer') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipStart = val('date');
                else {
                    (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.mainImage = getImgVal('image');
                    (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.introMessage = val('intro');
                    (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipTag = val('tag');
                }
            } else if (pageId === 'journey') {
                const evt = {
                    date: val('date'),
                    title: val('title'),
                    description: val('desc'),
                    showYear: !checked('hideYear')
                };
                if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events.push(evt);
                else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events[index] = evt;
            } else if (pageId === 'video') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).videoMontage = {
                intro: val('intro'),
                fileId: val('url')
            };
            else if (pageId === 'surprise') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise = {
                ...(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise,
                title: val('title'),
                message: val('msg'),
                image: getImgVal('image')
            };
            else if (pageId === 'wheel') {
                (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.wheelItems = val('wheel-items').split(',').map((s)=>s.trim()).filter((s)=>s);
                pageId = 'surprise';
            } else if (pageId === 'bucketList') {
                if (context === 'intro') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.intro = val('intro');
                else {
                    const item = {
                        title: val('title'),
                        description: val('desc'),
                        targetDate: val('date'),
                        icon: val('icon')
                    };
                    if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.items.push(item);
                    else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.items[index] = item;
                }
            } else if (pageId === 'playlist') {
                if (context === 'intro') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.intro = val('intro');
                else {
                    const s = {
                        title: val('title'),
                        embedId: val('embed'),
                        note: val('note')
                    };
                    if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.songs.push(s);
                    else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.songs[index] = s;
                }
            } else if (pageId === 'promises') {
                if (context === 'intro') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.intro = val('intro');
                else if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.promises.push(val('promise'));
                else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.promises[index] = val('promise');
            } else if (pageId === 'loveLanguages') {
                const l = {
                    name: val('name'),
                    icon: val('icon'),
                    description: val('desc')
                };
                if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.languages.push(l);
                else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.languages[index] = l;
            } else if (pageId === 'loveReasons') {
                if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.reasons.push(val('reason'));
                else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.reasons[index] = val('reason');
            } else if (pageId === 'memoryBook') {
                const m = {
                    message: val('msg'),
                    author: val('auth')
                };
                if (isNew) (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).memoryBook.push(m);
                else (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).memoryBook[index] = m;
            } else if (pageId === 'allMyLove') {
                if (context === 'intro') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.intro = val('intro');
                else if (context === 'loveReasonsIntro') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.intro = val('intro');
                else if (context === 'loveLanguages') {
                    const l = {
                        name: val('name'),
                        icon: val('icon'),
                        description: val('desc')
                    };
                    (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.languages.push(l);
                } else if (context === 'loveReasons') (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.reasons.push(val('reason'));
            }
            await (0, $1a6cd9663479e45c$export$15d8621db9a88346)(false, $efd3ba4ec2608b1d$var$showCustomAlert);
        }
        $efd3ba4ec2608b1d$var$formModalBackdrop.classList.remove('active');
        const sectionMap = {
            'loveLanguages': 'allMyLove',
            'loveReasons': 'allMyLove',
            'loveReasonsIntro': 'allMyLove',
            'notes': 'memories'
        };
        $efd3ba4ec2608b1d$var$navigateTo(sectionMap[pageId] || pageId);
    } catch (e) {
        console.error(e);
        $efd3ba4ec2608b1d$var$showCustomAlert('Error', e.message || 'Failed to save.');
    } finally{
        btn.disabled = false;
    }
}
async function $efd3ba4ec2608b1d$var$deleteItem(type, index) {
    if (!confirm("Are you sure?")) return;
    try {
        if (type === 'photoGallery') {
            await (0, $1a6cd9663479e45c$export$24b331154e79a600)(index);
            $efd3ba4ec2608b1d$var$navigateTo('gallery');
        } else {
            let arr = null, page = 'home';
            if (type === 'events') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events;
                page = 'journey';
            }
            if (type === 'bucketList') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.items;
                page = 'bucketList';
            }
            if (type === 'notes') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).notes;
                page = 'memories';
            }
            if (type === 'playlist') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.songs;
                page = 'playlist';
            }
            if (type === 'promises') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.promises;
                page = 'promises';
            }
            if (type === 'loveLanguages') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.languages;
                page = 'allMyLove';
            }
            if (type === 'loveReasons') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.reasons;
                page = 'allMyLove';
            }
            if (type === 'memoryBook') {
                arr = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).memoryBook;
                page = 'memories';
            }
            if (arr) {
                arr.splice(index, 1);
                await (0, $1a6cd9663479e45c$export$15d8621db9a88346)(false, $efd3ba4ec2608b1d$var$showCustomAlert);
                $efd3ba4ec2608b1d$var$navigateTo(page);
            }
        }
    } catch (e) {
        $efd3ba4ec2608b1d$var$showCustomAlert("Error", "Could not delete item.");
    }
}
function $efd3ba4ec2608b1d$var$updateRelationshipTimer() {
    const start = new Date((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipStart || new Date());
    const now = new Date();
    const diff = now - start;
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor(diff / 3600000 % 24);
    const minutes = Math.floor(diff / 1000 / 60 % 60);
    const seconds = Math.floor(diff / 1000 % 60);
    const el = document.getElementById('relationship-timer');
    if (el) el.innerHTML = `
            <span class="heart-beat" aria-hidden="true"><i class="fas fa-heart"></i></span>
            <span>${days}d</span> : <span>${hours}h</span> : <span>${minutes}m</span> : <span>${seconds}s</span> 
            <span class="heart-beat" aria-hidden="true"><i class="fas fa-heart"></i></span>
        `;
}
function $efd3ba4ec2608b1d$var$updateMetaTags() {
    if ((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).SpouseName) document.title = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).SpouseName;
    const imageUrl = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.mainImage || 'https://placehold.co/100x100';
    const setLink = (rel, href)=>{
        let link = document.querySelector(`link[rel='${rel}']`);
        if (!link) {
            link = document.createElement('link');
            link.rel = rel;
            document.head.appendChild(link);
        }
        link.href = href;
    };
    setLink('icon', imageUrl);
    setLink('apple-touch-icon', imageUrl);
    setLink('shortcut icon', imageUrl);
    let metaTheme = document.querySelector("meta[name='theme-color']");
    if (!metaTheme) {
        metaTheme = document.createElement('meta');
        metaTheme.name = 'theme-color';
        document.head.appendChild(metaTheme);
    }
    metaTheme.content = '#FFEAE3';
}
function $efd3ba4ec2608b1d$var$spinWheel() {
    const result = document.getElementById('wheel-result');
    const btn = document.getElementById('spin-btn');
    const wheel = document.getElementById('the-wheel');
    const items = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.wheelItems;
    if (items.length === 0) {
        result.textContent = "Add items first!";
        return;
    }
    btn.disabled = true;
    // Accessibility check
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const randomItem = items[Math.floor(Math.random() * items.length)];
        result.textContent = `\u{2728} Let's do: ${randomItem}! \u{2728}`;
        btn.disabled = false;
        return;
    }
    wheel.style.transition = 'none';
    wheel.style.transform = `rotate(0deg)`;
    result.textContent = '';
    setTimeout(()=>{
        const extraSpins = 1800;
        const randomStop = Math.floor(Math.random() * 360);
        const totalDeg = extraSpins + randomStop;
        wheel.style.transition = 'transform 4s cubic-bezier(0.17, 0.67, 0.12, 0.99)';
        wheel.style.transform = `rotate(${totalDeg}deg)`;
        wheel.addEventListener('transitionend', ()=>{
            const degPerSlice = 360 / items.length;
            const normalizedDeg = totalDeg % 360;
            const winningIndex = Math.floor((360 - normalizedDeg) / degPerSlice) % items.length;
            result.textContent = `\u{2728} Let's do: ${items[winningIndex]}! \u{2728}`;
            btn.disabled = false;
        }, {
            once: true
        });
    }, 50);
}
// Modal Logic
function $efd3ba4ec2608b1d$var$getModalContent(pageId, index, context) {
    const isNew = index === -1;
    let title = '', fields = '';
    const input = (id, label, val)=>`<div class="mb-4"><label class="block text-sm font-bold mb-1 text-gray-700" for="${id}">${label}</label><input id="${id}" value="${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(val)}" class="form-input"></div>`;
    const textarea = (id, label, val)=>`<div class="mb-4"><label class="block text-sm font-bold mb-1 text-gray-700" for="${id}">${label}</label><textarea id="${id}" class="form-input h-24">${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(val)}</textarea></div>`;
    const dateInput = (id, label, val)=>`<div class="mb-4"><label class="block text-sm font-bold mb-1 text-gray-700" for="${id}">${label}</label><input type="date" id="${id}" value="${val}" class="form-input"></div>`;
    const imageInput = (id, label, currentUrl)=>`
        <div class="mb-4"><label class="block text-sm font-bold mb-1 text-gray-700" for="${id}-file">${label}</label>
        <div class="flex gap-2 items-center"><input type="file" id="${id}-file" accept="image/*" class="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-soft file:text-primary hover:file:bg-gray-100"/></div>
        <input type="hidden" id="${id}" value="${(0, $9423fef94170f602$export$83d2e9e3e4ee39ed)(currentUrl)}">${currentUrl ? `<p class="text-xs text-green-600 mt-1">Current image loaded.</p>` : ''}</div>`;
    if (pageId === 'home') {
        if (context === 'timer') {
            title = 'Relationship Start Date';
            fields = dateInput('date', 'When did it start?', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipStart ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipStart.slice(0, 10) : '');
        } else {
            title = 'Edit Home';
            fields = imageInput('image', 'Main Photo', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.mainImage) + input('tag', 'Relationship Tag', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.relationshipTag || 'For You') + textarea('intro', 'Intro Message', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).homepage.introMessage);
        }
    } else if (pageId === 'journey') {
        const evt = !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).events[index] : {};
        title = isNew ? 'Add Event' : 'Edit Event';
        fields = dateInput('date', 'Date', evt.date || '') + input('title', 'Title', evt.title || '') + textarea('desc', 'Description', evt.description || '') + `<div class="flex items-center mt-2"><input id="hideYear" type="checkbox" class="h-4 w-4 rounded" ${evt.showYear === false ? 'checked' : ''}><label for="hideYear" class="ml-2 text-sm">Recurring Anniversary (Hide Year)</label></div>`;
    } else if (pageId === 'gallery') {
        const photo = !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery[index] : {};
        title = isNew ? 'Add Photo' : 'Edit Photo';
        fields = imageInput('image', 'Upload Photo', photo.image || '') + textarea('caption', 'Caption', photo.caption || '');
    } else if (pageId === 'video') {
        title = 'Edit Video';
        fields = textarea('intro', 'Intro', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).videoMontage.intro) + input('url', 'YouTube Video/Playlist URL', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).videoMontage.fileId || '');
    } else if (pageId === 'surprise') {
        title = 'Edit Surprise';
        fields = input('title', 'Title', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.title) + textarea('msg', 'Message', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.message) + imageInput('image', 'Surprise Image', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.image);
    } else if (pageId === 'bucketList') {
        if (context === 'intro') {
            title = 'Edit Intro';
            fields = textarea('intro', 'Intro', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.intro);
        } else {
            const item = !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).bucketList.items[index] : {};
            title = isNew ? 'New Adventure' : 'Edit Adventure';
            fields = input('title', 'Title', item.title || '') + input('icon', 'Icon Class', item.icon || 'fas fa-star') + textarea('desc', 'Description', item.description || '') + dateInput('date', 'Target Date', item.targetDate || '');
        }
    } else if (pageId === 'wheel') {
        title = 'Edit Wheel';
        fields = `<div class="mb-4"><label class="block text-sm font-bold mb-1 text-gray-700" for="wheel-items">Items (Comma separated)</label><textarea id="wheel-items" class="form-input h-24">${((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).surprise.wheelItems || []).join(', ')}</textarea></div>`;
    } else if (pageId === 'playlist') {
        if (context === 'intro') {
            title = 'Edit Intro';
            fields = textarea('intro', 'Intro', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.intro);
        } else {
            const song = !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).playlist.songs[index] : {};
            title = 'Edit Song';
            fields = input('title', 'Title', song.title || '') + input('embed', 'YouTube URL', song.embedId || '') + textarea('note', 'Note', song.note || '');
        }
    } else if (pageId === 'promises') {
        if (context === 'intro') {
            title = 'Edit Intro';
            fields = textarea('intro', 'Intro', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.intro);
        } else {
            title = 'Promise';
            fields = textarea('promise', 'Promise', !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).promises.promises[index] : '');
        }
    } else if (pageId === 'allMyLove') {
        if (context === 'intro') {
            title = 'Edit Intro';
            fields = textarea('intro', 'Intro', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.intro);
        } else if (context === 'loveReasonsIntro') {
            title = 'Edit Reasons Intro';
            fields = textarea('intro', 'Intro', (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.intro);
        } else if (context === 'loveLanguages') {
            title = 'Add Love Language';
            fields = input('name', 'Name', '') + input('icon', 'Icon', 'fas fa-heart') + textarea('desc', 'Description', '');
        } else if (context === 'loveReasons') {
            title = 'Add Reason';
            fields = textarea('reason', 'Reason', '');
        }
    } else if (pageId === 'loveLanguages') {
        const l = !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveLanguages.languages[index] : {};
        title = 'Love Language';
        fields = input('name', 'Name', l.name || '') + input('icon', 'Icon', l.icon || 'fas fa-heart') + textarea('desc', 'Description', l.description || '');
    } else if (pageId === 'loveReasons') {
        title = 'Reason';
        fields = textarea('reason', 'Reason', !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).loveReasons.reasons[index] : '');
    } else if (pageId === 'memoryBook') {
        const m = !isNew ? (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).memoryBook[index] : {};
        title = 'Memory';
        fields = textarea('msg', 'Message', m.message || '') + input('auth', 'Author', m.author || '');
    }
    return {
        title: title,
        fields: fields
    };
}
function $efd3ba4ec2608b1d$var$openModal(pageId, index = -1, context = 'default') {
    const { title: title, fields: fields } = $efd3ba4ec2608b1d$var$getModalContent(pageId, index, context);
    if (!fields) return;
    $efd3ba4ec2608b1d$var$formModalBackdrop.innerHTML = `<div class="modal-content" role="dialog" aria-modal="true" aria-labelledby="modal-title"><div class="modal-content-header p-4 flex justify-between items-center"><h3 id="modal-title" class="font-bold text-xl">${title}</h3><button onclick="document.getElementById('form-modal-backdrop').classList.remove('active')" class="text-2xl" aria-label="Close Modal">&times;</button></div><div class="modal-content-body p-4">${fields}</div><div class="modal-content-footer p-4 flex justify-end gap-2"><button onclick="document.getElementById('form-modal-backdrop').classList.remove('active')" class="btn btn-secondary">Cancel</button><button id="modal-save-btn" onclick="window.app.saveEntry('${pageId}', ${index}, '${context}')" class="btn btn-primary">Save</button></div></div>`;
    $efd3ba4ec2608b1d$var$formModalBackdrop.classList.add('active');
    const firstInput = $efd3ba4ec2608b1d$var$formModalBackdrop.querySelector('input, textarea, button');
    if (firstInput) firstInput.focus();
}
function $efd3ba4ec2608b1d$var$showCustomAlert(title, msg, autoClose = false) {
    const modal = document.getElementById('alert-modal-backdrop');
    modal.innerHTML = `<div class="alert-modal-content text-center" role="alertdialog" aria-labelledby="alert-title" aria-describedby="alert-desc"><h3 id="alert-title" class="text-xl font-bold mb-2">${title}</h3><p id="alert-desc" class="text-gray-600 mb-4">${msg}</p><button onclick="document.getElementById('alert-modal-backdrop').classList.remove('active')" class="btn btn-primary">OK</button></div>`;
    modal.classList.add('active');
    if (autoClose) setTimeout(()=>modal.classList.remove('active'), 2000);
}
function $efd3ba4ec2608b1d$var$promptForAppPassword() {
    return new Promise((resolve)=>{
        const input = document.getElementById('password-input');
        const form = document.getElementById('password-form');
        const error = document.getElementById('password-error');
        const tryLogin = async ()=>{
            const enteredHash = await (0, $9423fef94170f602$export$8c91308a4df762e1)(input.value);
            if (enteredHash === window.SITE_CONFIG.appPasswordHash) {
                sessionStorage.setItem('isAppAuthenticated', 'true');
                error.classList.add('hidden');
                resolve();
            } else {
                error.classList.remove('hidden');
                input.value = '';
                input.focus();
            }
        };
        // Use the form submit handler
        form.onsubmit = (e)=>{
            e.preventDefault();
            tryLogin();
        };
    });
}
function $efd3ba4ec2608b1d$var$updateAllCountdowns() {
    document.querySelectorAll('.countdown-container').forEach((el)=>{
        const target = new Date(el.dataset.countdownTarget).getTime();
        const now = new Date().getTime();
        const dist = target - now;
        if (dist < 0) {
            el.innerHTML = "It's here!";
            return;
        }
        el.querySelector('.days').innerText = Math.floor(dist / 86400000);
        el.querySelector('.hours').innerText = Math.floor(dist % 86400000 / 3600000);
        el.querySelector('.minutes').innerText = Math.floor(dist % 3600000 / 60000);
        el.querySelector('.seconds').innerText = Math.floor(dist % 60000 / 1000);
    });
}
function $efd3ba4ec2608b1d$var$addNoteEventListeners() {
    document.getElementById('add-note-btn')?.addEventListener('click', async ()=>{
        const txt = document.getElementById('new-note-input').value;
        if (txt) {
            (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).notes.push({
                text: txt,
                done: false
            });
            await (0, $1a6cd9663479e45c$export$15d8621db9a88346)(true);
            $efd3ba4ec2608b1d$var$navigateTo('memories');
        }
    });
}
function $efd3ba4ec2608b1d$var$bindSettingsEvents() {
    document.getElementById('clear-data-button')?.addEventListener('click', async ()=>{
        if (confirm("\u26A0\uFE0F WARNING: This will permanently delete ALL your data, photos, and settings. This cannot be undone!\n\nAre you absolutely sure?")) {
            const btn = document.getElementById('clear-data-button');
            btn.disabled = true;
            btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Deleting...';
            const result = await (0, $1a6cd9663479e45c$export$425019a80ecc179b)();
            if (result.success) {
                $efd3ba4ec2608b1d$var$showCustomAlert("Data Reset", "All data has been cleared. Reloading...", true);
                setTimeout(()=>location.reload(), 2000);
            } else {
                $efd3ba4ec2608b1d$var$showCustomAlert("Error", "Failed to reset data: " + result.error);
                btn.disabled = false;
                btn.innerHTML = '<i class="fas fa-trash mr-2"></i>Reset All Data';
            }
        }
    });
    document.getElementById('edit-mode-toggle')?.addEventListener('change', (e)=>{
        $efd3ba4ec2608b1d$var$toggleEditMode(e.target.checked);
    });
}
// Global Exports
window.app = {
    logout: $e7ff1b009dd6583c$export$a0973bcfe11b05c9,
    applyTheme: (key)=>{
        $efd3ba4ec2608b1d$var$applyThemeInternal(key);
        if (window.location.hash === '#settings') {
            const activeSection = document.getElementById('settings');
            if (activeSection) {
                activeSection.innerHTML = (0, $4463b5b4a6e7ec34$export$5999ca150006b0ea)('settings', $efd3ba4ec2608b1d$var$navLinks);
                $efd3ba4ec2608b1d$var$bindSettingsEvents();
            }
        }
    },
    navigateMonth: (dir)=>{
        $efd3ba4ec2608b1d$var$currentCalendarDate.setMonth($efd3ba4ec2608b1d$var$currentCalendarDate.getMonth() + dir);
        const el = document.getElementById('calendar-container');
        if (el) el.innerHTML = (0, $4463b5b4a6e7ec34$export$c1a8fd48acd59fbd)($efd3ba4ec2608b1d$var$currentCalendarDate);
    },
    jumpToDate: ()=>{
        const m = document.getElementById('cal-month').value;
        const y = document.getElementById('cal-year').value;
        $efd3ba4ec2608b1d$var$currentCalendarDate = new Date(y, m, 1);
        document.getElementById('calendar-container').innerHTML = (0, $4463b5b4a6e7ec34$export$c1a8fd48acd59fbd)($efd3ba4ec2608b1d$var$currentCalendarDate);
    },
    openModal: $efd3ba4ec2608b1d$var$openModal,
    saveEntry: $efd3ba4ec2608b1d$var$saveEntry,
    deleteItem: $efd3ba4ec2608b1d$var$deleteItem,
    spinWheel: $efd3ba4ec2608b1d$var$spinWheel,
    retryLoad: ()=>{
        window.location.reload();
    },
    toggleNote: async (index)=>{
        (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).notes[index].done = !(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).notes[index].done;
        await (0, $1a6cd9663479e45c$export$15d8621db9a88346)(true);
        $efd3ba4ec2608b1d$var$navigateTo('memories');
    },
    // Lightbox Logic
    openImageModal: (i)=>{
        $efd3ba4ec2608b1d$var$galleryIndex = i;
        const p = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery[i];
        document.getElementById('modal-image').src = p.image;
        document.getElementById('modal-caption').textContent = p.caption;
        document.getElementById('image-modal-backdrop').classList.add('active');
    },
    closeImageModal: ()=>{
        clearInterval($efd3ba4ec2608b1d$var$slideshowInterval);
        $efd3ba4ec2608b1d$var$slideshowInterval = null;
        document.getElementById('image-modal-backdrop').classList.remove('active');
    },
    navGallery: (dir)=>{
        $efd3ba4ec2608b1d$var$galleryIndex += dir;
        if ($efd3ba4ec2608b1d$var$galleryIndex < 0) $efd3ba4ec2608b1d$var$galleryIndex = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery.length - 1;
        if ($efd3ba4ec2608b1d$var$galleryIndex >= (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery.length) $efd3ba4ec2608b1d$var$galleryIndex = 0;
        const p = (0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery[$efd3ba4ec2608b1d$var$galleryIndex];
        document.getElementById('modal-image').src = p.image;
        document.getElementById('modal-caption').textContent = p.caption;
    },
    startSlideshowFromPage: ()=>{
        if ((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296).photoGallery.length === 0) return;
        window.app.openImageModal(0);
        $efd3ba4ec2608b1d$var$slideshowInterval = setInterval(()=>window.app.navGallery(1), 3000);
    },
    emergencyReset: async ()=>{
        if (confirm("This will wipe all local data to fix the corruption. Continue?")) {
            const req = indexedDB.deleteDatabase('InaiyaLocalDB');
            req.onsuccess = ()=>window.location.reload();
            req.onerror = ()=>alert("Could not delete DB. Clear browser cache manually.");
        }
    },
    // Export Data Function
    exportData: async ()=>{
        try {
            const btn = document.getElementById('export-data-button');
            if (btn) {
                btn.disabled = true;
                btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Exporting...';
            }
            const exportData = {
                version: '1.0',
                exportDate: new Date().toISOString(),
                appName: 'LoveWebsite',
                siteData: JSON.parse(JSON.stringify((0, $1a6cd9663479e45c$export$7a7e7f0c34e94296)))
            };
            const dataStr = JSON.stringify(exportData, null, 2);
            const dataBlob = new Blob([
                dataStr
            ], {
                type: 'application/json'
            });
            const url = URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `love-website-backup-${new Date().toISOString().slice(0, 10)}.json`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            $efd3ba4ec2608b1d$var$showCustomAlert('Export Successful', 'Your data has been exported successfully!', true);
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = '<i class="fas fa-download mr-2"></i>Export Data';
            }
        } catch (error) {
            console.error('Export error:', error);
            $efd3ba4ec2608b1d$var$showCustomAlert('Export Failed', 'Failed to export data: ' + error.message);
            const btn = document.getElementById('export-data-button');
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = '<i class="fas fa-download mr-2"></i>Export Data';
            }
        }
    },
    // Import Data Function
    importData: async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        try {
            const btn = document.getElementById('import-data-button');
            if (btn) {
                btn.disabled = true;
                btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Importing...';
            }
            const reader = new FileReader();
            reader.onload = async (e)=>{
                try {
                    const importedData = JSON.parse(e.target.result);
                    if (!importedData.siteData) throw new Error('Invalid file format');
                    if (!confirm("\u26A0\uFE0F WARNING: Importing will replace all current data. Are you sure?")) {
                        if (btn) {
                            btn.disabled = false;
                            btn.innerHTML = '<i class="fas fa-upload mr-2"></i>Import Data';
                        }
                        return;
                    }
                    // Update State
                    (0, $1a6cd9663479e45c$export$7397bbb6aee3d43)(deepMerge({
                        ...(0, $1a6cd9663479e45c$export$7a7e7f0c34e94296)
                    }, importedData.siteData));
                    await (0, $1a6cd9663479e45c$export$15d8621db9a88346)(false, $efd3ba4ec2608b1d$var$showCustomAlert);
                    $efd3ba4ec2608b1d$var$showCustomAlert('Import Successful', 'Data imported successfully!', true);
                    $efd3ba4ec2608b1d$var$renderAll();
                    const currentPage = window.location.hash.substring(1) || 'home';
                    $efd3ba4ec2608b1d$var$navigateTo(currentPage);
                } catch (error) {
                    console.error('Import parse error:', error);
                    $efd3ba4ec2608b1d$var$showCustomAlert('Import Failed', error.message);
                    if (btn) {
                        btn.disabled = false;
                        btn.innerHTML = '<i class="fas fa-upload mr-2"></i>Import Data';
                    }
                }
            };
            reader.readAsText(file);
        } catch (error) {
            console.error('Import error:', error);
            $efd3ba4ec2608b1d$var$showCustomAlert('Import Failed', error.message);
            const btn = document.getElementById('import-data-button');
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = '<i class="fas fa-upload mr-2"></i>Import Data';
            }
        }
        event.target.value = '';
    }
};
// Start the engine
$efd3ba4ec2608b1d$var$init();
var $aac2e2be59c07ac3$exports = {};
$aac2e2be59c07ac3$exports = import.meta.resolve("2AiUB");


// --- SERVICE WORKER REGISTRATION (Moved from index.html) ---
// Placing it here ensures 'import.meta' is available because main.js is loaded as a module.
if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register($aac2e2be59c07ac3$exports).then((reg)=>console.log('Service Worker Registered')).catch((err)=>console.log('SW Registration Failed: ', err));
});


//# sourceMappingURL=repo.0b5bd7e7.js.map
